import { GraphQLClient } from 'graphql-request';
// RequestInit is a global DOM type (graphql-request v6 fix)
import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: Date;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: Date;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  Json: any;
};

export type ActivateSoundCloudResult = {
  __typename?: 'ActivateSoundCloudResult';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ActiveFestival = {
  __typename?: 'ActiveFestival';
  communityCode: Scalars['String'];
  communityId: Scalars['ID'];
  communityName: Scalars['String'];
  dayEndHour: Scalars['Int'];
  dayStartHour: Scalars['Int'];
  days: Array<FestivalDay>;
  festivalEnd: Scalars['DateTime'];
  festivalStart: Scalars['DateTime'];
  savedItemCount: Scalars['Int'];
  tabLabel?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
};

export type ActiveProductsReturn = {
  __typename?: 'ActiveProductsReturn';
  active: Scalars['Int'];
};

export type ActivityEvent = {
  __typename?: 'ActivityEvent';
  communityId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  eventId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location: Scalars['String'];
  platform: Scalars['String'];
  properties: Scalars['Json'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type AdminChat = {
  __typename?: 'AdminChat';
  id?: Maybe<Scalars['String']>;
  lastMessage?: Maybe<TalksMessage>;
  title?: Maybe<Scalars['String']>;
};

export type AdminCommunityUpdateInput = {
  availableModules?: InputMaybe<ModuleListUpdateInput>;
  description?: InputMaybe<Scalars['String']>;
  joinRequirements?: InputMaybe<Scalars['Json']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  styleOverride?: InputMaybe<Scalars['Json']>;
  timezone?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type AdminCommunityWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type AdminCommunityWhereUniqueInput2 = {
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type AdminListEventAttendee = {
  __typename?: 'AdminListEventAttendee';
  communityId: Scalars['String'];
  memberships: Array<AttendeeMembership>;
  notes: Scalars['Json'];
  notesCount: Scalars['Int'];
  purchases: Array<Purchase>;
  user: User;
};

export enum AdminRolesType {
  CheckIn = 'CheckIn',
  Super = 'Super'
}

export enum AgentActionStatus {
  Denied = 'Denied',
  Executing = 'Executing',
  Expired = 'Expired',
  Failed = 'Failed',
  Pending = 'Pending',
  Succeeded = 'Succeeded',
  Superseded = 'Superseded'
}

export enum AgentActionType {
  CancelPushNotification = 'CancelPushNotification',
  CreateEvent = 'CreateEvent',
  CreateEventDraft = 'CreateEventDraft',
  CreateNewsItem = 'CreateNewsItem',
  CreateProduct = 'CreateProduct',
  CreatePromocode = 'CreatePromocode',
  CreatePushNotification = 'CreatePushNotification',
  CreateSegment = 'CreateSegment',
  CreateSmartLink = 'CreateSmartLink',
  DeleteProduct = 'DeleteProduct',
  DeletePromocode = 'DeletePromocode',
  DeletePushNotification = 'DeletePushNotification',
  DeleteSmartLink = 'DeleteSmartLink',
  DraftEmailCampaign = 'DraftEmailCampaign',
  DuplicateEvent = 'DuplicateEvent',
  DuplicateProduct = 'DuplicateProduct',
  DuplicatePromocode = 'DuplicatePromocode',
  DuplicatePushNotification = 'DuplicatePushNotification',
  DuplicateSmartLink = 'DuplicateSmartLink',
  EmailGuestListInvites = 'EmailGuestListInvites',
  ManageGuestList = 'ManageGuestList',
  ManageSegmentMembers = 'ManageSegmentMembers',
  PublishNewsItem = 'PublishNewsItem',
  SetEventStatus = 'SetEventStatus',
  SetProductStatus = 'SetProductStatus',
  SetPromocodeStatus = 'SetPromocodeStatus',
  SetSmartLinkStatus = 'SetSmartLinkStatus',
  SubmitPushNotification = 'SubmitPushNotification',
  UnpublishNewsItem = 'UnpublishNewsItem',
  UpdateEvent = 'UpdateEvent',
  UpdateNewsItem = 'UpdateNewsItem',
  UpdateProduct = 'UpdateProduct',
  UpdatePromocode = 'UpdatePromocode',
  UpdatePushNotification = 'UpdatePushNotification',
  UpdateSegment = 'UpdateSegment',
  UpdateSmartLink = 'UpdateSmartLink'
}

export enum AgentArtifactType {
  EmailCampaign = 'EmailCampaign',
  Event = 'Event',
  News = 'News',
  Product = 'Product',
  Promocode = 'Promocode',
  PushNotification = 'PushNotification',
  Segment = 'Segment',
  SmartLink = 'SmartLink'
}

export type AgentAttachment = {
  __typename?: 'AgentAttachment';
  byteSize: Scalars['Int'];
  checksum: Scalars['String'];
  filename: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  mimeType: Scalars['String'];
  status: AgentAttachmentStatus;
  width?: Maybe<Scalars['Int']>;
};

export type AgentAttachmentAccess = {
  __typename?: 'AgentAttachmentAccess';
  attachment: AgentAttachment;
  expiresAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type AgentAttachmentConfig = {
  __typename?: 'AgentAttachmentConfig';
  images: AgentImageAttachmentConfig;
  maxFiles: Scalars['Int'];
  maxTotalBytes: Scalars['Int'];
  uploadConcurrency: Scalars['Int'];
  videos: AgentVideoAttachmentConfig;
};

export enum AgentAttachmentStatus {
  Deleted = 'Deleted',
  Deleting = 'Deleting',
  Finalizing = 'Finalizing',
  Ready = 'Ready',
  Staging = 'Staging'
}

export type AgentAttachmentUpload = {
  __typename?: 'AgentAttachmentUpload';
  attachment: AgentAttachment;
  uploadHeaders: Scalars['Json'];
  uploadUrl: Scalars['String'];
};

export type AgentConfig = {
  __typename?: 'AgentConfig';
  attachments: AgentAttachmentConfig;
};

export type AgentImageAttachmentConfig = {
  __typename?: 'AgentImageAttachmentConfig';
  maxSourceBytes: Scalars['Int'];
  maxUploadBytes: Scalars['Int'];
  maxUploadPixels: Scalars['Int'];
  preparation: AgentImagePreparationConfig;
  sourceMimeTypes: Array<Scalars['String']>;
  uploadMimeTypes: Array<Scalars['String']>;
};

export type AgentImagePreparationConfig = {
  __typename?: 'AgentImagePreparationConfig';
  fallbackMimeType: Scalars['String'];
  heicQuality: Scalars['Float'];
  maxDimension: Scalars['Int'];
  maxHeicMetadataBytes: Scalars['Int'];
  maxHeicPixels: Scalars['Int'];
  preferredMimeType: Scalars['String'];
  qualitySteps: Array<Scalars['Float']>;
  scaleSteps: Array<Scalars['Float']>;
};

export type AgentMessage = {
  __typename?: 'AgentMessage';
  authorId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  demo: Scalars['Boolean'];
  id: Scalars['String'];
  metadata: Scalars['Json'];
  parts: Scalars['Json'];
  renderConfig: Scalars['Json'];
  role: AgentMessageRole;
  runId?: Maybe<Scalars['String']>;
  status: AgentMessageStatus;
  text?: Maybe<Scalars['String']>;
  uiMessageId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export enum AgentMessageRole {
  Assistant = 'Assistant',
  System = 'System',
  User = 'User'
}

export enum AgentMessageStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Pending = 'Pending'
}

export type AgentModel = {
  __typename?: 'AgentModel';
  id: Scalars['String'];
  label: Scalars['String'];
  relativeCost: Scalars['Int'];
};

export type AgentRole = {
  __typename?: 'AgentRole';
  avatarColor: Scalars['String'];
  changes: Array<Scalars['String']>;
  description: Scalars['String'];
  looksUp: Array<Scalars['String']>;
  starterPrompts: Array<AgentStarterPrompt>;
  title: Scalars['String'];
};

export type AgentRun = {
  __typename?: 'AgentRun';
  actorId: Scalars['String'];
  attempt: Scalars['Int'];
  commandId: Scalars['String'];
  communityId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  dispatchedAt?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['String']>;
  errorSummary?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  heartbeatAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  parentRunId?: Maybe<Scalars['String']>;
  promptVersion?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status: AgentRunStatus;
  threadId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  usage: Scalars['Json'];
};

export enum AgentRunStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Failed = 'Failed',
  Interrupted = 'Interrupted',
  Proposed = 'Proposed',
  Queued = 'Queued',
  Running = 'Running'
}

export type AgentStarterPrompt = {
  __typename?: 'AgentStarterPrompt';
  description: Scalars['String'];
  icon: AgentStarterPromptIcon;
  label: Scalars['String'];
  prompt: Scalars['String'];
};

export enum AgentStarterPromptIcon {
  Analytics = 'analytics',
  Calendar = 'calendar',
  Members = 'members',
  News = 'news',
  Promocodes = 'promocodes',
  Push = 'push',
  Tickets = 'tickets'
}

export type AgentThread = {
  __typename?: 'AgentThread';
  activeRun?: Maybe<AgentRun>;
  activityStatus: AgentThreadActivityStatus;
  agentKey?: Maybe<Scalars['String']>;
  canRestartDemo: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  lastMessage?: Maybe<AgentMessage>;
  lastSeq: Scalars['Int'];
  messages: Array<AgentMessage>;
  model?: Maybe<AgentModel>;
  modelChoices: Array<AgentModel>;
  role?: Maybe<AgentRole>;
  scenarioKey?: Maybe<Scalars['String']>;
  seen: Scalars['Boolean'];
  status: AgentThreadStatus;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export enum AgentThreadActivityStatus {
  Failed = 'Failed',
  Idle = 'Idle',
  RunningAction = 'RunningAction',
  Typing = 'Typing'
}

export type AgentThreadEvent = {
  __typename?: 'AgentThreadEvent';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  payload: Scalars['Json'];
  runId?: Maybe<Scalars['String']>;
  seq: Scalars['Int'];
  type: Scalars['String'];
};

export type AgentThreadEventsPage = {
  __typename?: 'AgentThreadEventsPage';
  events: Array<AgentThreadEvent>;
  hasMore: Scalars['Boolean'];
};

export enum AgentThreadStatus {
  Active = 'Active',
  Archived = 'Archived',
  Deleted = 'Deleted'
}

export type AgentVideoAttachmentConfig = {
  __typename?: 'AgentVideoAttachmentConfig';
  maxUploadBytes: Scalars['Int'];
  mimeTypes: Array<Scalars['String']>;
};

export type AllCalendarEventsResponse = {
  __typename?: 'AllCalendarEventsResponse';
  invitedEvents: Array<DisplayEvent>;
  popularNext30Days: Array<DisplayEvent>;
  popularThisWeek: Array<DisplayEvent>;
  upcomingEvents: UpcomingEventsResponse;
  werzyPicks: Array<DisplayEvent>;
};

export type AmbassadorCampaign = {
  __typename?: 'AmbassadorCampaign';
  claims: Array<AmbassadorCampaignClaim>;
  claimsCount: Scalars['Int'];
  codes: Array<Scalars['String']>;
  community: Community;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  internalName: Scalars['String'];
  maxSpots?: Maybe<Scalars['Int']>;
  rewardType: AmbassadorRewardType;
  segments: Array<Segment>;
  status: AmbassadorCampaignStatus;
  updatedAt: Scalars['DateTime'];
};

export type AmbassadorCampaignClaim = {
  __typename?: 'AmbassadorCampaignClaim';
  claimedAt: Scalars['DateTime'];
  code: Scalars['String'];
  id: Scalars['String'];
  user: User;
};

export enum AmbassadorCampaignStatus {
  Active = 'Active',
  Deleted = 'Deleted',
  Expired = 'Expired'
}

export enum AmbassadorRewardType {
  FreeTicket = 'FreeTicket',
  SegmentAssignment = 'SegmentAssignment'
}

export type AnnouncementsReturn = {
  __typename?: 'AnnouncementsReturn';
  items: Array<FeedItem>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type ApiStatusResponse = {
  __typename?: 'ApiStatusResponse';
  status: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AttendeeMembership = {
  __typename?: 'AttendeeMembership';
  checkInCount: Scalars['Int'];
  displayName?: Maybe<Scalars['String']>;
  lastCheckedIn?: Maybe<Scalars['DateTime']>;
  mediaUrl?: Maybe<Scalars['String']>;
  segmentId: Scalars['String'];
  segmentName: Scalars['String'];
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  communities?: Maybe<Array<Maybe<Community>>>;
  errors?: Maybe<Array<Maybe<TranslatableError>>>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type AuthV2Response = {
  __typename?: 'AuthV2Response';
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  verificationCodeSent?: Maybe<Scalars['Boolean']>;
};

export type AutomatedTestingCommunityManifest = {
  __typename?: 'AutomatedTestingCommunityManifest';
  code: Scalars['String'];
  fixturePrefix: Scalars['String'];
  id: Scalars['ID'];
  memberCount: Scalars['Int'];
  notificationsEnabledCount: Scalars['Int'];
};

export type AutomatedTestingEventsManifest = {
  __typename?: 'AutomatedTestingEventsManifest';
  attachableProducts: Array<AutomatedTestingFixture>;
  canceled: AutomatedTestingFixture;
  completeDraft: AutomatedTestingFixture;
  crossEventProduct: AutomatedTestingFixture;
  externalTickets: AutomatedTestingFixture;
  freeGuestList: AutomatedTestingFixture;
  incompleteDraft: AutomatedTestingFixture;
  legacyLongName: AutomatedTestingFixture;
  legacyMixed: AutomatedTestingFixture;
  legacyValues: AutomatedTestingFixture;
  live: AutomatedTestingFixture;
  past: AutomatedTestingFixture;
  pendingReview: AutomatedTestingFixture;
  rejected: AutomatedTestingFixture;
  revealedLocation: AutomatedTestingFixture;
  secretLocation: AutomatedTestingFixture;
  tbdLocation: AutomatedTestingFixture;
  ticketed: AutomatedTestingTicketedEventFixture;
  undated: AutomatedTestingFixture;
  upcoming: AutomatedTestingFixture;
  withCapacity: AutomatedTestingFixture;
  withHistory: AutomatedTestingFixture;
};

export type AutomatedTestingFixture = {
  __typename?: 'AutomatedTestingFixture';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AutomatedTestingMemberFixture = {
  __typename?: 'AutomatedTestingMemberFixture';
  id: Scalars['ID'];
  karma: Scalars['Int'];
  name: Scalars['String'];
};

export type AutomatedTestingMembersManifest = {
  __typename?: 'AutomatedTestingMembersManifest';
  emptySegment: AutomatedTestingFixture;
  profile: AutomatedTestingMemberFixture;
  profileSegment: AutomatedTestingFixture;
  restrictedChatChannel: AutomatedTestingFixture;
};

export type AutomatedTestingNewsManifest = {
  __typename?: 'AutomatedTestingNewsManifest';
  completeDraft: AutomatedTestingFixture;
  imageOnly: AutomatedTestingFixture;
  incompleteDraft: AutomatedTestingFixture;
  mixedMedia: AutomatedTestingFixture;
  published: AutomatedTestingFixture;
  videoOnly: AutomatedTestingFixture;
  withCta: AutomatedTestingFixture;
};

export type AutomatedTestingProductsManifest = {
  __typename?: 'AutomatedTestingProductsManifest';
  completeDraft: AutomatedTestingFixture;
  free: AutomatedTestingFixture;
  incompleteDraft: AutomatedTestingFixture;
  merch: AutomatedTestingFixture;
  past: AutomatedTestingFixture;
  priceless: AutomatedTestingFixture;
  published: AutomatedTestingFixture;
  scheduled: AutomatedTestingFixture;
  soldOut: AutomatedTestingFixture;
  unlimitedStock: AutomatedTestingFixture;
};

export type AutomatedTestingPromocodeFixture = {
  __typename?: 'AutomatedTestingPromocodeFixture';
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AutomatedTestingPromocodesManifest = {
  __typename?: 'AutomatedTestingPromocodesManifest';
  active: AutomatedTestingPromocodeFixture;
  completeDraft: AutomatedTestingPromocodeFixture;
  expired: AutomatedTestingPromocodeFixture;
  fixed: AutomatedTestingPromocodeFixture;
  limited: AutomatedTestingPromocodeFixture;
  noCodeDraft: AutomatedTestingPromocodeFixture;
  oneSided: AutomatedTestingPromocodeFixture;
  percentage: AutomatedTestingPromocodeFixture;
  replacement: AutomatedTestingPromocodeFixture;
  scheduled: AutomatedTestingPromocodeFixture;
};

export type AutomatedTestingPushNotificationsManifest = {
  __typename?: 'AutomatedTestingPushNotificationsManifest';
  completeDraft: AutomatedTestingFixture;
  incompleteDraft: AutomatedTestingFixture;
  rejected: AutomatedTestingFixture;
  sent: AutomatedTestingFixture;
  waitingForApproval: AutomatedTestingFixture;
};

export type AutomatedTestingTicketedEventFixture = {
  __typename?: 'AutomatedTestingTicketedEventFixture';
  id: Scalars['ID'];
  name: Scalars['String'];
  products: Array<AutomatedTestingFixture>;
};

export type AvailableLocation = {
  __typename?: 'AvailableLocation';
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  isNearby?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  supported: Scalars['Boolean'];
};

export enum AvailableLocationsSource {
  Events = 'EVENTS',
  LocationNotSupported = 'LOCATION_NOT_SUPPORTED',
  Settings = 'SETTINGS'
}

export enum BackgroundType {
  Color = 'Color',
  Picture = 'Picture',
  Pictures = 'Pictures',
  Video = 'Video',
  VideoAlways = 'VideoAlways'
}

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
};

export type BooleanFilter2 = {
  equals?: InputMaybe<Scalars['Boolean']>;
};

export type ByDateBreakdownData = {
  __typename?: 'ByDateBreakdownData';
  byNameBreakdown?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  totalFaceValue?: Maybe<Scalars['Float']>;
  totalTickets?: Maybe<Scalars['Float']>;
};

export type ByTypeBreakdownData = {
  __typename?: 'ByTypeBreakdownData';
  data?: Maybe<Array<Maybe<Scalars['Float']>>>;
  label?: Maybe<Scalars['String']>;
};

export type CaAdmin = {
  __typename?: 'CAAdmin';
  DOB?: Maybe<Scalars['DateTime']>;
  avatar: Scalars['String'];
  displayRole: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  joinedOn: Scalars['DateTime'];
  userId: Scalars['String'];
  username: Scalars['String'];
};

export type CaAdminsResponse = {
  __typename?: 'CAAdminsResponse';
  admins: Array<CaAdmin>;
};

export type CaAgentStartRunInput = {
  attachmentIds?: InputMaybe<Array<Scalars['ID']>>;
  commandId: Scalars['String'];
  communityId: Scalars['ID'];
  message: Scalars['String'];
  replyToActionId?: InputMaybe<Scalars['String']>;
  threadId: Scalars['ID'];
  uiMessageId?: InputMaybe<Scalars['String']>;
};

export type CaAmbassadorCampaignInput = {
  communityId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  internalName: Scalars['String'];
  maxSpots?: InputMaybe<Scalars['Int']>;
  segmentId: Scalars['ID'];
  status?: InputMaybe<Scalars['String']>;
};

export type CaAnnouncementCreateOrUpdateInput = {
  ctaButtonTitle?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  watchLink?: InputMaybe<Scalars['String']>;
};

export type CaCommunityContext = {
  __typename?: 'CACommunityContext';
  announcement?: Maybe<FeedItem>;
  announcements: CaAnnouncementsResult;
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type CaCommunityContextAnnouncementArgs = {
  announcementId: Scalars['ID'];
};


export type CaCommunityContextAnnouncementsArgs = {
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  statuses?: InputMaybe<Array<FeedItemPublishingStatus>>;
  take?: Scalars['Int'];
};

export type CaCommunityThemeCreateOrUpdateInput = {
  buttonStyle?: InputMaybe<Scalars['Json']>;
  colorSet?: InputMaybe<Array<Scalars['String']>>;
  enabledModules?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fonts?: InputMaybe<Array<Scalars['String']>>;
  media?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  style: Scalars['Json'];
};

export type CaEmailCampaignUpdateInput = {
  eventId?: InputMaybe<Scalars['String']>;
  htmlDesign?: InputMaybe<Scalars['String']>;
  immediateSend?: InputMaybe<Scalars['Boolean']>;
  includeUnverifiedEmails?: InputMaybe<Scalars['Boolean']>;
  jsonDesign?: InputMaybe<Scalars['Json']>;
  name?: InputMaybe<Scalars['String']>;
  replyTo?: InputMaybe<Scalars['String']>;
  segment?: InputMaybe<EmailCampaignSegment>;
  sendAt?: InputMaybe<Scalars['DateTime']>;
  senderEmail?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type CaEventActivityEvent = {
  __typename?: 'CAEventActivityEvent';
  action?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type CaEventAttendancePage = {
  __typename?: 'CAEventAttendancePage';
  items: Array<CaEventAttendee>;
  total: Scalars['Int'];
};

export enum CaEventAttendanceStatus {
  CheckedIn = 'CheckedIn',
  NotCheckedIn = 'NotCheckedIn',
  TransferNeeded = 'TransferNeeded'
}

export type CaEventAttendee = {
  __typename?: 'CAEventAttendee';
  avatar?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  /** Whether the community's member profile exists for them */
  hasProfile: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  pronouns?: Maybe<Scalars['String']>;
  status: CaEventAttendanceStatus;
  /** Paid tickets held for the event per tier, in the shop's order */
  tickets: Array<CaEventAttendeeTickets>;
  userId: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
};

export type CaEventAttendeeTickets = {
  __typename?: 'CAEventAttendeeTickets';
  count: Scalars['Int'];
  name: Scalars['String'];
};

export type CaEventBenchmark = {
  __typename?: 'CAEventBenchmark';
  /** The compared event's line; null when there is none */
  compare?: Maybe<CaEventBenchmarkSeries>;
  /** The picked event, or the default one; null when there is none */
  compareEvent?: Maybe<Event>;
  /** Null when the event has no start date */
  event?: Maybe<CaEventBenchmarkSeries>;
};

export type CaEventBenchmarkPoint = {
  __typename?: 'CAEventBenchmarkPoint';
  /** Days relative to the event day (0), never above 0 */
  day: Scalars['Int'];
  tickets: Scalars['Int'];
};

export type CaEventBenchmarkSeries = {
  __typename?: 'CAEventBenchmarkSeries';
  /** Where the line stops: 0 once the event day has passed, else today */
  endDay: Scalars['Int'];
  /** Days with sales only, oldest first; tickets are cumulative */
  points: Array<CaEventBenchmarkPoint>;
};

export type CaEventDetail = {
  __typename?: 'CAEventDetail';
  /** The order's organizer revenue (amount − fee), Progress Sales and smart link orders */
  amount?: Maybe<Scalars['Float']>;
  /** A visitor not linked to an account */
  anonymous: Scalars['Boolean'];
  at: Scalars['DateTime'];
  avatar?: Maybe<Scalars['String']>;
  /** The view's Top sources label, Progress Views only */
  channel?: Maybe<Scalars['String']>;
  /** The order's event, Benchmark only */
  eventName?: Maybe<Scalars['String']>;
  /** The person has a profile in the community (See member) */
  hasProfile: Scalars['Boolean'];
  id: Scalars['ID'];
  /** The stage reached, Event funnel only */
  stage?: Maybe<CaEventFunnelStage>;
  /** An order's tickets per tier, most first (Progress Tickets and Sales, Benchmark, smart link orders) */
  tickets?: Maybe<Array<CaEventDetailTickets>>;
  /** Null for anonymous visitors and deleted accounts */
  userId?: Maybe<Scalars['ID']>;
  /** Null for anonymous visitors and deleted accounts */
  username?: Maybe<Scalars['String']>;
};

export type CaEventDetailTickets = {
  __typename?: 'CAEventDetailTickets';
  count: Scalars['Int'];
  name: Scalars['String'];
};

export type CaEventDetails = {
  __typename?: 'CAEventDetails';
  /** The currency of every amount */
  currency?: Maybe<Scalars['String']>;
  items: Array<CaEventDetail>;
  total: Scalars['Int'];
};

export type CaEventFunnel = {
  __typename?: 'CAEventFunnel';
  /** People who added one of its tickets to the cart */
  cart: Scalars['Int'];
  /** People holding a checked-in paid ticket */
  checkedIn: Scalars['Int'];
  /** Going and Interested RSVPs */
  rsvp: Scalars['Int'];
  /** People who saw the event in a list, opened its page or saw its tickets */
  seen: Scalars['Int'];
  /** People holding a paid ticket, guest list excluded */
  tickets: Scalars['Int'];
};

export enum CaEventFunnelStage {
  Cart = 'cart',
  CheckedIn = 'checkedIn',
  Rsvp = 'rsvp',
  Seen = 'seen',
  Tickets = 'tickets'
}

export enum CaEventFunnelTab {
  Interest = 'interest',
  Purchase = 'purchase'
}

export type CaEventInformation = {
  __typename?: 'CAEventInformation';
  grossRevenue?: Maybe<Scalars['Float']>;
  rsvped?: Maybe<Scalars['Float']>;
  ticketsSold?: Maybe<Scalars['Float']>;
  usersCheckedIn?: Maybe<Scalars['Float']>;
  usersInvited?: Maybe<Scalars['Float']>;
  usersRegistered?: Maybe<Scalars['Float']>;
};

export type CaEventOverview = {
  __typename?: 'CAEventOverview';
  currency: Scalars['String'];
  /** Spots claimed out of spots created; null when the event has no invites */
  guestList?: Maybe<CaEventOverviewGuestList>;
  response: CaEventOverviewResponse;
  revenue: CaEventOverviewMetric;
  revenueEstimated: Scalars['Boolean'];
  tickets: CaEventOverviewMetric;
  tiers: Array<CaEventOverviewTier>;
  views: CaEventOverviewMetric;
};

export type CaEventOverviewGuestList = {
  __typename?: 'CAEventOverviewGuestList';
  claimed: Scalars['Int'];
  spots: Scalars['Int'];
};

export type CaEventOverviewMetric = {
  __typename?: 'CAEventOverviewMetric';
  addedLast7Days: Scalars['Float'];
  /** Capacity or target; null when unlimited or unknown */
  total?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

export type CaEventOverviewResponse = {
  __typename?: 'CAEventOverviewResponse';
  addedLast7Days: Scalars['Int'];
  going: Scalars['Int'];
  interested: Scalars['Int'];
  members: Scalars['Int'];
  noResponse: Scalars['Int'];
  notGoing: Scalars['Int'];
};

export type CaEventOverviewTier = {
  __typename?: 'CAEventOverviewTier';
  /** Effective capacity: the quantity, or what it sold once closed early (D10) */
  capacity: Scalars['Int'];
  currency: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** List price */
  price: Scalars['Float'];
  /** When sales end: the earlier of the sales end and the sold-out cut-off */
  salesEnd?: Maybe<Scalars['DateTime']>;
  /** When sales of a published tier start; in the future while it is scheduled */
  salesStart?: Maybe<Scalars['DateTime']>;
  sold: Scalars['Int'];
  /** Sold to capacity, or closed early */
  soldOut: Scalars['Boolean'];
};

export type CaEventProgressBounds = {
  __typename?: 'CAEventProgressBounds';
  /** Last day (YYYY-MM-DD) */
  end: Scalars['String'];
  /** First day (YYYY-MM-DD); custom ranges only */
  start?: Maybe<Scalars['String']>;
};

export type CaEventProgressChannel = {
  __typename?: 'CAEventProgressChannel';
  /** A Top sources label: WERZ, Instagram, a website's domain, … */
  channel: Scalars['String'];
  /** Buckets with views only, oldest first */
  points: Array<CaEventViewsProgressPoint>;
};

export type CaEventProgressPeriod = {
  __typename?: 'CAEventProgressPeriod';
  /** Whether the period reaches today */
  current: Scalars['Boolean'];
  /** The bucket holding now, when in the period */
  currentSlot?: Maybe<Scalars['String']>;
  /** Last day, never after today */
  end: Scalars['String'];
  /** The period after; null once the period reaches today */
  next?: Maybe<CaEventProgressBounds>;
  /** The period before; null at the event's creation and for All time */
  previous?: Maybe<CaEventProgressBounds>;
  /** Every bucket's local start (YYYY-MM-DDTHH:MI), oldest first, up to now */
  slots: Array<Scalars['String']>;
  /** First day, YYYY-MM-DD in the event time zone */
  start: Scalars['String'];
  unit: CaEventProgressUnit;
};

export enum CaEventProgressRange {
  AllTime = 'ALL_TIME',
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  Last_24Hours = 'LAST_24_HOURS',
  Last_30Days = 'LAST_30_DAYS',
  Last_90Days = 'LAST_90_DAYS'
}

export enum CaEventProgressTab {
  Sales = 'sales',
  Tickets = 'tickets',
  Views = 'views'
}

export type CaEventProgressTier = {
  __typename?: 'CAEventProgressTier';
  /** The guest list's free tickets (claims), for Tickets; never in Other tiers */
  guestList: Scalars['Boolean'];
  /** The ticket product; null for Other tiers and the guest list */
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  /** Buckets with sales only, oldest first */
  points: Array<CaEventSalesProgressPoint>;
};

export enum CaEventProgressUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type CaEventResponse = {
  __typename?: 'CAEventResponse';
  activityEvents?: Maybe<Array<Maybe<CaEventActivityEvent>>>;
  /** Unredacted latitude for the authenticated community-admin editor. */
  editableLatitude?: Maybe<Scalars['Float']>;
  /** Unredacted address for the authenticated community-admin editor. */
  editableLocation?: Maybe<Scalars['String']>;
  /** Unredacted longitude for the authenticated community-admin editor. */
  editableLongitude?: Maybe<Scalars['Float']>;
  event?: Maybe<Event>;
  information?: Maybe<CaEventInformation>;
  ticketProducts: Array<Product>;
};


export type CaEventResponseActivityEventsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type CaEventSalesProgress = {
  __typename?: 'CAEventSalesProgress';
  /** The currency of every revenue value */
  currency: Scalars['String'];
  period: CaEventProgressPeriod;
  /** Tiers with sales in the period, most tickets first; the rest merged as Other tiers; then the guest list, when it has tickets in the period */
  tiers: Array<CaEventProgressTier>;
};

export type CaEventSalesProgressPoint = {
  __typename?: 'CAEventSalesProgressPoint';
  bucket: Scalars['String'];
  /** Organizer revenue (amount − fee) */
  revenue: Scalars['Float'];
  /** Paid tickets */
  tickets: Scalars['Int'];
};

export type CaEventTicketsActivityResponse = {
  __typename?: 'CAEventTicketsActivityResponse';
  byDateBreakdown?: Maybe<Array<Maybe<ByDateBreakdownData>>>;
  byTypeBreakdown?: Maybe<Array<Maybe<ByTypeBreakdownData>>>;
};

export type CaEventTopSource = {
  __typename?: 'CAEventTopSource';
  /** Buyers among them */
  buyers: Scalars['Int'];
  /** WERZ, Instagram, Direct, Email, a website's domain, a sharer's @username, a smart link (Smart link · name), Unattributed, … */
  channel: Scalars['String'];
  /** Organizer revenue (amount − fee) of those tickets */
  revenue: Scalars['Float'];
  /** The member behind an @username row, when they have a profile in this community */
  sharerId?: Maybe<Scalars['String']>;
  /** Paid tickets they bought, guest list excluded */
  tickets: Scalars['Int'];
  /** People this channel last brought to the event (in-app browsing never overrides a campaign touch) */
  views: Scalars['Int'];
};

export type CaEventTopSources = {
  __typename?: 'CAEventTopSources';
  /** By tickets, then views; Unattributed last */
  channels: Array<CaEventTopSource>;
  /** The currency of every revenue value */
  currency: Scalars['String'];
};

export type CaEventTraction = {
  __typename?: 'CAEventTraction';
  metrics: CaEventTractionMetrics;
  ticketsDetails: Array<CaEventTractionTicketsDetails>;
};

export type CaEventTractionMetrics = {
  __typename?: 'CAEventTractionMetrics';
  guestListTickets?: Maybe<Scalars['Int']>;
  potentialRevenue: Scalars['String'];
  ticketsSold: Scalars['String'];
  timePoint: Scalars['DateTime'];
  timeSubtitle: Scalars['String'];
  totalRevenue: Scalars['String'];
};

export type CaEventTractionTicketsDetails = {
  __typename?: 'CAEventTractionTicketsDetails';
  description?: Maybe<Scalars['String']>;
  discountedPrice?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  initialPrice: Scalars['String'];
  medialUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  salesDates: Scalars['String'];
  soldByInitialPrice: Scalars['String'];
  soldWithDiscount?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status: Scalars['String'];
  statusColor: Scalars['String'];
  totalRevenue: Scalars['String'];
  totalSold: Scalars['String'];
};

export type CaEventViewsProgress = {
  __typename?: 'CAEventViewsProgress';
  /** Channels by views in the period; the rest merged as Other */
  channels: Array<CaEventProgressChannel>;
  period: CaEventProgressPeriod;
};

export type CaEventViewsProgressPoint = {
  __typename?: 'CAEventViewsProgressPoint';
  bucket: Scalars['String'];
  /** List impressions and page opens */
  views: Scalars['Int'];
};

export type CaFinancesOverviewResponse = {
  __typename?: 'CAFinancesOverviewResponse';
  salesBreakdown?: Maybe<Array<Maybe<SalesData>>>;
  selectedRangeTotal?: Maybe<Scalars['Float']>;
  totalSales?: Maybe<Scalars['Float']>;
};

export type CaForumItemsReturn = {
  __typename?: 'CAForumItemsReturn';
  nextPosts: Scalars['Int'];
  nextReported: Scalars['Int'];
  posts: Array<ForumPost>;
  reports: Array<ForumContentReport>;
  totalPending: Scalars['Int'];
  totalPosts: Scalars['Int'];
  totalReported: Scalars['Int'];
};

export enum CaGuestListAction {
  AddMembers = 'AddMembers',
  AddNote = 'AddNote',
  CreateEmailInvites = 'CreateEmailInvites',
  CreateLinks = 'CreateLinks',
  DeleteInvite = 'DeleteInvite',
  DeleteNote = 'DeleteNote',
  MarkShared = 'MarkShared'
}

export type CaGuestListChangeInput = {
  action: CaGuestListAction;
  checkInNote?: InputMaybe<Scalars['String']>;
  expectedVersion?: InputMaybe<Scalars['String']>;
  inviteId?: InputMaybe<Scalars['ID']>;
  invitees?: InputMaybe<Array<CaGuestListInviteeInput>>;
  noteId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CaGuestListClaim = {
  __typename?: 'CAGuestListClaim';
  claimedAt: Scalars['DateTime'];
  hasProfile: Scalars['Boolean'];
  id: Scalars['ID'];
  person: CaGuestListPerson;
};

export type CaGuestListInvite = {
  __typename?: 'CAGuestListInvite';
  claimedCount: Scalars['Int'];
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  editVersion: Scalars['String'];
  eventId: Scalars['ID'];
  eventName: Scalars['String'];
  id: Scalars['ID'];
  internalName: Scalars['String'];
  inviteUrl?: Maybe<Scalars['String']>;
  invitedBy?: Maybe<CaGuestListPerson>;
  method: GuestListInviteMethod;
  notes: Array<CaGuestListNote>;
  spots: Scalars['Int'];
  status: CaGuestListInviteStatus;
};

export enum CaGuestListInviteStatus {
  Claimed = 'Claimed',
  Created = 'Created',
  Expired = 'Expired',
  Opened = 'Opened',
  Shared = 'Shared'
}

export type CaGuestListInviteeInput = {
  /** The guest's email for CreateEmailInvites */
  name: Scalars['String'];
  numPlus: Scalars['Int'];
};

export type CaGuestListNote = {
  __typename?: 'CAGuestListNote';
  author?: Maybe<CaGuestListPerson>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  text: Scalars['String'];
  username: Scalars['String'];
};

export type CaGuestListPage = {
  __typename?: 'CAGuestListPage';
  items: Array<CaGuestListInvite>;
  total: Scalars['Int'];
};

export type CaGuestListPerson = {
  __typename?: 'CAGuestListPerson';
  avatar?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
};

export type CaGuestListReceipt = {
  __typename?: 'CAGuestListReceipt';
  /** CreateEmailInvites: the invites whose email was sent. The others stay Created, with a link to copy. */
  emailedInviteIds: Array<Scalars['ID']>;
  eventId: Scalars['ID'];
  inviteIds: Array<Scalars['ID']>;
};

export type CaLoginResponse = {
  __typename?: 'CALoginResponse';
  communities: Array<Community>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type CaMassMessageUpdateInput = {
  eventId?: InputMaybe<Scalars['String']>;
  linkedChannelId?: InputMaybe<Scalars['String']>;
  linkedChannelName?: InputMaybe<Scalars['String']>;
  linkedItemId?: InputMaybe<Scalars['String']>;
  linkedModule?: InputMaybe<Scalars['String']>;
  linkedToChat?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  segment?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['String']>;
  sendAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CaProductConfigs = {
  __typename?: 'CAProductConfigs';
  availableCurrencies: Array<SupportedCurrencies>;
};

export type CaProductCreateOrUpdateInput = {
  additionalConfig?: InputMaybe<Scalars['Json']>;
  badgeMediaUrl?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<SupportedCurrencies>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mediaUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  productType?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requiredAccessCode?: InputMaybe<Scalars['String']>;
  showBeforeStartDate?: InputMaybe<Scalars['Boolean']>;
  soldoutAfter?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  validFrom?: InputMaybe<Scalars['DateTime']>;
  validTo?: InputMaybe<Scalars['DateTime']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type CaProductEventsReturn = {
  __typename?: 'CAProductEventsReturn';
  items: Array<Event>;
  total: Scalars['Int'];
};

export type CaProductQuantityChangeInput = {
  mode: Scalars['String'];
  value: Scalars['Int'];
};

export type CaProductsReturn = {
  __typename?: 'CAProductsReturn';
  items: Array<Product>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export enum CaPromocodeDiscountType {
  AmountOff = 'AmountOff',
  NewPrice = 'NewPrice',
  Percentage = 'Percentage'
}

export type CaPromocodeRedemption = {
  __typename?: 'CAPromocodeRedemption';
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  /** The code's discount, or AmountOff with the amount taken off when it changed */
  discountType: CaPromocodeDiscountType;
  discountValue: Scalars['Float'];
  /** The purchase */
  id: Scalars['ID'];
  /** Price before the code, fees excluded */
  listPrice: Scalars['Float'];
  /** Price after the code, fees excluded */
  price: Scalars['Float'];
  /** Null when the code was deleted */
  promocodeId?: Maybe<Scalars['ID']>;
  /** The buyer; null when the account is gone */
  userId?: Maybe<Scalars['ID']>;
  username?: Maybe<Scalars['String']>;
};

export type CaPromocodeRedemptions = {
  __typename?: 'CAPromocodeRedemptions';
  items: Array<CaPromocodeRedemption>;
  total: Scalars['Int'];
};

export type CaScheduleItemCreateOrUpdateInput = {
  dayOverride?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  mediaUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  stageName?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export enum CaSegmentAction {
  AddMembers = 'AddMembers',
  Create = 'Create',
  Delete = 'Delete',
  RemoveMembers = 'RemoveMembers',
  Update = 'Update'
}

export type CaSegmentChangeInput = {
  action: CaSegmentAction;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['ID']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CaSegmentList = {
  __typename?: 'CASegmentList';
  items: Array<CaSegmentListItem>;
  total: Scalars['Int'];
};

export type CaSegmentListItem = {
  __typename?: 'CASegmentListItem';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayTotalSpent: Scalars['String'];
  id: Scalars['ID'];
  memberCount: Scalars['Int'];
  name: Scalars['String'];
  totalKarma: Scalars['Int'];
};

export type CaSegmentReceipt = {
  __typename?: 'CASegmentReceipt';
  changedUserIds: Array<Scalars['ID']>;
  segmentId: Scalars['ID'];
};

export enum CaSegmentSort {
  CreatedAt = 'createdAt',
  Name = 'name'
}

export type CaSegmentUsage = {
  __typename?: 'CASegmentUsage';
  ambassadorCampaigns: Array<Scalars['String']>;
  chatChannels: Array<Scalars['String']>;
  membershipProducts: Array<Scalars['String']>;
  modules: Array<Scalars['String']>;
  pushNotifications: Array<Scalars['String']>;
  restrictedProducts: Array<Scalars['String']>;
};

export type CaTalksChannelItem = {
  __typename?: 'CATalksChannelItem';
  channelId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CaTalksChannelsResponse = {
  __typename?: 'CATalksChannelsResponse';
  items: Array<CaTalksChannelItem>;
  total: Scalars['Int'];
};

export type CaTalksChat = {
  __typename?: 'CATalksChat';
  avatar: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  lastMessage: Scalars['String'];
  lastMessageTime: Scalars['DateTime'];
  lastMine: Scalars['Boolean'];
  numberUnread: Scalars['Int'];
  userId: Scalars['String'];
  username: Scalars['String'];
};

export type CaTalksChatResponse = {
  __typename?: 'CATalksChatResponse';
  avatar: Scalars['String'];
  items: Array<TalksMessage>;
  next: Scalars['Int'];
  total: Scalars['Int'];
  username: Scalars['String'];
};

export type CaTalksChatsResponse = {
  __typename?: 'CATalksChatsResponse';
  chats?: Maybe<Array<Maybe<CaTalksChat>>>;
  unreadCount: Scalars['Int'];
};

export type Cta = {
  __typename?: 'CTA';
  frequency: Scalars['String'];
  link: Scalars['String'];
  style: Scalars['String'];
  text: Scalars['String'];
};

export type CaAdminIndicatorsPermissions = {
  __typename?: 'CaAdminIndicatorsPermissions';
  pendingReviewCount: Scalars['Int'];
};

export type CaCatalogItemInput = {
  categoryNames?: InputMaybe<Array<Scalars['String']>>;
  communityId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  photoUrl?: InputMaybe<Scalars['String']>;
  publishingStatus: UnifiedPublishingStatus;
  scheduleItemIds?: InputMaybe<Array<Scalars['String']>>;
  urls?: InputMaybe<Array<Scalars['String']>>;
};

export type CaCatalogItemOrderByInput = {
  name?: InputMaybe<SortOrder>;
  publishingStatus?: InputMaybe<SortOrder>;
};

export type CaCatalogScheduleItemRef = {
  __typename?: 'CaCatalogScheduleItemRef';
  id: Scalars['ID'];
  mediaUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CaCommunityMembersV2Response = {
  __typename?: 'CaCommunityMembersV2Response';
  members: Array<CaMember>;
  next: Scalars['Int'];
  totalMembers: Scalars['Int'];
};

export enum CaEventTemporalFilter {
  Live = 'Live',
  Past = 'Past',
  Undated = 'Undated',
  Upcoming = 'Upcoming'
}

export type CaImportEventResult = {
  __typename?: 'CaImportEventResult';
  alreadyExisted: Scalars['Boolean'];
  event: Event;
};

export type CaInstagramComment = {
  __typename?: 'CaInstagramComment';
  createdAt: Scalars['DateTime'];
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  replies: Array<CaInstagramCommentReply>;
  text: Scalars['String'];
  username: Scalars['String'];
};

export type CaInstagramCommentReply = {
  __typename?: 'CaInstagramCommentReply';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  text: Scalars['String'];
  username: Scalars['String'];
};

export type CaInstagramConversation = {
  __typename?: 'CaInstagramConversation';
  id: Scalars['ID'];
  lastMessage?: Maybe<CaInstagramMessage>;
  messages: Array<CaInstagramMessage>;
  name?: Maybe<Scalars['String']>;
  replyUntil?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type CaInstagramInsight = {
  __typename?: 'CaInstagramInsight';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type CaInstagramMessage = {
  __typename?: 'CaInstagramMessage';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  mine: Scalars['Boolean'];
  repliesToStory: Scalars['Boolean'];
  story?: Maybe<CaInstagramStory>;
  text: Scalars['String'];
};

export type CaInstagramStory = {
  __typename?: 'CaInstagramStory';
  id: Scalars['ID'];
  insights: Array<CaInstagramInsight>;
  mediaType: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  permalink?: Maybe<Scalars['String']>;
  postedAt: Scalars['DateTime'];
};

export type CaJoinRequest = {
  __typename?: 'CaJoinRequest';
  joinRequirementsData?: Maybe<Scalars['Json']>;
  requestedAt: Scalars['DateTime'];
  user: User;
};

export type CaJoinRequestDetailResponse = {
  __typename?: 'CaJoinRequestDetailResponse';
  joinRequirementsConfig?: Maybe<Scalars['Json']>;
  joinRequirementsData?: Maybe<Scalars['Json']>;
  requestedAt: Scalars['DateTime'];
  user: User;
};

export type CaJoinRequestsResponse = {
  __typename?: 'CaJoinRequestsResponse';
  next: Scalars['Int'];
  requests: Array<CaJoinRequest>;
  totalCount: Scalars['Int'];
};

export type CaMember = {
  __typename?: 'CaMember';
  avatar?: Maybe<Scalars['String']>;
  banned: Scalars['Boolean'];
  birthday?: Maybe<Scalars['DateTime']>;
  country?: Maybe<Scalars['String']>;
  displayLocation?: Maybe<Scalars['String']>;
  displayTotalSpent: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  id: Scalars['String'];
  karma: Scalars['Int'];
  lastEnteredAt?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  memberSince?: Maybe<Scalars['DateTime']>;
  numberedId: Scalars['Int'];
  pronouns?: Maybe<Scalars['String']>;
  segments: Array<CaMemberSegment>;
  totalSpent: Scalars['Float'];
  username?: Maybe<Scalars['String']>;
};

export type CaMemberActivityEvent = {
  __typename?: 'CaMemberActivityEvent';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: Scalars['String'];
  properties?: Maybe<Scalars['String']>;
  time: Scalars['String'];
};

export type CaMemberEventItem = {
  __typename?: 'CaMemberEventItem';
  dateRange: Scalars['String'];
  id: Scalars['ID'];
  mediaUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  startAt?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  statusColor: Scalars['String'];
  ticketCount: Scalars['Int'];
  ticketInfo?: Maybe<Scalars['String']>;
};

export type CaMemberEventsResponse = {
  __typename?: 'CaMemberEventsResponse';
  items: Array<CaMemberEventItem>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaMemberOrderItem = {
  __typename?: 'CaMemberOrderItem';
  createdAt: Scalars['DateTime'];
  displayProducts: Scalars['String'];
  displayTotalSpent?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  productCount: Scalars['Int'];
};

export type CaMemberOrdersResponse = {
  __typename?: 'CaMemberOrdersResponse';
  items: Array<CaMemberOrderItem>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaMemberPurchaseItem = {
  __typename?: 'CaMemberPurchaseItem';
  discountedPrice?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  price: Scalars['String'];
  productName: Scalars['String'];
  status: Scalars['String'];
  statusColor: Scalars['String'];
  time: Scalars['String'];
};

export type CaMemberPurchasesResponse = {
  __typename?: 'CaMemberPurchasesResponse';
  items: Array<CaMemberPurchaseItem>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaMemberResponse = {
  __typename?: 'CaMemberResponse';
  avatar?: Maybe<Scalars['String']>;
  banned: Scalars['Boolean'];
  birthday?: Maybe<Scalars['String']>;
  boughtTicketsCount: Scalars['Int'];
  checkedInEventsCount: Scalars['Int'];
  displayLocation?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  karma: Scalars['Int'];
  location?: Maybe<Scalars['String']>;
  member?: Maybe<CommunityMemberInfo>;
  memberSince?: Maybe<Scalars['String']>;
  notes: Scalars['Json'];
  numberedId: Scalars['String'];
  pronouns?: Maybe<Scalars['String']>;
  purchasesCount: Scalars['Int'];
  segments: Array<Segment>;
  sumOfPurchases: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export type CaMemberSegment = {
  __typename?: 'CaMemberSegment';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CaPromocodeUpdateInput = {
  code?: InputMaybe<Scalars['String']>;
  discountFixed?: InputMaybe<Scalars['Int']>;
  discountOverridePrice?: InputMaybe<Scalars['Int']>;
  discountPercentage?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['String']>;
  limitPerUser?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type CaReviewEventInput = {
  additionalDetails?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  end?: InputMaybe<Scalars['DateTime']>;
  location?: InputMaybe<Scalars['String']>;
  mediaUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  venueName?: InputMaybe<Scalars['String']>;
};

export type CaReviewQueueResult = {
  __typename?: 'CaReviewQueueResult';
  items: Array<DisplayReviewEvent>;
  total: Scalars['Int'];
};

export type CaReviewReleaseInput = {
  artist?: InputMaybe<Scalars['String']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CaReviewReleaseQueueResult = {
  __typename?: 'CaReviewReleaseQueueResult';
  items: Array<DisplayReviewRelease>;
  total: Scalars['Int'];
};

export type CaUserActivityLogResponse = {
  __typename?: 'CaUserActivityLogResponse';
  items: Array<CaMemberActivityEvent>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CalendarEventsResponse = {
  __typename?: 'CalendarEventsResponse';
  items: Array<Event>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CalendarLocation = {
  __typename?: 'CalendarLocation';
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CancelKustomOrderResponse = {
  __typename?: 'CancelKustomOrderResponse';
  success: Scalars['Boolean'];
};

export type CatalogItem = {
  __typename?: 'CatalogItem';
  categories: Array<CatalogItemCategoryRef>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  parentCommunity?: Maybe<Community>;
  parentCommunityId?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  publishingStatus: UnifiedPublishingStatus;
  schedule?: Maybe<Array<Maybe<CatalogItemSchedule>>>;
  updatedAt: Scalars['DateTime'];
  urls: Array<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type CatalogItemCategoryRef = {
  __typename?: 'CatalogItemCategoryRef';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CatalogItemSchedule = {
  __typename?: 'CatalogItemSchedule';
  addedToCalendar: Scalars['Boolean'];
  addedToCalendarUserIds: Scalars['String'];
  artistId?: Maybe<Scalars['String']>;
  calendarHideFrom?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dayOverride?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  myRsvp?: Maybe<ScheduleItemRsvpStatus>;
  name: Scalars['String'];
  parentCommunity?: Maybe<Community>;
  parentCommunityId?: Maybe<Scalars['String']>;
  publishingStatus: CatalogItemSchedulePublishingStatus;
  pushNotificationSent: Scalars['Boolean'];
  stageName: Scalars['String'];
  start?: Maybe<Scalars['DateTime']>;
  tags: Array<Scalars['String']>;
  timezone: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum CatalogItemSchedulePublishingStatus {
  Active = 'Active',
  Deleted = 'Deleted',
  Draft = 'Draft',
  UneditedDraft = 'UneditedDraft'
}

export type Chat = {
  __typename?: 'Chat';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum CheckoutMode {
  JoinRequest = 'join_request',
  Purchase = 'purchase'
}

export type CheckoutPostReturnPurchase = {
  __typename?: 'CheckoutPostReturnPurchase';
  additionalInfo?: Maybe<Scalars['Json']>;
  code?: Maybe<Scalars['String']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  price: Scalars['Float'];
  product: Product;
  status: PurchaseStatus;
  statusMessage?: Maybe<Scalars['String']>;
};

export type ClaimedBadge = {
  __typename?: 'ClaimedBadge';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  owner: User;
  ownerId: Scalars['String'];
  purchase?: Maybe<Purchase>;
  purchaseId?: Maybe<Scalars['String']>;
  template?: Maybe<TemplateBadge>;
  templateId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ClientConfigResponse = {
  __typename?: 'ClientConfigResponse';
  enabledSignUpSteps: Array<SignUpStep>;
  joinAdditionalSteps: Array<Scalars['String']>;
  signUpFastTrack: Scalars['Boolean'];
};

export type Community = {
  __typename?: 'Community';
  adminRole?: Maybe<Scalars['String']>;
  admins: Array<User>;
  adminsCount: Scalars['Int'];
  availableModules?: Maybe<Array<Maybe<Scalars['String']>>>;
  availablePaymentMethods: Array<Scalars['String']>;
  backgroundColor: Scalars['String'];
  backgroundColorAndroid: Scalars['String'];
  backgroundLength: Scalars['Int'];
  backgroundLengthAndroid: Scalars['Int'];
  backgroundType: BackgroundType;
  backgroundTypeAndroid?: Maybe<BackgroundType>;
  code?: Maybe<Scalars['String']>;
  configs: Scalars['Json'];
  country: SupportedCountries;
  createdAt: Scalars['DateTime'];
  currency: SupportedCurrencies;
  description?: Maybe<Scalars['String']>;
  emailPostmarkStream?: Maybe<Scalars['String']>;
  emailSenderSignature?: Maybe<Scalars['String']>;
  enableModulesV2: Scalars['Boolean'];
  enableStylePolling: Scalars['Boolean'];
  events: Array<Event>;
  exploreMedia: Array<Scalars['String']>;
  exploreMediaUrl?: Maybe<Scalars['String']>;
  globalInviteCode?: Maybe<Scalars['String']>;
  globalTicketsLink?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inviteFriendsPrompt: Scalars['Boolean'];
  isCurrentUserCheckInAdmin: Scalars['Boolean'];
  joinRequirements?: Maybe<Scalars['Json']>;
  landingCode?: Maybe<Scalars['String']>;
  landingLink?: Maybe<Scalars['String']>;
  links: Scalars['Json'];
  location?: Maybe<Scalars['String']>;
  massMessagesAutoApprove: Scalars['Boolean'];
  memberSince?: Maybe<Scalars['Date']>;
  /** @deprecated Returns an empty list. Member lists are not public; admins use caCommunityMembers. */
  members: Array<User>;
  membersCount?: Maybe<Scalars['Int']>;
  minAppVersion: Scalars['String'];
  missingRequiredUserFields: Array<Scalars['String']>;
  modulesDesign?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numPersonalizedInviteCodes: Scalars['Int'];
  order?: Maybe<Scalars['Int']>;
  paymentFees: ProductFees;
  preselectedPaymentMethod?: Maybe<PurchasePaymentMethod>;
  requestToJoin: Scalars['Boolean'];
  requiredUserFields: Array<UserInfoField>;
  sawDisclaimer?: Maybe<Scalars['Boolean']>;
  shortDescription?: Maybe<Scalars['String']>;
  showPermanentInviteInList: Scalars['Boolean'];
  stripeConnectedAccountId?: Maybe<Scalars['String']>;
  styleOverride?: Maybe<Scalars['Json']>;
  swishPayees?: Maybe<Scalars['String']>;
  talksAdminIconUrl?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  type: CommunityType;
  updatedAt: Scalars['DateTime'];
  visibleInLocations: Array<Location>;
};


export type CommunityEventsArgs = {
  orderBy?: InputMaybe<EventOrderByInput>;
  where?: InputMaybe<EventWhereInput>;
};


export type CommunityMembersArgs = {
  orderBy?: InputMaybe<UserOrderByInput>;
  where?: InputMaybe<UserWhereInput>;
};

export type CommunityByInviteCode = {
  __typename?: 'CommunityByInviteCode';
  communityCode: Scalars['String'];
  communityIconUrl: Scalars['String'];
  communityInviteCode: Scalars['String'];
  communityName: Scalars['String'];
  hasPendingRequest: Scalars['Boolean'];
  isMember: Scalars['Boolean'];
  requestToJoin: Scalars['Boolean'];
};

export type CommunityDailyRevenueData = {
  __typename?: 'CommunityDailyRevenueData';
  amount?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['Date']>;
  formattedDates?: Maybe<Scalars['String']>;
};

export type CommunityListRelationFilter = {
  some?: InputMaybe<CommunityWhereInput2>;
};

export type CommunityMemberInfo = {
  __typename?: 'CommunityMemberInfo';
  community: Community;
  communityId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  memberSince: Scalars['DateTime'];
  sawDisclaimer: Scalars['Boolean'];
  user: User;
  userId: Scalars['String'];
};

export type CommunityPayload = {
  __typename?: 'CommunityPayload';
  communities?: Maybe<Array<Maybe<Community>>>;
  errors?: Maybe<Array<Maybe<TranslatableError>>>;
};

export type CommunityRadiosReturn = {
  __typename?: 'CommunityRadiosReturn';
  items: Array<CommunityRadiosTrack>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CommunityRadiosTrack = {
  __typename?: 'CommunityRadiosTrack';
  artist?: Maybe<Scalars['String']>;
  community: PublicCommunity;
  coverUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  socialMediaLinks?: Maybe<Array<Scalars['String']>>;
  start?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  type: TrackType;
};

export type CommunityShop = {
  __typename?: 'CommunityShop';
  code: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inAppLink: Scalars['String'];
};

export type CommunitySubscription = {
  __typename?: 'CommunitySubscription';
  id: Scalars['ID'];
  lastTransactionDate?: Maybe<Scalars['DateTime']>;
  productName: Scalars['String'];
  status: Scalars['String'];
  subscriberSince: Scalars['DateTime'];
  user: User;
};

export type CommunityTheme = {
  __typename?: 'CommunityTheme';
  buttonStyle: Scalars['JSON'];
  colorSet: Array<Scalars['String']>;
  community?: Maybe<Community>;
  communityId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  enabledModules: Array<Module>;
  fonts: Array<Scalars['String']>;
  id: Scalars['String'];
  media: Array<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  status: CommunityThemeStatus;
  style: Scalars['JSON'];
  updatedAt: Scalars['DateTime'];
};

export enum CommunityThemeStatus {
  Active = 'Active',
  Deleted = 'Deleted',
  Draft = 'Draft'
}

export enum CommunityType {
  Aggregator = 'Aggregator',
  EventOrganizer = 'EventOrganizer'
}

export type CommunityWhereInput = {
  id?: InputMaybe<Scalars['String']>;
  landingCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CommunityWhereInput2 = {
  id?: InputMaybe<StringFilter2>;
};

export type CommunityWhereUniqueInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CompetitionTicket = {
  __typename?: 'CompetitionTicket';
  charityName: Scalars['String'];
  charityUrl: Scalars['String'];
  communityCode: Scalars['String'];
  donateProductSlug?: Maybe<Scalars['String']>;
  donationPool: Scalars['Float'];
  isWinner?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<Scalars['String']>>;
  productImage?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  productSlug?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  ticketUuid: Scalars['String'];
};

export type ConfirmKustomOrderResponse = {
  __typename?: 'ConfirmKustomOrderResponse';
  byEmail: Scalars['Boolean'];
  currency: Scalars['String'];
  digitalItems?: Maybe<Array<DigitalItem>>;
  discount: Scalars['Float'];
  fees: Scalars['Float'];
  purchases?: Maybe<Array<Purchase>>;
  success: Scalars['Boolean'];
  vat: Scalars['Float'];
};

export type CreateMediaResponse = {
  __typename?: 'CreateMediaResponse';
  errors?: Maybe<Array<Maybe<TranslatableError>>>;
  publicUrl?: Maybe<Scalars['String']>;
  uploadURL?: Maybe<Scalars['String']>;
};

export type CreateOrUpdateKustomOrderResponse = {
  __typename?: 'CreateOrUpdateKustomOrderResponse';
  htmlSnippet: Scalars['String'];
  orderId: Scalars['String'];
  purchaseIds?: Maybe<Array<Scalars['String']>>;
  werzOrderId: Scalars['String'];
};

export type CreateStripeCustomerPortalResponse = {
  __typename?: 'CreateStripeCustomerPortalResponse';
  url: Scalars['String'];
};

export type CuratedNewsResponse = {
  __typename?: 'CuratedNewsResponse';
  items: Array<FeedItem>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CuratedScheduleItemsResponse = {
  __typename?: 'CuratedScheduleItemsResponse';
  items: Array<FeedFestivalScheduleItem>;
  next: Scalars['Int'];
  timezone: Scalars['String'];
  total: Scalars['Int'];
};

export type DailyMembersData = {
  __typename?: 'DailyMembersData';
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
};

export type DeferredLinkResult = {
  __typename?: 'DeferredLinkResult';
  communityCode: Scalars['String'];
  inviteCode: Scalars['String'];
};

export enum DeliveryMethod {
  MerchPickup = 'merchPickup',
  MerchShipping = 'merchShipping',
  TicketInApp = 'ticketInApp',
  TicketQr = 'ticketQR'
}

export type DigitalItem = {
  __typename?: 'DigitalItem';
  label: Scalars['String'];
  productName: Scalars['String'];
  ticketUuid: Scalars['String'];
};

export type DiscountAndFees = {
  __typename?: 'DiscountAndFees';
  checkoutMode: CheckoutMode;
  deliveryFees?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  fees?: Maybe<Scalars['Float']>;
  invalidProductIds?: Maybe<Array<Scalars['String']>>;
  membershipRequiredProductIds: Array<Scalars['String']>;
  paymentMethods: Array<PurchasePaymentMethod>;
  shippingVat?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

export type DisplayAmbassadorCampaign = {
  __typename?: 'DisplayAmbassadorCampaign';
  community: Community;
  id: Scalars['String'];
  segmentDisplayName?: Maybe<Scalars['String']>;
  segmentInstructions?: Maybe<Scalars['String']>;
  spotsAvailable: Scalars['Boolean'];
  status: AmbassadorCampaignStatus;
  userHasClaimed: Scalars['Boolean'];
};

export type DisplayCatalogItem = {
  __typename?: 'DisplayCatalogItem';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
};

export type DisplayCatalogItemCategory = {
  __typename?: 'DisplayCatalogItemCategory';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DisplayCatalogScheduleItem = {
  __typename?: 'DisplayCatalogScheduleItem';
  addedToCalendar: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mediaUrl?: Maybe<Scalars['String']>;
  myRsvp?: Maybe<ScheduleItemRsvpStatus>;
  name?: Maybe<Scalars['String']>;
  stageName?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
};

export type DisplayContentPreview = {
  __typename?: 'DisplayContentPreview';
  community?: Maybe<DisplayContentPreviewCommunity>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DisplayContentPreviewCommunity = {
  __typename?: 'DisplayContentPreviewCommunity';
  iconUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type DisplayDetailedCatalogItem = {
  __typename?: 'DisplayDetailedCatalogItem';
  categories: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  schedule: Array<Maybe<DisplayCatalogScheduleItem>>;
  urls: Array<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type DisplayEvent = {
  __typename?: 'DisplayEvent';
  attendeesCount: Scalars['Int'];
  attendeesIcons: Array<Scalars['String']>;
  communityCode: Scalars['String'];
  communityIconUrl: Scalars['String'];
  communityName: Scalars['String'];
  date?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  location: Scalars['String'];
  locationDisplayCompact: Scalars['String'];
  locationDisplayFull: Scalars['String'];
  myRSVP?: Maybe<EventRsvpStatus>;
  recommendedByIcons: Array<Scalars['String']>;
  recommendedByText: Scalars['String'];
  start?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  venueName?: Maybe<Scalars['String']>;
  webLink?: Maybe<Scalars['String']>;
};

export type DisplayEventCategory = {
  __typename?: 'DisplayEventCategory';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DisplayEventInfo = {
  __typename?: 'DisplayEventInfo';
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  location: Scalars['String'];
  locationDisplayCompact: Scalars['String'];
  locationDisplayFull: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  start?: Maybe<Scalars['DateTime']>;
};

export type DisplayFeedFestivalTrack = {
  __typename?: 'DisplayFeedFestivalTrack';
  artist?: Maybe<Scalars['String']>;
  coverUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  duration: Scalars['Int'];
  id: Scalars['ID'];
  inAppUrl: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  type: TrackType;
};

export type DisplayFeedReleaseTrack = {
  __typename?: 'DisplayFeedReleaseTrack';
  artist?: Maybe<Scalars['String']>;
  community: FeedReleasesTrackCommunity;
  coverUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  duration: Scalars['Int'];
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  inAppUrl: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  type: TrackType;
};

export type DisplayGuestListCommunity = {
  __typename?: 'DisplayGuestListCommunity';
  code?: Maybe<Scalars['String']>;
  globalInviteCode?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type DisplayGuestListEvent = {
  __typename?: 'DisplayGuestListEvent';
  community?: Maybe<DisplayGuestListCommunity>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  locationAvailable?: Maybe<Scalars['Boolean']>;
  locationDisplayFull?: Maybe<Scalars['String']>;
  mediaUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  venue?: Maybe<Scalars['String']>;
};

export type DisplayGuestListInvite = {
  __typename?: 'DisplayGuestListInvite';
  claimerId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayStatus?: Maybe<Scalars['Json']>;
  event?: Maybe<DisplayGuestListEvent>;
  eventId?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['Json']>;
  numPlus?: Maybe<Scalars['Int']>;
  plusGuests: Array<DisplayGuestListPlusGuest>;
  productName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type DisplayGuestListPlusGuest = {
  __typename?: 'DisplayGuestListPlusGuest';
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type DisplayInterest = {
  __typename?: 'DisplayInterest';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type DisplayInterestCategory = {
  __typename?: 'DisplayInterestCategory';
  id?: Maybe<Scalars['String']>;
  mediaUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subcategories: Array<Maybe<DisplayInterestSubcategory>>;
};

export type DisplayInterestSubcategory = {
  __typename?: 'DisplayInterestSubcategory';
  id?: Maybe<Scalars['String']>;
  interests: Array<Maybe<DisplayInterest>>;
  name?: Maybe<Scalars['String']>;
};

export type DisplayMapLocation = {
  __typename?: 'DisplayMapLocation';
  additionalInfo?: Maybe<Scalars['String']>;
  additionalInfoUrl?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['Json']>;
  catalogItemSchedules: Array<MapLocationEvent>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  markerStyleOverride?: Maybe<Scalars['Json']>;
  markerUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  timezone: Scalars['String'];
  type: Scalars['String'];
};

export type DisplayMembershipCommunity = {
  __typename?: 'DisplayMembershipCommunity';
  currency: Scalars['String'];
  name: Scalars['String'];
};

export type DisplayMembershipProduct = {
  __typename?: 'DisplayMembershipProduct';
  community?: Maybe<DisplayMembershipCommunity>;
  id: Scalars['ID'];
  name: Scalars['String'];
  price: Scalars['Float'];
};

export type DisplayPaidMembership = {
  __typename?: 'DisplayPaidMembership';
  currentPeriodEnd?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  product?: Maybe<DisplayMembershipProduct>;
  status: Scalars['String'];
  stripeSubscriptionId?: Maybe<Scalars['String']>;
};

export type DisplayReaction = {
  __typename?: 'DisplayReaction';
  count: Scalars['Int'];
  displayChar: Scalars['String'];
  isMine: Scalars['Boolean'];
  reactionType: Scalars['String'];
};

export type DisplayReviewEvent = {
  __typename?: 'DisplayReviewEvent';
  additionalDetails?: Maybe<Scalars['String']>;
  categories: Array<DisplayEventCategory>;
  communityCode?: Maybe<Scalars['String']>;
  communityId: Scalars['String'];
  communityName: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  mediaUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sourceCategory?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  venueName?: Maybe<Scalars['String']>;
};

export type DisplayReviewRelease = {
  __typename?: 'DisplayReviewRelease';
  artist?: Maybe<Scalars['String']>;
  bandcampArtist?: Maybe<Scalars['String']>;
  bandcampEmbedUrl?: Maybe<Scalars['String']>;
  bandcampReleaseTitle?: Maybe<Scalars['String']>;
  bandcampTrackSource?: Maybe<Scalars['String']>;
  bandcampTrackTitle?: Maybe<Scalars['String']>;
  bandcampUrl?: Maybe<Scalars['String']>;
  categoryLabel?: Maybe<Scalars['String']>;
  communityId: Scalars['String'];
  communityName: Scalars['String'];
  coverUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  id: Scalars['String'];
  matchConfidence?: Maybe<Scalars['Float']>;
  soundcloudArtist?: Maybe<Scalars['String']>;
  soundcloudTrackTitle?: Maybe<Scalars['String']>;
  soundcloudUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type DisplayScheduleCuration = {
  __typename?: 'DisplayScheduleCuration';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mediaUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type DisplayScheduleItem = {
  __typename?: 'DisplayScheduleItem';
  addedToCalendar: Scalars['Boolean'];
  catalogItemId?: Maybe<Scalars['String']>;
  dayOverride?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  horizontalStyleOverride?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  mediaUrl?: Maybe<Scalars['String']>;
  myRsvp?: Maybe<ScheduleItemRsvpStatus>;
  name?: Maybe<Scalars['String']>;
  stageName?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
};

export type DisplayShortcut = {
  __typename?: 'DisplayShortcut';
  config?: Maybe<Scalars['Json']>;
  deeplink: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mediaUrl: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type DisplaySubscription = {
  __typename?: 'DisplaySubscription';
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  communityIconUrl?: Maybe<Scalars['String']>;
  communityName?: Maybe<Scalars['String']>;
  currentPeriodEnd?: Maybe<Scalars['DateTime']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']>;
  displayPaymentMethod?: Maybe<Scalars['String']>;
  displayPrice?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  productDescription?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  recurringInterval?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type DisplayTag = {
  __typename?: 'DisplayTag';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DisplayTagCategory = {
  __typename?: 'DisplayTagCategory';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  tags: Array<DisplayTag>;
};

export type EmailActivityUser = {
  __typename?: 'EmailActivityUser';
  avatar?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
};

export type EmailCampaign = {
  __typename?: 'EmailCampaign';
  canEditDesign: Scalars['Boolean'];
  clicks: Scalars['Int'];
  community?: Maybe<Community>;
  communityId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customUserIds?: Maybe<Scalars['String']>;
  delivered: Scalars['Int'];
  eventId?: Maybe<Scalars['String']>;
  eventName?: Maybe<Scalars['String']>;
  htmlDesign?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  immediateSend: Scalars['Boolean'];
  includeUnverifiedEmails: Scalars['Boolean'];
  jsonDesign: Scalars['Json'];
  name: Scalars['String'];
  /** Unique opens as a share of delivered emails; null when nothing was delivered */
  openRate?: Maybe<Scalars['Float']>;
  opens: Scalars['Int'];
  replyTo?: Maybe<Scalars['String']>;
  segment: EmailCampaignSegment;
  sendAt?: Maybe<Scalars['DateTime']>;
  senderEmail: Scalars['String'];
  status: EmailCampaignStatus;
  subject: Scalars['String'];
  totalUsers: Scalars['Int'];
  unsubscribes: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type EmailCampaignActivity = {
  __typename?: 'EmailCampaignActivity';
  clicked: Scalars['Int'];
  delivered: Scalars['Int'];
  opened: Scalars['Int'];
  total: Scalars['Int'];
  unsubscribed: Scalars['Int'];
};

export type EmailCampaignActivityItem = {
  __typename?: 'EmailCampaignActivityItem';
  createdAt: Scalars['DateTime'];
  geo: Scalars['String'];
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  platform: Scalars['String'];
  type: Scalars['String'];
  user?: Maybe<EmailActivityUser>;
};

export type EmailCampaignActivityResult = {
  __typename?: 'EmailCampaignActivityResult';
  items: Array<EmailCampaignActivityItem>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type EmailCampaignDetails = {
  __typename?: 'EmailCampaignDetails';
  createdOn: Scalars['DateTime'];
  senderAddress: Scalars['String'];
  sentOn?: Maybe<Scalars['DateTime']>;
  subject: Scalars['String'];
};

export enum EmailCampaignSegment {
  CommunityMembers = 'CommunityMembers',
  Custom = 'Custom',
  CustomEmails = 'CustomEmails',
  EventAttendees = 'EventAttendees',
  EventCheckedIn = 'EventCheckedIn',
  EventRegistered = 'EventRegistered'
}

export type EmailCampaignStats = {
  __typename?: 'EmailCampaignStats';
  activity: EmailCampaignActivity;
  details: EmailCampaignDetails;
};

export enum EmailCampaignStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  FailedScheduling = 'FailedScheduling',
  Scheduled = 'Scheduled',
  SendingInProgress = 'SendingInProgress',
  Sent = 'Sent',
  WaitingForApproval = 'WaitingForApproval'
}

export type Event = {
  __typename?: 'Event';
  additionalConfig: Scalars['Json'];
  additionalDetails?: Maybe<Scalars['String']>;
  allowFreeGuestList: Scalars['Boolean'];
  arrivedViaSlug?: Maybe<Scalars['String']>;
  attendeesInfo: Scalars['Json'];
  buyTicketsLink?: Maybe<Scalars['String']>;
  calendarSeen: Scalars['Boolean'];
  categories: Array<EventCategory>;
  checkedInCount: Scalars['Int'];
  checkedInUsers: Array<User>;
  /** Consent checkboxes / questions required at checkout for this event's tickets. Same field schema as Community.joinRequirements. Null when none are configured. */
  checkoutRequirements?: Maybe<Scalars['Json']>;
  connectedEvents: Array<Event>;
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  curatorsInfo: Scalars['Json'];
  displayGrossRevenue?: Maybe<Scalars['String']>;
  /** Configuration version from this admin read snapshot; null on other Event paths. */
  editVersion?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  feed: Array<FeedItem>;
  freeGuestListProductId?: Maybe<Scalars['String']>;
  grossRevenue?: Maybe<Scalars['Float']>;
  hasTicketsOrLink: Scalars['Boolean'];
  host?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  infoStepsComplete: Scalars['Int'];
  /** @deprecated Returns an empty list. Who an event invited is not public. */
  invitedUsers: Array<User>;
  isLocked: Scalars['Boolean'];
  isMaster: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  /** Legacy location field. New clients should use locationDisplayCompact/locationDisplayFull for UI display. */
  location: Scalars['String'];
  locationAvailability: EventLocationAvailability;
  locationAvailable: Scalars['Boolean'];
  locationDescription?: Maybe<Scalars['String']>;
  /** Short event location display value, usually the venue name with address/location fallback. */
  locationDisplayCompact: Scalars['String'];
  /** Long event location display value, usually venue name plus address without duplication. */
  locationDisplayFull: Scalars['String'];
  locationDropNotificationSent?: Maybe<Scalars['Boolean']>;
  locationDropTime?: Maybe<Scalars['DateTime']>;
  locationSubtitle: Scalars['String'];
  longitude?: Maybe<Scalars['Float']>;
  meRegistered?: Maybe<Scalars['Boolean']>;
  meRsvp?: Maybe<EventRsvpStatus>;
  meTicketed?: Maybe<Scalars['Boolean']>;
  mediaUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentCommunity: Community;
  parentCommunityId: Scalars['String'];
  potentialRevenue?: Maybe<Scalars['Float']>;
  prePurchaseCode?: Maybe<Scalars['String']>;
  productEditVersion?: Maybe<Scalars['String']>;
  products: Array<Product>;
  publishingStatus: EventStatus;
  /** @deprecated Returns an empty list. Use eventRecommendedBy, which applies members' display settings. */
  recommendedBy: Array<User>;
  registerLink?: Maybe<Scalars['String']>;
  /** @deprecated Returns an empty list. Who registered for an event is not public. */
  registeredUsers: Array<User>;
  registrationRequired: Scalars['Boolean'];
  registrationState: Scalars['String'];
  relatedCommunities: Array<Community>;
  shouldInviteCommunityMembersAutomatically: Scalars['Boolean'];
  start?: Maybe<Scalars['DateTime']>;
  styleOverride: Scalars['Json'];
  swapMinPrice?: Maybe<Scalars['String']>;
  /** Ticket-bar presentation and navigation resolved from availability and community Shop policy */
  ticketBar?: Maybe<EventTicketBar>;
  ticketState: Scalars['String'];
  /** @deprecated Returns an empty list. Who holds a ticket is not public. */
  ticketedUsers: Array<User>;
  /**
   * Returns formatted price string if ticket bar should show, null to hide
   * @deprecated Use ticketBar.buttonCTA instead.
   */
  ticketsBarInfo?: Maybe<Scalars['String']>;
  ticketsSold: Scalars['Int'];
  ticketsTotal?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  totalTicketsOverride?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  /** Venue label/name. Event.location stores the address-ish value going forward. */
  venueName?: Maybe<Scalars['String']>;
  webLink?: Maybe<Scalars['String']>;
};


export type EventRegisteredUsersArgs = {
  where?: InputMaybe<UserWhereEqualsInput>;
};


export type EventTicketedUsersArgs = {
  where?: InputMaybe<UserWhereEqualsInput>;
};

export type EventAttendees = {
  __typename?: 'EventAttendees';
  attendees: Array<User>;
  next: Scalars['Int'];
  totalAttendees: Scalars['Int'];
};

export type EventCategory = {
  __typename?: 'EventCategory';
  createdAt: Scalars['DateTime'];
  /** @deprecated Returns an empty list. A category spans every community's events. */
  events: Array<Event>;
  id: Scalars['String'];
  name: Scalars['String'];
  styleOverride: Scalars['Json'];
  updatedAt: Scalars['DateTime'];
};

export enum EventLocationAvailability {
  Public = 'Public',
  Registered = 'Registered',
  Ticketed = 'Ticketed'
}

export type EventOrderByInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type EventRecommendedBy = {
  __typename?: 'EventRecommendedBy';
  next: Scalars['Int'];
  total: Scalars['Int'];
  users: Array<RecommendedByUser>;
};

export enum EventRsvpStatus {
  Going = 'Going',
  Interested = 'Interested',
  NotInterested = 'NotInterested'
}

export type EventSalesStatsEvent = {
  __typename?: 'EventSalesStatsEvent';
  currency: SupportedCurrencies;
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  mediaUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  start?: Maybe<Scalars['DateTime']>;
  ticketsSold: Scalars['Int'];
  ticketsTotal: Scalars['Int'];
  totalRevenue: Scalars['Float'];
};

export type EventSalesStatsResponse = {
  __typename?: 'EventSalesStatsResponse';
  event: EventSalesStatsEvent;
  ticketTiers: Array<EventSalesStatsTicketTier>;
};

export type EventSalesStatsTicketTier = {
  __typename?: 'EventSalesStatsTicketTier';
  currency: SupportedCurrencies;
  id: Scalars['ID'];
  name: Scalars['String'];
  price: Scalars['Float'];
  ticketsSold: Scalars['Int'];
  ticketsTotal: Scalars['Int'];
  totalRevenue: Scalars['Float'];
};

export enum EventStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  CompletedDraft = 'CompletedDraft',
  Deleted = 'Deleted',
  Draft = 'Draft',
  ImportFailed = 'ImportFailed',
  Importing = 'Importing',
  PendingReview = 'PendingReview',
  Rejected = 'Rejected',
  UneditedDraft = 'UneditedDraft'
}

export type EventStatusFilter = {
  equals?: InputMaybe<EventStatus>;
};

export type EventTicketBar = {
  __typename?: 'EventTicketBar';
  /** Text beside the button: the cheapest price, External tickets or Sold out */
  buttonCTA: Scalars['String'];
  /** The button's label: Get tickets, or Go to shop once every ticket is sold out */
  buttonText: Scalars['String'];
  destination: TicketBarDestination;
};

export type EventWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EventWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventWhereInput>>>;
  end?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserListRelationFilter>;
  isMaster?: InputMaybe<BooleanFilter2>;
  isPrivate?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<Scalars['String']>;
  parentCommunityId?: InputMaybe<StringFilter>;
  publishingStatus?: InputMaybe<EventStatusFilter>;
  relatedCommunities?: InputMaybe<CommunityListRelationFilter>;
};

export type EventWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type EventWhereUniqueInput2 = {
  id?: InputMaybe<Scalars['String']>;
};

export type EventWithProducts = {
  __typename?: 'EventWithProducts';
  buyTicketsLink?: Maybe<Scalars['String']>;
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  location: Scalars['String'];
  locationDisplayCompact: Scalars['String'];
  name: Scalars['String'];
  products: Array<Product>;
  start: Scalars['DateTime'];
};

export type EventWithTicketsResponse = {
  __typename?: 'EventWithTicketsResponse';
  eventInfo: DisplayEventInfo;
  products: Array<Product>;
  requestBundleProducts: Array<Product>;
  showGotCode: Scalars['Boolean'];
};

export type EventsV2Response = {
  __typename?: 'EventsV2Response';
  items: Array<Event>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type ExploreCommunitiesResponse = {
  __typename?: 'ExploreCommunitiesResponse';
  items: Array<ExploreCommunity>;
  next: Scalars['Int'];
  onboardingConfig: JoinCommunitiesConfig;
  total: Scalars['Int'];
};

export enum ExploreCommunitiesSource {
  HandpickedExplore = 'HandpickedExplore',
  SignUp = 'SignUp',
  UbiqExploreHorizontal = 'UbiqExploreHorizontal',
  UbiqExploreVertical = 'UbiqExploreVertical'
}

export type ExploreCommunity = {
  __typename?: 'ExploreCommunity';
  allowJoin: Scalars['Boolean'];
  allowOpen: Scalars['Boolean'];
  communityCode: Scalars['String'];
  communityDescription?: Maybe<Scalars['String']>;
  communityExploreMedia: Array<Scalars['String']>;
  communityExploreMediaUrl?: Maybe<Scalars['String']>;
  communityIconUrl: Scalars['String'];
  communityInviteCode: Scalars['String'];
  communityName: Scalars['String'];
  communityShortDescription?: Maybe<Scalars['String']>;
  membershipStatus: Scalars['String'];
  requestToJoin: Scalars['Boolean'];
};

export type ExploreShortcuts = {
  __typename?: 'ExploreShortcuts';
  items: Array<DisplayShortcut>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type FaqCategory = {
  __typename?: 'FaqCategory';
  externalId?: Maybe<Scalars['String']>;
  faqItems: Array<FaqItem>;
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Int'];
  parentCommunity?: Maybe<Community>;
  parentCommunityId?: Maybe<Scalars['String']>;
  publishingStatus: UnifiedPublishingStatus;
};

export type FaqItem = {
  __typename?: 'FaqItem';
  answer: Scalars['String'];
  category?: Maybe<FaqCategory>;
  categoryId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  parentCommunity?: Maybe<Community>;
  parentCommunityId?: Maybe<Scalars['String']>;
  publishingStatus: UnifiedPublishingStatus;
  question: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type FeaturedItem = {
  __typename?: 'FeaturedItem';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inAppLink: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  price: Scalars['String'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
};

export type FeedBanner = {
  __typename?: 'FeedBanner';
  actionUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  stylingConfig: Scalars['Json'];
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type FeedEventsViewResponse = {
  __typename?: 'FeedEventsViewResponse';
  items: Array<DisplayEvent>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type FeedFestivalNavShortcut = {
  __typename?: 'FeedFestivalNavShortcut';
  iconUrl?: Maybe<Scalars['String']>;
  inAppUrl: Scalars['String'];
  label: Scalars['String'];
};

export type FeedFestivalResponse = {
  __typename?: 'FeedFestivalResponse';
  sections: Array<FeedFestivalSection>;
  timezone: Scalars['String'];
};

export type FeedFestivalScheduleItem = {
  __typename?: 'FeedFestivalScheduleItem';
  addedToCalendar: Scalars['Boolean'];
  attendeesCount: Scalars['Int'];
  attendeesIcons: Array<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  inAppUrl: Scalars['String'];
  locationName: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  myRsvp?: Maybe<ScheduleItemRsvpStatus>;
  name: Scalars['String'];
  start?: Maybe<Scalars['DateTime']>;
};

export type FeedFestivalSection = {
  __typename?: 'FeedFestivalSection';
  actionUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageOverlayOpacity?: Maybe<Scalars['Float']>;
  imageUrl?: Maybe<Scalars['String']>;
  navShortcuts: Array<FeedFestivalNavShortcut>;
  playableTrack?: Maybe<DisplayFeedFestivalTrack>;
  scheduleItems: Array<FeedFestivalScheduleItem>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  tracks: Array<DisplayFeedFestivalTrack>;
  type: FeedFestivalSectionType;
};

export enum FeedFestivalSectionType {
  BannerLink = 'BANNER_LINK',
  ModuleGrid = 'MODULE_GRID',
  ScheduleCarousel = 'SCHEDULE_CAROUSEL',
  ScheduleList = 'SCHEDULE_LIST',
  TrackList = 'TRACK_LIST'
}

export type FeedItem = {
  __typename?: 'FeedItem';
  author?: Maybe<Scalars['String']>;
  commentsCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  ctaButtonTitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  downvoted: Array<Event>;
  downvotes?: Maybe<Scalars['Int']>;
  events: Array<Event>;
  externalUrl?: Maybe<Scalars['String']>;
  headlineType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  liked?: Maybe<Scalars['Boolean']>;
  likesBoost: Scalars['Int'];
  likesCount?: Maybe<Scalars['Int']>;
  media: Array<Scalars['String']>;
  mediaHeight?: Maybe<Scalars['Int']>;
  mediaPreviewUrl?: Maybe<Scalars['String']>;
  mediaUrl?: Maybe<Scalars['String']>;
  mediaWidth?: Maybe<Scalars['Int']>;
  missingFields: Array<Scalars['String']>;
  parentCommunity: Community;
  parentCommunityId: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishingStatus: FeedItemPublishingStatus;
  revision: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  trailerLink?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  upvoted: Array<Event>;
  upvotes?: Maybe<Scalars['Int']>;
  /** People who saw the item's card or opened it in the app; community admins only. */
  viewsCount?: Maybe<Scalars['Int']>;
  watchLink?: Maybe<Scalars['String']>;
};

export type FeedItemComment = {
  __typename?: 'FeedItemComment';
  author: User;
  authorId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  feedItem: FeedItem;
  feedItemId: Scalars['String'];
  id: Scalars['String'];
  liked?: Maybe<Scalars['Boolean']>;
  likesCount?: Maybe<Scalars['Int']>;
  media: Array<Scalars['String']>;
  parentCommentId?: Maybe<Scalars['String']>;
  replies: Array<FeedItemComment>;
  status: FeedItemCommentStatus;
  text: Scalars['String'];
};

export type FeedItemCommentReport = {
  __typename?: 'FeedItemCommentReport';
  author: User;
  authorId: Scalars['String'];
  comment: FeedItemComment;
  commentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  reason: Scalars['String'];
  status: FeedItemCommentReportStatus;
};

export enum FeedItemCommentReportStatus {
  Approved = 'Approved',
  Declined = 'Declined',
  Submitted = 'Submitted'
}

export enum FeedItemCommentStatus {
  Deleted = 'Deleted',
  Hidden = 'Hidden',
  Published = 'Published'
}

export type FeedItemComments = {
  __typename?: 'FeedItemComments';
  comments: Array<FeedItemComment>;
  next: Scalars['Int'];
  totalComments: Scalars['Int'];
};

export type FeedItemEventInfo = {
  __typename?: 'FeedItemEventInfo';
  attendeesCount: Scalars['Int'];
  attendeesIcons: Array<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
  myRSVP?: Maybe<EventRsvpStatus>;
  recommendedByIcons: Array<Scalars['String']>;
  recommendedByText: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export enum FeedItemPublishingStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Published = 'Published',
  UneditedDraft = 'UneditedDraft'
}

export type FeedNewsViewCommunity = {
  __typename?: 'FeedNewsViewCommunity';
  code?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type FeedNewsViewItem = {
  __typename?: 'FeedNewsViewItem';
  commentsCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  liked: Scalars['Boolean'];
  likesCount: Scalars['Int'];
  media: Array<Scalars['String']>;
  mediaPreviewUrl?: Maybe<Scalars['String']>;
  parentCommunity: FeedNewsViewCommunity;
  title: Scalars['String'];
};

export type FeedNewsViewResponse = {
  __typename?: 'FeedNewsViewResponse';
  items: Array<FeedNewsViewItem>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type FeedReleasesResponse = {
  __typename?: 'FeedReleasesResponse';
  sections: Array<FeedReleasesSection>;
};

export type FeedReleasesSection = {
  __typename?: 'FeedReleasesSection';
  actionUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  playableTrack?: Maybe<DisplayFeedReleaseTrack>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  tracks: Array<DisplayFeedReleaseTrack>;
  type: FeedReleasesSectionType;
};

export enum FeedReleasesSectionType {
  BannerLink = 'BANNER_LINK',
  TrackCoverCarousel = 'TRACK_COVER_CAROUSEL',
  TrackGrid = 'TRACK_GRID',
  TrackList = 'TRACK_LIST'
}

export type FeedReleasesTrackCommunity = {
  __typename?: 'FeedReleasesTrackCommunity';
  code?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type FeedSpecialItem = {
  __typename?: 'FeedSpecialItem';
  config?: Maybe<Scalars['Json']>;
  index: Scalars['Int'];
  type: Scalars['String'];
};

export type FeedView = {
  __typename?: 'FeedView';
  communityCode?: Maybe<Scalars['String']>;
  communityIconUrl?: Maybe<Scalars['String']>;
  communityName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isSuggestedDefault?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  type: Scalars['String'];
};

export type FestivalCalendarDay = {
  __typename?: 'FestivalCalendarDay';
  date: Scalars['String'];
  events: Array<FestivalCalendarEvent>;
};

export type FestivalCalendarEvent = {
  __typename?: 'FestivalCalendarEvent';
  addedToCalendar: Scalars['Boolean'];
  catalogItemId?: Maybe<Scalars['String']>;
  dayOverride?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mediaUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  stageName: Scalars['String'];
  start?: Maybe<Scalars['DateTime']>;
};

export type FestivalCalendarEventsResponse = {
  __typename?: 'FestivalCalendarEventsResponse';
  days: Array<FestivalCalendarDay>;
  timezone: Scalars['String'];
};

export type FestivalDay = {
  __typename?: 'FestivalDay';
  date: Scalars['String'];
  dayLabel: Scalars['String'];
};

export type FestivalSeasonItem = {
  __typename?: 'FestivalSeasonItem';
  communityCode: Scalars['String'];
  communityIconUrl: Scalars['String'];
  communityInviteCode: Scalars['String'];
  description: Scalars['String'];
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  location: Scalars['String'];
  mediaHeight: Scalars['Int'];
  mediaUrl: Scalars['String'];
  products: Array<FestivalSeasonProduct>;
  start: Scalars['DateTime'];
  talksMessageText?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type FestivalSeasonProduct = {
  __typename?: 'FestivalSeasonProduct';
  ctaText?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  hasPromocode?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  mediaUrl: Scalars['String'];
  name: Scalars['String'];
  originalPrice?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  shopAccessCode?: Maybe<Scalars['String']>;
};

export type ForumComment = {
  __typename?: 'ForumComment';
  author: User;
  authorId: Scalars['String'];
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  liked: Scalars['Boolean'];
  likesCount: Scalars['Int'];
  media: Array<Scalars['String']>;
  parentCommentId?: Maybe<Scalars['String']>;
  post: ForumPost;
  postId: Scalars['String'];
  replies: Array<ForumComment>;
  status: ForumCommentStatus;
  updatedAt: Scalars['DateTime'];
};

export enum ForumCommentStatus {
  Deleted = 'Deleted',
  Hidden = 'Hidden',
  Published = 'Published',
  Reported = 'Reported'
}

export type ForumContentReport = {
  __typename?: 'ForumContentReport';
  authorId: Scalars['String'];
  comment?: Maybe<ForumComment>;
  commentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  post?: Maybe<ForumPost>;
  postId?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  status: ForumContentReportStatus;
  updatedAt: Scalars['DateTime'];
};

export enum ForumContentReportStatus {
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Submitted = 'Submitted'
}

export type ForumPost = {
  __typename?: 'ForumPost';
  author: User;
  authorId: Scalars['String'];
  commentsAndRepliesCount: Scalars['Int'];
  commentsCount: Scalars['Int'];
  community: Community;
  communityId: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  headline?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  liked: Scalars['Boolean'];
  likesBoost: Scalars['Int'];
  likesCount: Scalars['Int'];
  media: Array<Scalars['String']>;
  publishingStatus: ForumPostPublishingStatus;
  tags: Array<ForumTag>;
  updatedAt: Scalars['DateTime'];
};

export type ForumPostCommentsReturn = {
  __typename?: 'ForumPostCommentsReturn';
  comments: Array<ForumComment>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export enum ForumPostPublishingStatus {
  Deleted = 'Deleted',
  Hidden = 'Hidden',
  Pending = 'Pending',
  Published = 'Published',
  Reported = 'Reported',
  UneditedDraft = 'UneditedDraft'
}

export type ForumPostsReturn = {
  __typename?: 'ForumPostsReturn';
  allTags: Array<ForumTag>;
  next: Scalars['Int'];
  posts: Array<ForumPost>;
  total: Scalars['Int'];
};

export type ForumTag = {
  __typename?: 'ForumTag';
  community: Community;
  communityId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  posts: Array<ForumPost>;
  updatedAt: Scalars['DateTime'];
};

export enum GuestListInviteMethod {
  Email = 'Email',
  Link = 'Link',
  Member = 'Member'
}

export enum GuestListInviteStatus {
  Claimed = 'Claimed',
  Created = 'Created',
  Deleted = 'Deleted',
  Expired = 'Expired',
  Opened = 'Opened',
  Shared = 'Shared'
}

export type GuestListInvites = {
  __typename?: 'GuestListInvites';
  items: Array<DisplayGuestListInvite>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export enum HeadlineType {
  Picture = 'Picture',
  Video = 'Video'
}

export type IdentityQrToken = {
  __typename?: 'IdentityQrToken';
  expiresAt: Scalars['DateTime'];
  validFrom: Scalars['DateTime'];
  value: Scalars['String'];
};

export type IdentityQrTokenBatch = {
  __typename?: 'IdentityQrTokenBatch';
  serverTime: Scalars['DateTime'];
  subjectId: Scalars['ID'];
  tokens: Array<IdentityQrToken>;
};

export enum InstagramCommentAction {
  Delete = 'Delete',
  Hide = 'Hide',
  Reply = 'Reply',
  Unhide = 'Unhide'
}

export enum InstagramFeature {
  Comments = 'comments',
  Insights = 'insights',
  Messages = 'messages'
}

export type InstajumpIndividual = {
  __typename?: 'InstajumpIndividual';
  city: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type InstajumpOrganization = {
  __typename?: 'InstajumpOrganization';
  id: Scalars['ID'];
  logoDesktopHeight?: Maybe<Scalars['Int']>;
  logoDesktopWidth?: Maybe<Scalars['Int']>;
  logoMobileHeight?: Maybe<Scalars['Int']>;
  logoMobileWidth?: Maybe<Scalars['Int']>;
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  websiteUrl?: Maybe<Scalars['String']>;
};

export type InstajumpSigneesResponse = {
  __typename?: 'InstajumpSigneesResponse';
  individuals: Array<InstajumpIndividual>;
  organizations: Array<InstajumpOrganization>;
};

export type Interest = {
  __typename?: 'Interest';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type InventoryReturnType = {
  __typename?: 'InventoryReturnType';
  active?: Maybe<Array<Maybe<Purchase>>>;
  expired?: Maybe<Array<Maybe<Purchase>>>;
};

export type InventorySendInvite = {
  __typename?: 'InventorySendInvite';
  errors?: Maybe<Array<Maybe<TranslatableError>>>;
  success: Scalars['Boolean'];
};

export type InviteCode = {
  __typename?: 'InviteCode';
  additionalConfiguration: Scalars['Json'];
  claimedAt?: Maybe<Scalars['DateTime']>;
  claimer?: Maybe<User>;
  claimerId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  community: Community;
  communityId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['String']>;
  reservedFor?: Maybe<Scalars['String']>;
  type: InviteCodeType;
  updatedAt: Scalars['DateTime'];
};

export enum InviteCodeType {
  Invalid = 'Invalid',
  Permanent = 'Permanent',
  Personalized = 'Personalized'
}

export enum InviteFriendsAction {
  Close = 'Close',
  Continue = 'Continue',
  Opened = 'Opened',
  ShareOpened = 'ShareOpened',
  Skip = 'Skip',
  StartSlot = 'StartSlot'
}

export type InviteFriendsPromptPage = {
  __typename?: 'InviteFriendsPromptPage';
  communityCode?: Maybe<Scalars['String']>;
  communityId: Scalars['String'];
  slotCount: Scalars['Int'];
  slots: Array<InviteFriendsSlot>;
  slotsHelperText: Scalars['String'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
};

export type InviteFriendsSlot = {
  __typename?: 'InviteFriendsSlot';
  claimedAt?: Maybe<Scalars['DateTime']>;
  claimerId?: Maybe<Scalars['String']>;
  inviteCode?: Maybe<Scalars['String']>;
  inviteCodeId?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  slotId: Scalars['String'];
  status: Scalars['String'];
};

export type JoinCommunitiesConfig = {
  __typename?: 'JoinCommunitiesConfig';
  initialMessage?: Maybe<Scalars['String']>;
  numRequiredCommunities?: Maybe<Scalars['Int']>;
};

export type JoinCommunityReturnType = {
  __typename?: 'JoinCommunityReturnType';
  communities?: Maybe<Array<Community>>;
  communityToJoin?: Maybe<Community>;
  joinRequirements?: Maybe<Scalars['Json']>;
  missingInfo?: Maybe<Array<Maybe<UserInfoField>>>;
  requestToJoinSubmitted?: Maybe<Scalars['Boolean']>;
};

export type JoinWaitlistResult = {
  __typename?: 'JoinWaitlistResult';
  alreadyOnWaitlist: Scalars['Boolean'];
  success: Scalars['Boolean'];
};

export type KeyMetricsData = {
  __typename?: 'KeyMetricsData';
  totalPurchases?: Maybe<Scalars['Int']>;
  usedCount?: Maybe<Scalars['Int']>;
};

export type Location = {
  __typename?: 'Location';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  sublocations: Array<Scalars['String']>;
  supported: Scalars['Boolean'];
  ubiqFeedItems?: Maybe<Array<Maybe<UbiqFeedItem>>>;
  updatedAt: Scalars['DateTime'];
  /** @deprecated Returns an empty list. Who lives in a city is not public. */
  users?: Maybe<Array<Maybe<User>>>;
};

export type MapLocationEvent = {
  __typename?: 'MapLocationEvent';
  artistId?: Maybe<Scalars['String']>;
  dayOverride?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mediaUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  start?: Maybe<Scalars['DateTime']>;
};

export type MarkInviteFriendsLinkOpenedPayload = {
  __typename?: 'MarkInviteFriendsLinkOpenedPayload';
  tracked: Scalars['Boolean'];
};

export type MarkInviteFriendsPromptActionPayload = {
  __typename?: 'MarkInviteFriendsPromptActionPayload';
  inviteCode?: Maybe<Scalars['String']>;
  inviteCodeId?: Maybe<Scalars['String']>;
  inviteUrl?: Maybe<Scalars['String']>;
  page?: Maybe<InviteFriendsPromptPage>;
  prompt: Scalars['Boolean'];
  shareMessage?: Maybe<Scalars['String']>;
  slotId?: Maybe<Scalars['String']>;
};

export type MarkPromptActionPayload = {
  __typename?: 'MarkPromptActionPayload';
  prompt?: Maybe<UserPrompt>;
};

export type MassMessage = {
  __typename?: 'MassMessage';
  actionDeepLink: Scalars['String'];
  /** Whether an audience is chosen; before it, the counts and shares mean nothing */
  audienceSet: Scalars['Boolean'];
  chunkInterval: Scalars['Int'];
  chunkSize: Scalars['Int'];
  /** totalClicks as a share of delivered, at most 1; null when delivered is 0 */
  clickRate?: Maybe<Scalars['Float']>;
  community?: Maybe<Community>;
  createdAt: Scalars['DateTime'];
  customSegmentUserIds?: Maybe<Scalars['String']>;
  /** The people Expo delivered it to; the push-enabled count when it has no Expo records */
  delivered: Scalars['Int'];
  editVersion: Scalars['String'];
  event?: Maybe<Event>;
  id: Scalars['String'];
  immediateSend: Scalars['Boolean'];
  linkedDisplayInfo: Scalars['String'];
  linkedItemId?: Maybe<Scalars['String']>;
  linkedModule?: Maybe<Module>;
  message: Scalars['String'];
  missingFields: Array<Scalars['String']>;
  name: Scalars['String'];
  onesignalIds: Array<Scalars['String']>;
  onesignalUrls: Array<Scalars['String']>;
  rejectionReason?: Maybe<Scalars['String']>;
  segment?: Maybe<MassMessageSegment>;
  segmentId?: Maybe<Scalars['String']>;
  sendAt?: Maybe<Scalars['DateTime']>;
  status: MassMessageStatus;
  talksMessageText?: Maybe<Scalars['String']>;
  talksMessageType?: Maybe<TalksMessageType>;
  title: Scalars['String'];
  /** Clicks: OneSignal clicks on older pushes plus people who tapped an Expo push; not unique people across both. */
  totalClicks: Scalars['Int'];
  totalPushIds: Scalars['Int'];
  /** Stored count of accounts with push notifications enabled; not confirmed delivery. */
  totalReceivers: Scalars['Int'];
  /** Stored selected audience account count; not device delivery. */
  totalUsers: Scalars['Int'];
  type: MassMessageType;
  updatedAt: Scalars['DateTime'];
};

export enum MassMessageSegment {
  CommunityMembers = 'CommunityMembers',
  Custom = 'Custom',
  EventCheckedIn = 'EventCheckedIn',
  EventInvited = 'EventInvited',
  EventInvitedNoTicket = 'EventInvitedNoTicket',
  EventMultipleTickets = 'EventMultipleTickets',
  EventRegistered = 'EventRegistered',
  EventRegisteredNoTicket = 'EventRegisteredNoTicket',
  EventTicketed = 'EventTicketed',
  SegmentMembers = 'SegmentMembers'
}

export enum MassMessageStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  FailedScheduling = 'FailedScheduling',
  PendingScheduling = 'PendingScheduling',
  Rejected = 'Rejected',
  Scheduled = 'Scheduled',
  Sent = 'Sent',
  UneditedDraft = 'UneditedDraft',
  WaitingForApproval = 'WaitingForApproval'
}

export enum MassMessageType {
  LocationDropped = 'LocationDropped',
  Manual = 'Manual'
}

export type MatchAnswerInput = {
  optionKey: Scalars['String'];
  questionKey: Scalars['String'];
};

export type MatchCandidateProfile = {
  __typename?: 'MatchCandidateProfile';
  age?: Maybe<Scalars['Int']>;
  displayName: Scalars['String'];
  elevatorPitch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  photos: Array<Scalars['String']>;
  pronouns?: Maybe<Scalars['String']>;
};

export type MatchDiscoveryState = {
  __typename?: 'MatchDiscoveryState';
  currentProposal?: Maybe<MatchProposal>;
  profileComplete: Scalars['Boolean'];
  profileStatus?: Maybe<MatchProfileStatus>;
  roseAvailableAt?: Maybe<Scalars['DateTime']>;
  serverNow: Scalars['DateTime'];
};

export type MatchInterest = {
  __typename?: 'MatchInterest';
  communityCode: Scalars['String'];
  id: Scalars['String'];
  lookingForLabel?: Maybe<Scalars['String']>;
};

export enum MatchPairAction {
  Confirm = 'Confirm',
  Ignore = 'Ignore',
  Pass = 'Pass',
  Report = 'Report',
  Rose = 'Rose',
  Unmatch = 'Unmatch'
}

export type MatchPairActionResult = {
  __typename?: 'MatchPairActionResult';
  discoveryState?: Maybe<MatchDiscoveryState>;
  pairId: Scalars['String'];
  status: MatchPairStatus;
};

export enum MatchPairListType {
  Matches = 'Matches',
  Requests = 'Requests'
}

export enum MatchPairStatus {
  Closed = 'Closed',
  Ignored = 'Ignored',
  Interested = 'Interested',
  Matched = 'Matched',
  Passed = 'Passed',
  Proposed = 'Proposed',
  Unmatched = 'Unmatched'
}

export type MatchPairsResult = {
  __typename?: 'MatchPairsResult';
  items: Array<UbiqMatchPair>;
  menuVisible: Scalars['Boolean'];
  pendingRequestCount: Scalars['Int'];
  total: Scalars['Int'];
};

export type MatchProfile = {
  __typename?: 'MatchProfile';
  additionalInfo: Scalars['JSON'];
  answers: Scalars['JSON'];
  communityCode: Scalars['String'];
  contacts: Scalars['JSON'];
  createdAt: Scalars['DateTime'];
  elevatorPitch?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  photos: Array<Scalars['String']>;
  status: MatchProfileStatus;
  updatedAt: Scalars['DateTime'];
};

export enum MatchProfileStatus {
  Active = 'Active',
  Draft = 'Draft',
  OptedOut = 'OptedOut'
}

export type MatchProposal = {
  __typename?: 'MatchProposal';
  candidate: MatchCandidateProfile;
  id: Scalars['String'];
  status: MatchPairStatus;
};

export enum MessageHighlightStatus {
  Hidden = 'Hidden',
  Visible = 'Visible'
}

export type Modal = {
  __typename?: 'Modal';
  CTAs: Array<Cta>;
  body: Scalars['String'];
  frequency: ModalFrequency;
  title: Scalars['String'];
  type: Scalars['String'];
};

export enum ModalFrequency {
  Day = 'day',
  Once = 'once'
}

export enum Module {
  Catalogue = 'Catalogue',
  EventList = 'EventList',
  EventsCalendar = 'EventsCalendar',
  Faq = 'Faq',
  Feed = 'Feed',
  Forum = 'Forum',
  IdCard = 'IDCard',
  Landing = 'Landing',
  Map = 'Map',
  Match = 'Match',
  OpenCalls = 'OpenCalls',
  PrivateEvent = 'PrivateEvent',
  Radio = 'Radio',
  Sos = 'SOS',
  Schedule = 'Schedule',
  Shop = 'Shop'
}

export type ModuleListUpdateInput = {
  set?: InputMaybe<Array<InputMaybe<Module>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateSoundCloud?: Maybe<ActivateSoundCloudResult>;
  addGuestListInvite?: Maybe<Scalars['Boolean']>;
  addGuestListInviteNote?: Maybe<Scalars['Json']>;
  adminAddGuests?: Maybe<Scalars['Boolean']>;
  adminUpdateOneCommunity?: Maybe<Community>;
  associateUserActivityIdentity: Scalars['Boolean'];
  attendeeCheckIn?: Maybe<Event>;
  authV2?: Maybe<AuthV2Response>;
  /** @deprecated Use joinCommunityWithInfoCheck for each selected community. */
  batchJoinCommunities?: Maybe<CommunityPayload>;
  blockUser?: Maybe<Scalars['Boolean']>;
  caAddAdmin?: Maybe<Scalars['Boolean']>;
  caAddOrUpdateMemberNote?: Maybe<Scalars['Boolean']>;
  caAgentCancelRun: AgentRun;
  caAgentClearBrowserContext: Scalars['Boolean'];
  caAgentFinalizeAttachment: AgentAttachment;
  caAgentHandBackBrowser: Scalars['Boolean'];
  caAgentMarkThreadSeen: Scalars['Boolean'];
  caAgentPrepareAttachment: AgentAttachmentUpload;
  caAgentRestartDemo: AgentThread;
  caAgentSetModel: AgentThread;
  caAgentStartFresh: AgentThread;
  caAgentStartRun: AgentRun;
  caAnnouncementCreateOrUpdate?: Maybe<FeedItem>;
  caBanMember: Scalars['Boolean'];
  caCatalogItemCreateOrUpdate?: Maybe<CatalogItem>;
  caCatalogItemDelete?: Maybe<Scalars['Boolean']>;
  caCatalogItemDuplicate?: Maybe<CatalogItem>;
  caCommunityThemeCreateOrUpdate?: Maybe<CommunityTheme>;
  caCommunityThemeDuplicate?: Maybe<CommunityTheme>;
  caCommunityThemeToggleStatus?: Maybe<CommunityTheme>;
  caCreateEventCategory?: Maybe<EventCategory>;
  caCreateGuestListInvite?: Maybe<Scalars['Boolean']>;
  caCreateNewEvent?: Maybe<Event>;
  caCreateOrUpdateAmbassadorCampaign?: Maybe<AmbassadorCampaign>;
  caCreatePrintfulSampleCheckout?: Maybe<PrintfulSampleCheckoutResult>;
  caDuplicateAnnouncement?: Maybe<FeedItem>;
  caDuplicateEmailCampaign?: Maybe<EmailCampaign>;
  caDuplicateEvent?: Maybe<Event>;
  caDuplicateMassMessage?: Maybe<MassMessage>;
  caDuplicateProduct?: Maybe<Product>;
  caDuplicateScheduleItem?: Maybe<CatalogItemSchedule>;
  caEmailCampaignUpdate?: Maybe<EmailCampaign>;
  caEventCreateOrUpdate?: Maybe<Event>;
  /** @deprecated Legacy event invitation management retained for existing clients only. */
  caEventInviteMembers?: Maybe<Scalars['Boolean']>;
  caEventToggleStatus?: Maybe<Event>;
  caGeneratePrintfulEwlJwt?: Maybe<PrintfulEwlJwtResult>;
  caGetPrintfulSampleShippingRates?: Maybe<PrintfulSampleShippingRatesResult>;
  caImportEvent?: Maybe<CaImportEventResult>;
  caInstagramManageComment: Scalars['Boolean'];
  caInstagramSendMessage: Scalars['Boolean'];
  caLogin?: Maybe<CaLoginResponse>;
  caManageGuestList: CaGuestListReceipt;
  caManageSegments: CaSegmentReceipt;
  /** Returns the created, changed or duplicated link */
  caManageSmartLink: SmartLink;
  caMassMessageUpdate?: Maybe<MassMessage>;
  caModifyProduct?: Maybe<Product>;
  caProcessForumContentReport?: Maybe<Scalars['Boolean']>;
  caProcessForumPost?: Maybe<Scalars['Boolean']>;
  caProductCreateOrUpdate?: Maybe<Product>;
  caPromocodeCreateOrUpdate?: Maybe<Promocode>;
  caPromocodeDuplicate?: Maybe<Promocode>;
  caPromocodeToggleStatus?: Maybe<Promocode>;
  caRadioTrackCreateOrUpdate?: Maybe<Track>;
  caRadioTrackDuplicate?: Maybe<Track>;
  caReadTalksMessages?: Maybe<Scalars['Boolean']>;
  caRemoveAdmin?: Maybe<Scalars['Boolean']>;
  caRetryEventImport?: Maybe<Event>;
  caReviewEvent?: Maybe<Event>;
  caReviewRelease?: Maybe<Track>;
  caScheduleItemCreateOrUpdate?: Maybe<CatalogItemSchedule>;
  caSendMessage?: Maybe<TalksMessage>;
  caSendTestEmailCampaign?: Maybe<Scalars['Boolean']>;
  caSyncPrintfulEwlProduct?: Maybe<PrintfulEwlSyncResult>;
  caToggleAnnouncementStatus?: Maybe<FeedItem>;
  caToggleCatalogItemStatus?: Maybe<CatalogItem>;
  caToggleEmailCampaignStatus?: Maybe<EmailCampaign>;
  caToggleMassMessageStatus?: Maybe<MassMessage>;
  caToggleProductStatus?: Maybe<Product>;
  caToggleRadioTrackStatus?: Maybe<Track>;
  caToggleScheduleItemStatus?: Maybe<CatalogItemSchedule>;
  caUnbanMember: Scalars['Boolean'];
  caUpdateJoinRequestStatus?: Maybe<Scalars['Boolean']>;
  caUpdateUserSegments?: Maybe<Scalars['Boolean']>;
  calculateDiscountAndFees?: Maybe<DiscountAndFees>;
  calendarHideEvent?: Maybe<Scalars['Boolean']>;
  calendarSeenEvents?: Maybe<Scalars['Boolean']>;
  cancelKustomOrder?: Maybe<CancelKustomOrderResponse>;
  cancelPurchases?: Maybe<Scalars['Boolean']>;
  claimAmbassadorCampaign: Scalars['Boolean'];
  claimCard?: Maybe<Scalars['Boolean']>;
  claimGuestListInvite?: Maybe<Scalars['Boolean']>;
  commentFeedItem?: Maybe<FeedItemComment>;
  commentForumPost?: Maybe<ForumComment>;
  confirmKustomOrder?: Maybe<ConfirmKustomOrderResponse>;
  createDeferredLink?: Maybe<Scalars['Boolean']>;
  createMedia?: Maybe<CreateMediaResponse>;
  createOrUpdateKustomOrder?: Maybe<CreateOrUpdateKustomOrderResponse>;
  createShare?: Maybe<Scalars['String']>;
  createStripeCustomerPortal?: Maybe<CreateStripeCustomerPortalResponse>;
  deactivateThirdPartyIntegration?: Maybe<Scalars['Boolean']>;
  deleteFeedItemComment?: Maybe<Scalars['Boolean']>;
  deleteForumContent?: Maybe<Scalars['Boolean']>;
  deleteGuestListInvite?: Maybe<Scalars['Boolean']>;
  deleteGuestListInviteNote?: Maybe<Scalars['Boolean']>;
  deleteTalksMessage?: Maybe<Scalars['Boolean']>;
  eventRSVP?: Maybe<Scalars['Boolean']>;
  eventRegister?: Maybe<Event>;
  findMatchProposal: MatchDiscoveryState;
  finishGameRun?: Maybe<Scalars['Boolean']>;
  getInviteCodeByReservedEmail?: Maybe<Scalars['String']>;
  getPrintfulShippingRates?: Maybe<PrintfulShippingRatesResult>;
  joinCommunity?: Maybe<CommunityPayload>;
  joinCommunityWaitlist?: Maybe<JoinWaitlistResult>;
  joinCommunityWithInfoCheck?: Maybe<JoinCommunityReturnType>;
  leaveCommunity?: Maybe<Scalars['Boolean']>;
  login?: Maybe<AuthPayload>;
  markInviteFriendsLinkOpened?: Maybe<MarkInviteFriendsLinkOpenedPayload>;
  markInviteFriendsPromptAction?: Maybe<MarkInviteFriendsPromptActionPayload>;
  markPromptAction?: Maybe<MarkPromptActionPayload>;
  mcaTestFixture: Scalars['Json'];
  mmTestFixture: Scalars['Json'];
  postCreateUserUpdate?: Maybe<User>;
  reactFeedItem?: Maybe<Scalars['Boolean']>;
  reactFeedItemComment?: Maybe<Scalars['Boolean']>;
  reactForumComment?: Maybe<Scalars['Boolean']>;
  reactForumPost?: Maybe<Scalars['Boolean']>;
  reactSuggestedCommunity?: Maybe<Scalars['Boolean']>;
  reactTalksMessage?: Maybe<Scalars['Boolean']>;
  readMessage?: Maybe<ReadMessageResponse>;
  readTalksMessages?: Maybe<Scalars['Boolean']>;
  registerPushDevice: PushDevice;
  registerUserActivityIdentity: Scalars['Boolean'];
  removeGuestListInvite?: Maybe<Scalars['Boolean']>;
  reportFeedItemComment?: Maybe<FeedItemCommentReport>;
  reportForumContent?: Maybe<ForumContentReport>;
  reportTalksMessage?: Maybe<Scalars['Boolean']>;
  reportUser?: Maybe<Scalars['Boolean']>;
  reprocessPurchases?: Maybe<Scalars['Boolean']>;
  requestAccessFeedItem?: Maybe<Scalars['Boolean']>;
  requestAccountDeletion?: Maybe<Scalars['Boolean']>;
  requestEmailVerification?: Maybe<Scalars['Boolean']>;
  requestEmailVerificationLink?: Maybe<Scalars['Boolean']>;
  requestHideFeedItem?: Maybe<Scalars['Boolean']>;
  requestPhoneVerification?: Maybe<Scalars['Boolean']>;
  requestProductsPurchase?: Maybe<RequestProductsPurchase>;
  requestSubscriptionPurchase?: Maybe<RequestSubscriptionPurchase>;
  requestSwap?: Maybe<RequestSwapPayload>;
  requestTalksChannelAccess?: Maybe<RequestTalksChannelAccessResponse>;
  resetAutomatedTestingCommunity?: Maybe<Scalars['Json']>;
  resetAutomatedTestingNextWca: NextWcaAutomatedTestingManifest;
  resetPassword?: Maybe<AuthPayload>;
  resetPasswordRequest?: Maybe<PasswordResetRequestPayload>;
  respondToMatchPair: MatchPairActionResult;
  revokeUserActivityIdentity: Scalars['Boolean'];
  rollbackEmail?: Maybe<Scalars['Boolean']>;
  saveFormResponse?: Maybe<Scalars['Boolean']>;
  saveMatchProfile: MatchProfile;
  scheduleItemRsvp?: Maybe<Scalars['Boolean']>;
  scheduleItemToggleCalendar?: Maybe<Scalars['Boolean']>;
  sendCommunityInvite?: Maybe<InventorySendInvite>;
  sendInviteCode?: Maybe<Scalars['Boolean']>;
  sendTalksMessage?: Maybe<TalksMessage>;
  sendTicket?: Maybe<Scalars['Boolean']>;
  startGameRun?: Maybe<Scalars['ID']>;
  submitForumPost?: Maybe<ForumPost>;
  submitSpottedPost?: Maybe<FeedItem>;
  suggestCommunity?: Maybe<SuggestedCommunity>;
  syncPushPlayerIds?: Maybe<SyncPushPlayerIdsResponse>;
  toggleLikeProduct?: Maybe<Scalars['Boolean']>;
  toggleSwapPurchase?: Maybe<Scalars['Boolean']>;
  trackEventSlugVisit: Scalars['Boolean'];
  trackUserActivity?: Maybe<Scalars['Boolean']>;
  undoCheckIn?: Maybe<Scalars['Boolean']>;
  unregisterPushDevice: Scalars['Boolean'];
  updateCompetitionTicket?: Maybe<UpdateCompetitionTicketResult>;
  updateGuestListInviteStatus?: Maybe<Scalars['Boolean']>;
  updateOneUser?: Maybe<User>;
  updateUbiqNotificationState?: Maybe<Scalars['Boolean']>;
  upsertMatchInterest: MatchInterest;
  useTokens?: Maybe<Scalars['Boolean']>;
  userUpdate?: Maybe<User>;
  userUpdateV2?: Maybe<User>;
  validatePasswordResetCode?: Maybe<Scalars['Boolean']>;
  validatePromocode?: Maybe<Promocode>;
  validateUsername?: Maybe<Scalars['Boolean']>;
  verifyEmail?: Maybe<Scalars['Boolean']>;
  verifyEmailToken?: Maybe<Scalars['Boolean']>;
  verifyUser?: Maybe<AuthPayload>;
};


export type MutationActivateSoundCloudArgs = {
  communityId: Scalars['ID'];
  soundcloudUrl: Scalars['String'];
};


export type MutationAddGuestListInviteArgs = {
  code: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
};


export type MutationAddGuestListInviteNoteArgs = {
  code: Scalars['String'];
  text: Scalars['String'];
};


export type MutationAdminAddGuestsArgs = {
  note?: InputMaybe<Scalars['String']>;
  productId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationAdminUpdateOneCommunityArgs = {
  data: AdminCommunityUpdateInput;
  where: AdminCommunityWhereUniqueInput2;
};


export type MutationAssociateUserActivityIdentityArgs = {
  anonymousId: Scalars['String'];
  identityToken: Scalars['String'];
};


export type MutationAttendeeCheckInArgs = {
  communityId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  purchaseIds?: InputMaybe<Array<Scalars['String']>>;
  segmentIds?: InputMaybe<Array<Scalars['String']>>;
  userId: Scalars['String'];
};


export type MutationAuthV2Args = {
  fromWeb?: InputMaybe<Scalars['Boolean']>;
  noCreation?: InputMaybe<Scalars['Boolean']>;
  phone: Scalars['String'];
  phoneVerificationCode?: InputMaybe<Scalars['String']>;
};


export type MutationBatchJoinCommunitiesArgs = {
  inviteCodes: Array<Scalars['String']>;
};


export type MutationBlockUserArgs = {
  blockedUserId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationCaAddAdminArgs = {
  communityId: Scalars['ID'];
  role: AdminRolesType;
  userId: Scalars['ID'];
};


export type MutationCaAddOrUpdateMemberNoteArgs = {
  communityId: Scalars['ID'];
  noteId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type MutationCaAgentCancelRunArgs = {
  communityId: Scalars['ID'];
  runId: Scalars['ID'];
};


export type MutationCaAgentClearBrowserContextArgs = {
  communityId: Scalars['ID'];
};


export type MutationCaAgentFinalizeAttachmentArgs = {
  attachmentId: Scalars['ID'];
  communityId: Scalars['ID'];
  threadId: Scalars['ID'];
};


export type MutationCaAgentHandBackBrowserArgs = {
  communityId: Scalars['ID'];
  runId: Scalars['ID'];
};


export type MutationCaAgentMarkThreadSeenArgs = {
  communityId: Scalars['ID'];
  threadId: Scalars['ID'];
};


export type MutationCaAgentPrepareAttachmentArgs = {
  input: PrepareAgentAttachmentInput;
};


export type MutationCaAgentRestartDemoArgs = {
  communityId: Scalars['ID'];
  threadId: Scalars['ID'];
};


export type MutationCaAgentSetModelArgs = {
  communityId: Scalars['ID'];
  model: Scalars['String'];
  threadId: Scalars['ID'];
};


export type MutationCaAgentStartFreshArgs = {
  communityId: Scalars['ID'];
  threadId: Scalars['ID'];
};


export type MutationCaAgentStartRunArgs = {
  input: CaAgentStartRunInput;
};


export type MutationCaAnnouncementCreateOrUpdateArgs = {
  announcementId?: InputMaybe<Scalars['ID']>;
  attemptPublish?: InputMaybe<Scalars['Boolean']>;
  commandId?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  data: CaAnnouncementCreateOrUpdateInput;
  expectedRevision?: InputMaybe<Scalars['Int']>;
};


export type MutationCaBanMemberArgs = {
  communityId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationCaCatalogItemCreateOrUpdateArgs = {
  input: CaCatalogItemInput;
};


export type MutationCaCatalogItemDeleteArgs = {
  catalogItemId: Scalars['ID'];
  communityId: Scalars['ID'];
};


export type MutationCaCatalogItemDuplicateArgs = {
  catalogItemId: Scalars['ID'];
  communityId: Scalars['ID'];
};


export type MutationCaCommunityThemeCreateOrUpdateArgs = {
  attemptPublish?: InputMaybe<Scalars['Boolean']>;
  communityId: Scalars['ID'];
  communityThemeId?: InputMaybe<Scalars['ID']>;
  data: CaCommunityThemeCreateOrUpdateInput;
};


export type MutationCaCommunityThemeDuplicateArgs = {
  communityId: Scalars['ID'];
  communityThemeId: Scalars['ID'];
};


export type MutationCaCommunityThemeToggleStatusArgs = {
  communityId: Scalars['ID'];
  communityThemeId: Scalars['ID'];
  status: CommunityThemeStatus;
};


export type MutationCaCreateEventCategoryArgs = {
  communityId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationCaCreateGuestListInviteArgs = {
  invitees: Array<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
};


export type MutationCaCreateNewEventArgs = {
  communityId: Scalars['ID'];
};


export type MutationCaCreateOrUpdateAmbassadorCampaignArgs = {
  input: CaAmbassadorCampaignInput;
};


export type MutationCaCreatePrintfulSampleCheckoutArgs = {
  communityId: Scalars['ID'];
  items: Array<PrintfulSampleOrderItemInput>;
  returnUrl: Scalars['String'];
  shippingAddress: PrintfulSampleShippingAddressInput;
  shippingMethod?: InputMaybe<Scalars['String']>;
};


export type MutationCaDuplicateAnnouncementArgs = {
  commandId?: InputMaybe<Scalars['String']>;
  communityId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type MutationCaDuplicateEmailCampaignArgs = {
  emailCampaignId: Scalars['String'];
};


export type MutationCaDuplicateEventArgs = {
  clientRequestId?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  eventId: Scalars['ID'];
  expectedVersion?: InputMaybe<Scalars['String']>;
};


export type MutationCaDuplicateMassMessageArgs = {
  commandId?: InputMaybe<Scalars['String']>;
  communityId?: InputMaybe<Scalars['String']>;
  expectedVersion?: InputMaybe<Scalars['String']>;
  massMessageId: Scalars['String'];
};


export type MutationCaDuplicateProductArgs = {
  clientRequestId?: InputMaybe<Scalars['String']>;
  expectedVersion?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type MutationCaDuplicateScheduleItemArgs = {
  communityId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationCaEmailCampaignUpdateArgs = {
  attemptPublish?: InputMaybe<Scalars['Boolean']>;
  communityId: Scalars['ID'];
  data: CaEmailCampaignUpdateInput;
  emailCampaignId?: InputMaybe<Scalars['ID']>;
};


export type MutationCaEventCreateOrUpdateArgs = {
  attemptPublish?: InputMaybe<Scalars['Boolean']>;
  clientRequestId?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  data: CaEventCreateOrUpdateInput;
  eventId?: InputMaybe<Scalars['ID']>;
  expectedVersion?: InputMaybe<Scalars['String']>;
};


export type MutationCaEventInviteMembersArgs = {
  eventId: Scalars['String'];
};


export type MutationCaEventToggleStatusArgs = {
  clientRequestId?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  eventId: Scalars['ID'];
  expectedVersion?: InputMaybe<Scalars['String']>;
  status: EventStatus;
};


export type MutationCaGeneratePrintfulEwlJwtArgs = {
  communityId: Scalars['ID'];
};


export type MutationCaGetPrintfulSampleShippingRatesArgs = {
  communityId: Scalars['ID'];
  items: Array<PrintfulSampleOrderItemInput>;
  shippingAddress: PrintfulSampleShippingAddressInput;
};


export type MutationCaImportEventArgs = {
  communityId: Scalars['ID'];
  url: Scalars['String'];
};


export type MutationCaInstagramManageCommentArgs = {
  action: InstagramCommentAction;
  commentId: Scalars['ID'];
  communityId: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
};


export type MutationCaInstagramSendMessageArgs = {
  communityId: Scalars['ID'];
  conversationId: Scalars['ID'];
  message: Scalars['String'];
};


export type MutationCaLoginArgs = {
  identifier: Scalars['String'];
  password: Scalars['String'];
};


export type MutationCaManageGuestListArgs = {
  change: CaGuestListChangeInput;
  commandId: Scalars['String'];
  communityId: Scalars['ID'];
  eventId: Scalars['ID'];
};


export type MutationCaManageSegmentsArgs = {
  change: CaSegmentChangeInput;
  commandId?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
};


export type MutationCaManageSmartLinkArgs = {
  change: SmartLinkChangeInput;
  commandId: Scalars['String'];
  communityId: Scalars['ID'];
};


export type MutationCaMassMessageUpdateArgs = {
  attemptPublish?: InputMaybe<Scalars['Boolean']>;
  commandId?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  data: CaMassMessageUpdateInput;
  expectedAutoApprove?: InputMaybe<Scalars['Boolean']>;
  expectedVersion?: InputMaybe<Scalars['String']>;
  massMessageId?: InputMaybe<Scalars['ID']>;
};


export type MutationCaModifyProductArgs = {
  badgeMediaPath?: InputMaybe<Scalars['String']>;
  data: ProductUpdateInput;
  productId: Scalars['ID'];
};


export type MutationCaProcessForumContentReportArgs = {
  action: ProcessForumContentReportActionType;
  deleteReason?: InputMaybe<Scalars['String']>;
  reportId: Scalars['ID'];
};


export type MutationCaProcessForumPostArgs = {
  action: ProcessForumPostActionType;
  deleteReason?: InputMaybe<Scalars['String']>;
  postId: Scalars['ID'];
};


export type MutationCaProductCreateOrUpdateArgs = {
  attemptPublish?: InputMaybe<Scalars['Boolean']>;
  clientRequestId?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  data: CaProductCreateOrUpdateInput;
  expectedEventVersion?: InputMaybe<Scalars['String']>;
  expectedVersion?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
  quantityChange?: InputMaybe<CaProductQuantityChangeInput>;
};


export type MutationCaPromocodeCreateOrUpdateArgs = {
  acknowledgeUsed?: InputMaybe<Scalars['Boolean']>;
  attemptPublish?: InputMaybe<Scalars['Boolean']>;
  commandId?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  data: CaPromocodeUpdateInput;
  expectedVersion?: InputMaybe<Scalars['String']>;
  productsToConnect?: InputMaybe<Array<Scalars['String']>>;
  promocodeId?: InputMaybe<Scalars['ID']>;
};


export type MutationCaPromocodeDuplicateArgs = {
  commandId?: InputMaybe<Scalars['String']>;
  communityId?: InputMaybe<Scalars['ID']>;
  expectedVersion?: InputMaybe<Scalars['String']>;
  promocodeId: Scalars['ID'];
};


export type MutationCaPromocodeToggleStatusArgs = {
  acknowledgeUsed?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  commandId?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  expectedVersion?: InputMaybe<Scalars['String']>;
  promocodeId: Scalars['ID'];
  publishingStatus: PromocodePublishingStatus;
};


export type MutationCaRadioTrackCreateOrUpdateArgs = {
  attemptPublish?: InputMaybe<Scalars['Boolean']>;
  communityId: Scalars['ID'];
  data: CaRadioTrackCreateOrUpdateInput;
  trackId?: InputMaybe<Scalars['ID']>;
};


export type MutationCaRadioTrackDuplicateArgs = {
  communityId: Scalars['ID'];
  trackId: Scalars['ID'];
};


export type MutationCaReadTalksMessagesArgs = {
  chatId: Scalars['ID'];
  communityId: Scalars['ID'];
};


export type MutationCaRemoveAdminArgs = {
  communityId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationCaRetryEventImportArgs = {
  eventId: Scalars['ID'];
};


export type MutationCaReviewEventArgs = {
  action: Scalars['String'];
  data?: InputMaybe<CaReviewEventInput>;
  duplicateToCommunities?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['String'];
  rejectionReason?: InputMaybe<Scalars['String']>;
};


export type MutationCaReviewReleaseArgs = {
  action: Scalars['String'];
  data?: InputMaybe<CaReviewReleaseInput>;
  rejectionReason?: InputMaybe<Scalars['String']>;
  trackId: Scalars['String'];
};


export type MutationCaScheduleItemCreateOrUpdateArgs = {
  attemptPublish?: InputMaybe<Scalars['Boolean']>;
  communityId: Scalars['ID'];
  data: CaScheduleItemCreateOrUpdateInput;
  scheduleItemId?: InputMaybe<Scalars['ID']>;
};


export type MutationCaSendMessageArgs = {
  attachmentId?: InputMaybe<Scalars['String']>;
  communityId: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  recipientId: Scalars['String'];
};


export type MutationCaSendTestEmailCampaignArgs = {
  campaignData: CaEmailCampaignUpdateInput;
  communityId: Scalars['ID'];
  testEmails: Scalars['String'];
};


export type MutationCaSyncPrintfulEwlProductArgs = {
  communityId: Scalars['ID'];
  product: Scalars['Json'];
};


export type MutationCaToggleAnnouncementStatusArgs = {
  announcementId: Scalars['ID'];
  commandId?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  expectedRevision?: InputMaybe<Scalars['Int']>;
  status: FeedItemPublishingStatus;
};


export type MutationCaToggleCatalogItemStatusArgs = {
  catalogItemId: Scalars['ID'];
  communityId: Scalars['ID'];
};


export type MutationCaToggleEmailCampaignStatusArgs = {
  emailCampaignId: Scalars['String'];
  status: EmailCampaignStatus;
};


export type MutationCaToggleMassMessageStatusArgs = {
  commandId?: InputMaybe<Scalars['String']>;
  communityId?: InputMaybe<Scalars['String']>;
  expectedAutoApprove?: InputMaybe<Scalars['Boolean']>;
  expectedVersion?: InputMaybe<Scalars['String']>;
  massMessageId: Scalars['String'];
  status: MassMessageStatus;
};


export type MutationCaToggleProductStatusArgs = {
  clientRequestId?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  expectedVersion?: InputMaybe<Scalars['String']>;
  productId: Scalars['ID'];
  status: ProductStatus;
};


export type MutationCaToggleRadioTrackStatusArgs = {
  communityId: Scalars['ID'];
  status: TrackPublishingStatus;
  trackId: Scalars['ID'];
};


export type MutationCaToggleScheduleItemStatusArgs = {
  communityId: Scalars['ID'];
  scheduleItemId: Scalars['ID'];
  status: CatalogItemSchedulePublishingStatus;
};


export type MutationCaUnbanMemberArgs = {
  communityId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationCaUpdateJoinRequestStatusArgs = {
  communityId: Scalars['String'];
  status: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationCaUpdateUserSegmentsArgs = {
  action: UserSegmentAction;
  communityId: Scalars['ID'];
  segmentId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationCalculateDiscountAndFeesArgs = {
  cart: Array<RequestProductsPurchaseInput>;
  paymentMethod?: InputMaybe<PurchasePaymentMethod>;
  printfulShippingFee?: InputMaybe<Scalars['Float']>;
  promocodeId?: InputMaybe<Scalars['String']>;
  sendQR?: InputMaybe<Scalars['Boolean']>;
  shippingCountry?: InputMaybe<Scalars['String']>;
};


export type MutationCalendarHideEventArgs = {
  eventId: Scalars['ID'];
};


export type MutationCalendarSeenEventsArgs = {
  eventIds: Scalars['String'];
};


export type MutationCancelKustomOrderArgs = {
  orderId: Scalars['String'];
};


export type MutationCancelPurchasesArgs = {
  purchaseIds: Array<Scalars['String']>;
};


export type MutationClaimAmbassadorCampaignArgs = {
  code: Scalars['String'];
};


export type MutationClaimCardArgs = {
  communityCode: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationClaimGuestListInviteArgs = {
  code: Scalars['String'];
};


export type MutationCommentFeedItemArgs = {
  commentId?: InputMaybe<Scalars['ID']>;
  feedItemId: Scalars['ID'];
  media?: InputMaybe<Array<Scalars['String']>>;
  text: Scalars['String'];
};


export type MutationCommentForumPostArgs = {
  commentId?: InputMaybe<Scalars['ID']>;
  content: Scalars['String'];
  media?: InputMaybe<Array<Scalars['String']>>;
  postId: Scalars['ID'];
};


export type MutationConfirmKustomOrderArgs = {
  orderId: Scalars['String'];
};


export type MutationCreateDeferredLinkArgs = {
  communityCode: Scalars['String'];
  inviteCode: Scalars['String'];
  inviteUrl: Scalars['String'];
  locale: Scalars['String'];
  screenWidth: Scalars['Int'];
  timezone: Scalars['String'];
};


export type MutationCreateMediaArgs = {
  communityCode?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  mimeType: Scalars['String'];
  subpath: Scalars['String'];
};


export type MutationCreateOrUpdateKustomOrderArgs = {
  additionalInfo?: InputMaybe<Scalars['Json']>;
  arrivedViaSlugs?: InputMaybe<Array<Scalars['String']>>;
  cart: Array<RequestProductsPurchaseInput>;
  checkoutRequirementsResponses?: InputMaybe<Scalars['Json']>;
  communityCode: Scalars['String'];
  idempotencyKey?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  printfulShippingMethod?: InputMaybe<Scalars['String']>;
  printfulShippingRate?: InputMaybe<Scalars['Float']>;
  promocodeId?: InputMaybe<Scalars['String']>;
  sendQR?: Scalars['Boolean'];
};


export type MutationCreateShareArgs = {
  communityCode: Scalars['String'];
  itemId?: InputMaybe<Scalars['String']>;
  module: Module;
};


export type MutationCreateStripeCustomerPortalArgs = {
  membershipId: Scalars['ID'];
};


export type MutationDeactivateThirdPartyIntegrationArgs = {
  integrationId: Scalars['ID'];
};


export type MutationDeleteFeedItemCommentArgs = {
  feedItemCommentId: Scalars['ID'];
};


export type MutationDeleteForumContentArgs = {
  commentId?: InputMaybe<Scalars['ID']>;
  postId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteGuestListInviteArgs = {
  code: Scalars['String'];
};


export type MutationDeleteGuestListInviteNoteArgs = {
  code: Scalars['String'];
  noteId: Scalars['String'];
};


export type MutationDeleteTalksMessageArgs = {
  messageId: Scalars['ID'];
};


export type MutationEventRsvpArgs = {
  eventId: Scalars['ID'];
  status?: InputMaybe<EventRsvpStatus>;
};


export type MutationEventRegisterArgs = {
  communityId: Scalars['ID'];
  eventId: Scalars['ID'];
};


export type MutationFindMatchProposalArgs = {
  communityCode: Scalars['String'];
};


export type MutationFinishGameRunArgs = {
  playSeconds: Scalars['Float'];
  runId: Scalars['ID'];
  score: Scalars['Int'];
};


export type MutationGetInviteCodeByReservedEmailArgs = {
  email: Scalars['String'];
};


export type MutationGetPrintfulShippingRatesArgs = {
  cart: Array<RequestProductsPurchaseInput>;
  shippingAddress: PrintfulShippingAddressInput;
};


export type MutationJoinCommunityArgs = {
  inviteCode: Scalars['String'];
};


export type MutationJoinCommunityWaitlistArgs = {
  communityCode: Scalars['String'];
};


export type MutationJoinCommunityWithInfoCheckArgs = {
  doInfoChecks?: InputMaybe<Scalars['Boolean']>;
  fromSignUp?: InputMaybe<Scalars['Boolean']>;
  inviteCode: Scalars['String'];
  joinRequirementsResponses?: InputMaybe<Scalars['Json']>;
  source?: InputMaybe<ExploreCommunitiesSource>;
};


export type MutationLeaveCommunityArgs = {
  communityCode: Scalars['String'];
};


export type MutationLoginArgs = {
  identifier?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  solanaWalletAddress?: InputMaybe<Scalars['String']>;
  solanaWalletSignature?: InputMaybe<Scalars['String']>;
};


export type MutationMarkInviteFriendsLinkOpenedArgs = {
  communityCode?: InputMaybe<Scalars['String']>;
  inviteCode: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
};


export type MutationMarkInviteFriendsPromptActionArgs = {
  action: InviteFriendsAction;
  communityId: Scalars['String'];
  platform?: InputMaybe<Scalars['String']>;
  recipientName?: InputMaybe<Scalars['String']>;
  slotId?: InputMaybe<Scalars['String']>;
};


export type MutationMarkPromptActionArgs = {
  action: UserPromptAction;
  metadata?: InputMaybe<Scalars['Json']>;
  type: UserPromptType;
};


export type MutationMcaTestFixtureArgs = {
  input: Scalars['Json'];
};


export type MutationMmTestFixtureArgs = {
  input: Scalars['Json'];
};


export type MutationPostCreateUserUpdateArgs = {
  password?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};


export type MutationReactFeedItemArgs = {
  feedItemId: Scalars['ID'];
};


export type MutationReactFeedItemCommentArgs = {
  feedItemCommentId: Scalars['ID'];
};


export type MutationReactForumCommentArgs = {
  forumCommentId: Scalars['ID'];
};


export type MutationReactForumPostArgs = {
  forumPostId: Scalars['ID'];
};


export type MutationReactSuggestedCommunityArgs = {
  suggestedCommunityId: Scalars['ID'];
};


export type MutationReactTalksMessageArgs = {
  messageId: Scalars['ID'];
  reactionType: Scalars['String'];
};


export type MutationReadMessageArgs = {
  chatId: Scalars['String'];
};


export type MutationReadTalksMessagesArgs = {
  channelId?: InputMaybe<Scalars['ID']>;
  communityId?: InputMaybe<Scalars['ID']>;
  werzySenderId?: InputMaybe<Scalars['ID']>;
};


export type MutationRegisterPushDeviceArgs = {
  input: RegisterPushDeviceInput;
};


export type MutationRegisterUserActivityIdentityArgs = {
  anonymousId: Scalars['String'];
  identityToken: Scalars['String'];
};


export type MutationRemoveGuestListInviteArgs = {
  code: Scalars['String'];
  phone: Scalars['String'];
};


export type MutationReportFeedItemCommentArgs = {
  feedItemCommentId: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationReportForumContentArgs = {
  commentId?: InputMaybe<Scalars['ID']>;
  postId?: InputMaybe<Scalars['ID']>;
  reason: Scalars['String'];
};


export type MutationReportTalksMessageArgs = {
  messageId: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationReportUserArgs = {
  reason: Scalars['String'];
  reportedUserId: Scalars['ID'];
};


export type MutationReprocessPurchasesArgs = {
  notifyAdmins?: InputMaybe<Scalars['Boolean']>;
  notifyUser?: InputMaybe<Scalars['Boolean']>;
  purchaseIds: Scalars['String'];
};


export type MutationRequestAccessFeedItemArgs = {
  feedItemId: Scalars['String'];
};


export type MutationRequestAccountDeletionArgs = {
  password: Scalars['String'];
  reason: Scalars['String'];
};


export type MutationRequestEmailVerificationArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type MutationRequestHideFeedItemArgs = {
  feedItemId: Scalars['String'];
};


export type MutationRequestPhoneVerificationArgs = {
  phone?: InputMaybe<Scalars['String']>;
  whatsapp?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRequestProductsPurchaseArgs = {
  additionalInfo?: InputMaybe<Scalars['Json']>;
  arrivedViaSlugs?: InputMaybe<Array<Scalars['String']>>;
  cart: Array<RequestProductsPurchaseInput>;
  checkoutRequirementsResponses?: InputMaybe<Scalars['Json']>;
  fromWeb?: Scalars['Boolean'];
  idempotencyKey?: InputMaybe<Scalars['String']>;
  joinRequirementsResponses?: InputMaybe<Scalars['Json']>;
  paymentMethod: PurchasePaymentMethod;
  postPaymentReturnUrl?: InputMaybe<Scalars['String']>;
  printfulShippingMethod?: InputMaybe<Scalars['String']>;
  printfulShippingRate?: InputMaybe<Scalars['Float']>;
  promocodeId?: InputMaybe<Scalars['String']>;
  sendQR?: InputMaybe<Scalars['Boolean']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']>;
};


export type MutationRequestSubscriptionPurchaseArgs = {
  fromWeb?: InputMaybe<Scalars['Boolean']>;
  postPaymentReturnUrl?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
};


export type MutationRequestSwapArgs = {
  paymentMethod: PurchasePaymentMethod;
  purchaseId: Scalars['ID'];
  stripePaymentMethodId?: InputMaybe<Scalars['String']>;
};


export type MutationRequestTalksChannelAccessArgs = {
  channelId: Scalars['ID'];
  joinRequirementsResponses?: InputMaybe<Scalars['Json']>;
};


export type MutationResetPasswordArgs = {
  currentPassword?: InputMaybe<Scalars['String']>;
  identifier: Scalars['String'];
  password: Scalars['String'];
  passwordResetCode: Scalars['String'];
};


export type MutationResetPasswordRequestArgs = {
  identifier: Scalars['String'];
};


export type MutationRespondToMatchPairArgs = {
  action: MatchPairAction;
  pairId: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationRevokeUserActivityIdentityArgs = {
  anonymousId: Scalars['String'];
  identityToken: Scalars['String'];
};


export type MutationSaveFormResponseArgs = {
  data?: InputMaybe<Scalars['Json']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
};


export type MutationSaveMatchProfileArgs = {
  communityCode: Scalars['String'];
  input: SaveMatchProfileInput;
};


export type MutationScheduleItemRsvpArgs = {
  id: Scalars['ID'];
  status?: InputMaybe<ScheduleItemRsvpStatus>;
};


export type MutationScheduleItemToggleCalendarArgs = {
  id: Scalars['ID'];
};


export type MutationSendCommunityInviteArgs = {
  communityId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};


export type MutationSendInviteCodeArgs = {
  communityId?: InputMaybe<Scalars['String']>;
  identifier: Scalars['String'];
  inviteCode: Scalars['String'];
};


export type MutationSendTalksMessageArgs = {
  attachmentId?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['String']>;
  communityId?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<Scalars['String']>>;
  message?: InputMaybe<Scalars['String']>;
  recipientId?: InputMaybe<Scalars['String']>;
  replyToMessageId?: InputMaybe<Scalars['ID']>;
};


export type MutationSendTicketArgs = {
  identifier?: InputMaybe<Scalars['String']>;
  purchaseId: Scalars['ID'];
  recipientId?: InputMaybe<Scalars['ID']>;
};


export type MutationStartGameRunArgs = {
  game: Scalars['String'];
  player: Scalars['String'];
};


export type MutationSubmitForumPostArgs = {
  communityId: Scalars['ID'];
  content: Scalars['String'];
  headline?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationSubmitSpottedPostArgs = {
  content: Scalars['String'];
  media?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};


export type MutationSuggestCommunityArgs = {
  name: Scalars['String'];
};


export type MutationSyncPushPlayerIdsArgs = {
  currentPushPlayerId: Scalars['String'];
};


export type MutationToggleLikeProductArgs = {
  productId: Scalars['ID'];
};


export type MutationToggleSwapPurchaseArgs = {
  price?: InputMaybe<Scalars['Int']>;
  purchaseId: Scalars['ID'];
};


export type MutationTrackEventSlugVisitArgs = {
  slug: Scalars['String'];
  visitorId?: InputMaybe<Scalars['String']>;
};


export type MutationTrackUserActivityArgs = {
  communityCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['Json']>;
  envelope?: InputMaybe<Scalars['Json']>;
  source: UserActivityEventSource;
  type: UserActivityEventType;
};


export type MutationUndoCheckInArgs = {
  communityId: Scalars['ID'];
  purchaseIds: Array<Scalars['String']>;
};


export type MutationUnregisterPushDeviceArgs = {
  expoPushToken: Scalars['String'];
};


export type MutationUpdateCompetitionTicketArgs = {
  answerIndex?: InputMaybe<Scalars['Int']>;
  reveal?: InputMaybe<Scalars['Boolean']>;
  ticketUuid: Scalars['String'];
};


export type MutationUpdateGuestListInviteStatusArgs = {
  code: Scalars['String'];
  status: GuestListInviteStatus;
};


export type MutationUpdateOneUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUbiqNotificationStateArgs = {
  action: UbiqNotificationStateAction;
  before?: InputMaybe<Scalars['DateTime']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationUpsertMatchInterestArgs = {
  communityCode: Scalars['String'];
  lookingForLabel?: InputMaybe<Scalars['String']>;
};


export type MutationUseTokensArgs = {
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
};


export type MutationUserUpdateArgs = {
  avatar?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['String']>;
  completedDiscoverOnboarding?: InputMaybe<Scalars['Boolean']>;
  currentPassword?: InputMaybe<Scalars['String']>;
  displayNameSetting?: InputMaybe<UserDisplayNameSetting>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  instagramHandle?: InputMaybe<Scalars['String']>;
  interestIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lastName?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  notificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  notificationsLastPromptedAt?: InputMaybe<Scalars['DateTime']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  primaryCommunityId?: InputMaybe<Scalars['String']>;
  pronouns?: InputMaybe<Scalars['String']>;
  pushPlayerIds?: InputMaybe<Scalars['String']>;
  sendEmailVerification?: InputMaybe<Scalars['Boolean']>;
  skipEmailVerification?: InputMaybe<Scalars['Boolean']>;
  socialLinks?: InputMaybe<Scalars['Json']>;
  username?: InputMaybe<Scalars['String']>;
};


export type MutationUserUpdateV2Args = {
  data: UserUpdateV2Input;
};


export type MutationValidatePasswordResetCodeArgs = {
  passwordResetCode: Scalars['String'];
};


export type MutationValidatePromocodeArgs = {
  parentCommunityCode?: InputMaybe<Scalars['String']>;
  parentCommunityId: Scalars['String'];
  productIds: Array<Scalars['String']>;
  promocode: Scalars['String'];
};


export type MutationValidateUsernameArgs = {
  username: Scalars['String'];
};


export type MutationVerifyEmailArgs = {
  emailVerificationCode: Scalars['String'];
};


export type MutationVerifyEmailTokenArgs = {
  token: Scalars['String'];
};


export type MutationVerifyUserArgs = {
  phoneVerificationCode: Scalars['String'];
};

export type MyCalendarEventsResponse = {
  __typename?: 'MyCalendarEventsResponse';
  invitedEvents: Array<DisplayEvent>;
  next: Scalars['Int'];
  pastEvents: Array<DisplayEvent>;
  total: Scalars['Int'];
  upcomingEvents: Array<DisplayEvent>;
};

export type MyLatestItem = {
  __typename?: 'MyLatestItem';
  iconUrl?: Maybe<Scalars['String']>;
  inAppLink: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  price: Scalars['String'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
};

export type NextWcaAutomatedTestingManifest = {
  __typename?: 'NextWcaAutomatedTestingManifest';
  chatChannel: AutomatedTestingFixture;
  community: AutomatedTestingCommunityManifest;
  event: AutomatedTestingFixture;
  events: AutomatedTestingEventsManifest;
  members: AutomatedTestingMembersManifest;
  news: AutomatedTestingNewsManifest;
  products: AutomatedTestingProductsManifest;
  promocodes: AutomatedTestingPromocodesManifest;
  pushNotifications: AutomatedTestingPushNotificationsManifest;
};

export type OpenCall = {
  __typename?: 'OpenCall';
  applied: Scalars['Boolean'];
  community: Community;
  communityId: Scalars['String'];
  config?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: OpenCallPublishingStatus;
  submissions: Array<OpenCallSubmission>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum OpenCallPublishingStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Published = 'Published'
}

export type OpenCallSubmission = {
  __typename?: 'OpenCallSubmission';
  createdAt: Scalars['DateTime'];
  data: Scalars['Json'];
  id: Scalars['String'];
  openCall: OpenCall;
  openCallId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type PasswordResetRequestPayload = {
  __typename?: 'PasswordResetRequestPayload';
  errors?: Maybe<Array<Maybe<TranslatableError>>>;
  requested: Scalars['Boolean'];
};

export type PopularEvent = {
  __typename?: 'PopularEvent';
  artistId?: Maybe<Scalars['String']>;
  attendeesCount: Scalars['Int'];
  attendeesIcons: Array<Scalars['String']>;
  calendarSeen: Scalars['String'];
  communityCode: Scalars['String'];
  communityIconUrl: Scalars['String'];
  communityName: Scalars['String'];
  curatedByIcons: Array<Scalars['String']>;
  curatedByUsernames?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  likesCount?: Maybe<Scalars['Int']>;
  location: Scalars['String'];
  myRSVP?: Maybe<EventRsvpStatus>;
  recommendedByIcons: Array<Scalars['String']>;
  recommendedByText: Scalars['String'];
  start?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  type: Scalars['String'];
  venueName?: Maybe<Scalars['String']>;
  webLink?: Maybe<Scalars['String']>;
};

export type PopularEventsResponse = {
  __typename?: 'PopularEventsResponse';
  end?: Maybe<Scalars['DateTime']>;
  items: Array<PopularEvent>;
  next: Scalars['Int'];
  start?: Maybe<Scalars['DateTime']>;
  total: Scalars['Int'];
};

export type PrepareAgentAttachmentInput = {
  byteSize: Scalars['Int'];
  checksum: Scalars['String'];
  communityId: Scalars['ID'];
  filename: Scalars['String'];
  mimeType: Scalars['String'];
  threadId: Scalars['ID'];
};

export type PrintfulEwlJwtResult = {
  __typename?: 'PrintfulEwlJwtResult';
  expiresAt: Scalars['String'];
  jwt: Scalars['String'];
};

export type PrintfulEwlSyncResult = {
  __typename?: 'PrintfulEwlSyncResult';
  product: Product;
  warnings: Array<Scalars['String']>;
  wasCreated: Scalars['Boolean'];
};

export type PrintfulSampleCheckoutResult = {
  __typename?: 'PrintfulSampleCheckoutResult';
  checkoutUrl: Scalars['String'];
};

export type PrintfulSampleOrderItemInput = {
  catalogVariantId?: InputMaybe<Scalars['Int']>;
  color?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  productTemplateId: Scalars['Int'];
  quantity: Scalars['Int'];
  size?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PrintfulSampleShippingAddressInput = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  fullName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  stateCode?: InputMaybe<Scalars['String']>;
  streetAddress: Scalars['String'];
  streetAddress2?: InputMaybe<Scalars['String']>;
};

export type PrintfulSampleShippingRateResult = {
  __typename?: 'PrintfulSampleShippingRateResult';
  currency: Scalars['String'];
  customsFeesPossible?: Maybe<Scalars['Boolean']>;
  maxDeliveryDate?: Maybe<Scalars['String']>;
  maxDeliveryDays?: Maybe<Scalars['Int']>;
  minDeliveryDate?: Maybe<Scalars['String']>;
  minDeliveryDays?: Maybe<Scalars['Int']>;
  rate: Scalars['Float'];
  shipping: Scalars['String'];
  shippingMethodName?: Maybe<Scalars['String']>;
};

export type PrintfulSampleShippingRatesResult = {
  __typename?: 'PrintfulSampleShippingRatesResult';
  rates: Array<PrintfulSampleShippingRateResult>;
  selectedShippingMethod?: Maybe<Scalars['String']>;
};

export type PrintfulShippingAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  fullName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  stateCode?: InputMaybe<Scalars['String']>;
  streetAddress: Scalars['String'];
  streetAddress2?: InputMaybe<Scalars['String']>;
};

export type PrintfulShippingRateResult = {
  __typename?: 'PrintfulShippingRateResult';
  currency: Scalars['String'];
  customsFeesPossible: Scalars['Boolean'];
  maxDeliveryDate?: Maybe<Scalars['String']>;
  maxDeliveryDays?: Maybe<Scalars['Int']>;
  minDeliveryDate?: Maybe<Scalars['String']>;
  minDeliveryDays?: Maybe<Scalars['Int']>;
  rate: Scalars['Float'];
  shipping: Scalars['String'];
  shippingMethodName?: Maybe<Scalars['String']>;
};

export type PrintfulShippingRatesResult = {
  __typename?: 'PrintfulShippingRatesResult';
  rates: Array<PrintfulShippingRateResult>;
  selectedShippingMethod?: Maybe<Scalars['String']>;
};

export enum ProcessForumContentReportActionType {
  Delete = 'delete',
  Ignore = 'ignore'
}

export enum ProcessForumPostActionType {
  Approve = 'approve',
  Delete = 'delete',
  Ignore = 'ignore'
}

export type Product = {
  __typename?: 'Product';
  additionalConfig: Scalars['Json'];
  additionalInfo?: Maybe<Scalars['String']>;
  badge?: Maybe<TemplateBadge>;
  badgeId?: Maybe<Scalars['String']>;
  bundleProducts: Array<Product>;
  code?: Maybe<Scalars['String']>;
  community: Community;
  communityId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: SupportedCurrencies;
  customReceiptAlias?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayPrice: Scalars['String'];
  displayPriceShort: Scalars['String'];
  editVersion?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['String']>;
  externalBuyLink?: Maybe<Scalars['String']>;
  fees: ProductFees;
  grossRevenue?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isDisabled: Scalars['Boolean'];
  liked: Scalars['Boolean'];
  limit: Scalars['Int'];
  /** The Products list's badge: Draft, Active, Sold out, Scheduled, Past, Unavailable, Hidden or Deleted */
  listStatus: Scalars['String'];
  maxAllowedPurchases: Scalars['Int'];
  media?: Maybe<Array<Scalars['String']>>;
  mediaUrl?: Maybe<Scalars['String']>;
  minPrice?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  payees: Scalars['String'];
  pickupInfo?: Maybe<Scalars['String']>;
  postPurchaseInstructions?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  pricingType: ProductPricingType;
  productType: ProductType;
  promocodes: Array<Promocode>;
  publishingStatus: ProductStatus;
  purchases: Array<Purchase>;
  quantity: Scalars['Int'];
  requiredAccessCode?: Maybe<Scalars['String']>;
  sharedQuantityProducts: Array<Product>;
  shortTerms?: Maybe<Scalars['String']>;
  showBeforeStartDate: Scalars['Boolean'];
  slugs?: Maybe<Array<Scalars['String']>>;
  soldoutAfter?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  totalProcess?: Maybe<Scalars['Int']>;
  totalSold?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  userMembershipId?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
  vat: Scalars['Float'];
};

export type ProductFees = {
  __typename?: 'ProductFees';
  FreeFixed?: Maybe<Scalars['Float']>;
  FreeMin?: Maybe<Scalars['Float']>;
  FreePercentage?: Maybe<Scalars['Float']>;
  KustomCheckoutFixed?: Maybe<Scalars['Float']>;
  KustomCheckoutMin?: Maybe<Scalars['Float']>;
  KustomCheckoutPercentage?: Maybe<Scalars['Float']>;
  StripeCardFixed?: Maybe<Scalars['Float']>;
  StripeCardMin?: Maybe<Scalars['Float']>;
  StripeCardPercentage?: Maybe<Scalars['Float']>;
  StripeFixed?: Maybe<Scalars['Float']>;
  StripeIdealFixed?: Maybe<Scalars['Float']>;
  StripeIdealMin?: Maybe<Scalars['Float']>;
  StripeIdealPercentage?: Maybe<Scalars['Float']>;
  StripeMobilePayFixed?: Maybe<Scalars['Float']>;
  StripeMobilePayMin?: Maybe<Scalars['Float']>;
  StripeMobilePayPercentage?: Maybe<Scalars['Float']>;
  StripePercentage?: Maybe<Scalars['Float']>;
  StripeSwishFixed?: Maybe<Scalars['Float']>;
  StripeSwishMin?: Maybe<Scalars['Float']>;
  StripeSwishPercentage?: Maybe<Scalars['Float']>;
  SwishFixed?: Maybe<Scalars['Float']>;
  SwishPercentage?: Maybe<Scalars['Float']>;
  WebFixed?: Maybe<Scalars['Float']>;
  WebMin?: Maybe<Scalars['Float']>;
  WebPercentage?: Maybe<Scalars['Float']>;
};

export enum ProductPricingType {
  Fixed = 'Fixed',
  Flexible = 'Flexible'
}

export enum ProductStatus {
  CompleteAvailable = 'CompleteAvailable',
  CompleteUnavailable = 'CompleteUnavailable',
  Deleted = 'Deleted',
  Draft = 'Draft',
  Hidden = 'Hidden',
  UneditedDraft = 'UneditedDraft'
}

export enum ProductType {
  Accomodation = 'Accomodation',
  Bundle = 'Bundle',
  Clothing = 'Clothing',
  Digital = 'Digital',
  Membership = 'Membership',
  Merch = 'Merch',
  Music = 'Music',
  Sauna = 'Sauna',
  Ticket = 'Ticket',
  Token = 'Token'
}

export type ProductUpdateInput = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  publishingStatus?: InputMaybe<ProductStatus>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ProductUsageDailyData = {
  __typename?: 'ProductUsageDailyData';
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
};

export type ProductVariantInput = {
  color?: InputMaybe<Scalars['String']>;
  printfulVariantId?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['String']>;
};

export type ProductWhereInput = {
  eventId?: InputMaybe<StringFilter8>;
  id?: InputMaybe<Scalars['String']>;
};

export type ProfileCommunity = {
  __typename?: 'ProfileCommunity';
  code: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ProfileSocialLink = {
  __typename?: 'ProfileSocialLink';
  displayText?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  url: Scalars['String'];
  username: Scalars['String'];
};

export type Promocode = {
  __typename?: 'Promocode';
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  discountFixed?: Maybe<Scalars['Int']>;
  discountOverridePrice?: Maybe<Scalars['Int']>;
  discountPercentage?: Maybe<Scalars['Int']>;
  editVersion: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  hasUsageHistory: Scalars['Boolean'];
  id: Scalars['String'];
  limitPerUser?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parentCommunity?: Maybe<Community>;
  products: Array<Product>;
  publishingStatus: PromocodePublishingStatus;
  purchases: Array<Purchase>;
  quantity?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  usedCount: Scalars['Int'];
};

export enum PromocodeAdminStatus {
  Active = 'Active',
  Draft = 'Draft',
  Expired = 'Expired',
  Scheduled = 'Scheduled'
}

export enum PromocodePublishingStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Published = 'Published',
  UneditedDraft = 'UneditedDraft'
}

export type PromocodeRecentRedemption = {
  __typename?: 'PromocodeRecentRedemption';
  createdAt: Scalars['DateTime'];
  productId: Scalars['String'];
  productName: Scalars['String'];
};

export type PromocodeUsageDailyData = {
  __typename?: 'PromocodeUsageDailyData';
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  localDate: Scalars['String'];
};

export type PublicCommunity = {
  __typename?: 'PublicCommunity';
  code?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Purchase = {
  __typename?: 'Purchase';
  additionalInfo?: Maybe<Scalars['Json']>;
  amount: Scalars['Float'];
  badge?: Maybe<ClaimedBadge>;
  code?: Maybe<Scalars['String']>;
  competitionInfo?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  currency: SupportedCurrencies;
  deliveryMethod?: Maybe<DeliveryMethod>;
  discount: Scalars['Float'];
  emailSent: Scalars['Boolean'];
  fee: Scalars['Float'];
  fromWeb: Scalars['Boolean'];
  hasBeenUsed?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isCheckedIn?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
  owner: User;
  ownerId: Scalars['String'];
  payee?: Maybe<Scalars['String']>;
  paymentMethod: PurchasePaymentMethod;
  price: Scalars['Float'];
  product: Product;
  productId: Scalars['String'];
  promocode?: Maybe<Promocode>;
  purchaserId: Scalars['String'];
  refundedAmount: Scalars['Float'];
  sendQR: Scalars['Boolean'];
  status: PurchaseStatus;
  statusMessage?: Maybe<Scalars['String']>;
  swapDisplayPrice: Scalars['String'];
  swapPrice?: Maybe<Scalars['Float']>;
  transferHistory: Array<PurchaseTransfer>;
  transferredTo?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  usedAt?: Maybe<Scalars['DateTime']>;
  with3ds: Scalars['Boolean'];
};

export type PurchaseOrderByInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export enum PurchasePaymentMethod {
  Free = 'Free',
  KustomCheckout = 'KustomCheckout',
  Manual = 'Manual',
  Stripe = 'Stripe',
  StripeCard = 'StripeCard',
  StripeIdeal = 'StripeIdeal',
  StripeMobilePay = 'StripeMobilePay',
  StripeSwish = 'StripeSwish',
  Swish = 'Swish',
  IDeal = 'iDEAL'
}

export enum PurchaseStatus {
  Deleted = 'Deleted',
  Failed = 'Failed',
  Initiated = 'Initiated',
  Paid = 'Paid',
  PartiallyRefunded = 'PartiallyRefunded',
  PendingApproval = 'PendingApproval',
  Processing = 'Processing',
  Refunded = 'Refunded',
  SwapPending = 'SwapPending'
}

export type PurchaseStatusFilter = {
  equals?: InputMaybe<PurchaseStatus>;
};

export type PurchaseTransfer = {
  __typename?: 'PurchaseTransfer';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  purchase?: Maybe<Purchase>;
  recipient?: Maybe<User>;
  sender: User;
  updatedAt: Scalars['DateTime'];
};

export enum PurchaseTransferStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Succeeded = 'Succeeded',
  SucceededRefundPending = 'SucceededRefundPending'
}

export enum PurchaseTransferType {
  Send = 'Send',
  Swap = 'Swap'
}

export type PurchaseWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PurchaseWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PurchaseWhereInput>>>;
  id?: InputMaybe<StringInFilter>;
  ownerId?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<ProductWhereInput>;
  status?: InputMaybe<PurchaseStatusFilter>;
};

export type PurchaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type PurchasesResponse = {
  __typename?: 'PurchasesResponse';
  errors?: Maybe<Array<Maybe<TranslatableError>>>;
  purchases?: Maybe<Array<Maybe<Purchase>>>;
};

export enum PushApp {
  Mca = 'MCA',
  Mm = 'MM'
}

export type PushDevice = {
  __typename?: 'PushDevice';
  app: PushApp;
  id: Scalars['String'];
  invalidatedAt?: Maybe<Scalars['DateTime']>;
  lastSeenAt: Scalars['DateTime'];
  permissionGranted: Scalars['Boolean'];
  platform: PushPlatform;
};

export enum PushPlatform {
  Android = 'android',
  Ios = 'ios'
}

export type QrCodeScan = {
  __typename?: 'QrCodeScan';
  attendee?: Maybe<AdminListEventAttendee>;
  outcome: QrCodeScanOutcome;
  purchaseId?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['ID']>;
};

export enum QrCodeScanOutcome {
  AlreadyUsed = 'AlreadyUsed',
  Expired = 'Expired',
  NotFound = 'NotFound',
  Refunded = 'Refunded',
  Valid = 'Valid',
  WrongEvent = 'WrongEvent'
}

export type Query = {
  __typename?: 'Query';
  activeFestivalsForCalendar?: Maybe<Array<ActiveFestival>>;
  adminCommunity?: Maybe<Community>;
  adminGuestListProducts?: Maybe<Array<Product>>;
  adminListEventAttendee?: Maybe<AdminListEventAttendee>;
  adminListEventAttendees?: Maybe<EventAttendees>;
  allCalendarEvents?: Maybe<AllCalendarEventsResponse>;
  ambassadorCampaignByCode?: Maybe<DisplayAmbassadorCampaign>;
  announcement?: Maybe<FeedItem>;
  announcements?: Maybe<AnnouncementsReturn>;
  apiStatus?: Maybe<ApiStatusResponse>;
  availableLocations?: Maybe<Array<AvailableLocation>>;
  caActiveProducts?: Maybe<ActiveProductsReturn>;
  caAdminIndicatorsPermissions?: Maybe<CaAdminIndicatorsPermissions>;
  caAdmins?: Maybe<CaAdminsResponse>;
  caAgentAttachment: AgentAttachmentAccess;
  caAgentBrowserLiveView?: Maybe<Scalars['String']>;
  caAgentConfig: AgentConfig;
  caAgentEmailDraftPreview?: Maybe<Scalars['String']>;
  caAgentRoleThreads: Array<AgentThread>;
  caAgentThread?: Maybe<AgentThread>;
  caAgentThreadEvents: AgentThreadEventsPage;
  caAmbassadorCampaigns?: Maybe<CaAmbassadorCampaignsResult>;
  caAnnouncement?: Maybe<FeedItem>;
  caAnnouncements?: Maybe<CaAnnouncementsResult>;
  caAssignableSegments?: Maybe<CaAssignableSegmentsResult>;
  caCatalogCategories?: Maybe<CaCatalogCategoriesResult>;
  caCatalogItem?: Maybe<CatalogItem>;
  caCatalogItems?: Maybe<CaCatalogItemsResult>;
  caCatalogScheduleItems?: Maybe<CaCatalogScheduleItemsResult>;
  caCommunity?: Maybe<CaCommunityContext>;
  caCommunityMembers?: Maybe<CaCommunityMembersResponse>;
  caCommunityMembersStats?: Maybe<CaCommunityMembersStatsResponse>;
  caCommunityMembersV2?: Maybe<CaCommunityMembersV2Response>;
  caCommunityOverviewStats?: Maybe<CaCommunityOverviewStatsResponse>;
  caCommunityRevenueStats?: Maybe<CaCommunityRevenueStatusResponse>;
  caCommunitySubscriptions?: Maybe<CaCommunitySubscriptionsResponse>;
  caCommunityTheme?: Maybe<CommunityTheme>;
  caCommunityThemes?: Maybe<CaCommunityThemesResult>;
  caEmailCampaign?: Maybe<EmailCampaign>;
  caEmailCampaignActivity?: Maybe<EmailCampaignActivityResult>;
  caEmailCampaignStats?: Maybe<EmailCampaignStats>;
  caEmailCampaigns?: Maybe<CaEmailCampaignsResult>;
  caEvent?: Maybe<CaEventResponse>;
  caEventActivity?: Maybe<CaEventActivityQueryResponse>;
  caEventAnalytics?: Maybe<CaEventAnalyticsResult>;
  caEventAttendance: CaEventAttendancePage;
  caEventBenchmark: CaEventBenchmark;
  /** The orders of the event and the compared one up to a day */
  caEventBenchmarkDetails: CaEventDetails;
  caEventCategories?: Maybe<CaEventCategoriesResult>;
  caEventFunnel: CaEventFunnel;
  /** The people at one stage of an Event funnel tab, or at every stage */
  caEventFunnelDetails: CaEventDetails;
  caEventGuests?: Maybe<CaEventGuestsResult>;
  caEventOverview: CaEventOverview;
  /** A Progress bar's orders or views */
  caEventProgressDetails: CaEventDetails;
  caEventSalesProgress: CaEventSalesProgress;
  caEventTicketsActivity?: Maybe<CaEventTicketsActivityResponse>;
  caEventTopSources: CaEventTopSources;
  caEventTraction?: Maybe<CaEventTraction>;
  caEventViewsProgress: CaEventViewsProgress;
  caEvents?: Maybe<CaEventsResult>;
  caFinancesOverview?: Maybe<CaFinancesOverviewResponse>;
  caForumItems?: Maybe<CaForumItemsReturn>;
  caGuestList: CaGuestListPage;
  caGuestListClaims: Array<CaGuestListClaim>;
  caInstagramComments: Array<CaInstagramComment>;
  caInstagramConversation: CaInstagramConversation;
  caInstagramConversations: Array<CaInstagramConversation>;
  caInstagramStories: Array<CaInstagramStory>;
  caJoinRequestDetail?: Maybe<CaJoinRequestDetailResponse>;
  caJoinRequests?: Maybe<CaJoinRequestsResponse>;
  caMassMessage?: Maybe<MassMessage>;
  caMassMessages?: Maybe<CaMassMessagesResult>;
  caMember?: Maybe<CaMemberResponse>;
  caMemberEvents?: Maybe<CaMemberEventsResponse>;
  caMemberOrders?: Maybe<CaMemberOrdersResponse>;
  caMemberPurchases?: Maybe<CaMemberPurchasesResponse>;
  caMonthlyActivityUsers?: Maybe<CaMonthlyActivityUsersResponse>;
  caPotentialAdmins?: Maybe<CaPotentialAdminsResponse>;
  caProduct?: Maybe<Product>;
  caProductConfigs?: Maybe<CaProductConfigs>;
  caProductEvent?: Maybe<Event>;
  caProductEvents?: Maybe<CaProductEventsReturn>;
  caProductUsageStats?: Maybe<CaProductUsageStatsResponse>;
  caProducts?: Maybe<CaProductsReturn>;
  caPromocode?: Maybe<Promocode>;
  caPromocodeRedemptions: CaPromocodeRedemptions;
  caPromocodeUsageStats?: Maybe<CaPromocodeUsageStatsResponse>;
  caPromocodes?: Maybe<CaPromocodesReturn>;
  caPromocodesRecentUsages?: Maybe<CaPromocodesResentUsagesReturn>;
  caPurchases?: Maybe<CaPurchasesResult>;
  caPurchasesActivity?: Maybe<CaPurchasesActivityResponse>;
  caPurchasesFunnel?: Maybe<CaPurchasesFunnelResponse>;
  caRadioTrack?: Maybe<Track>;
  caRadioTracks?: Maybe<CaRadioTracksResult>;
  caRecentPurchases?: Maybe<CaResentPurchasesReturn>;
  caReviewQueue?: Maybe<CaReviewQueueResult>;
  caReviewReleaseQueue?: Maybe<CaReviewReleaseQueueResult>;
  caScheduleCalendarStats?: Maybe<CaScheduleCalendarStatsResponse>;
  caScheduleItem?: Maybe<CatalogItemSchedule>;
  caScheduleItems?: Maybe<CaScheduleItemsResult>;
  caSegment: Segment;
  caSegmentUsage: CaSegmentUsage;
  caSegments: CaSegmentList;
  caShopActivity?: Maybe<CaShopActivityQueryResponse>;
  caSmartLink: SmartLink;
  /** The purchases dialog: the orders the link brought in, newest first */
  caSmartLinkOrders: SmartLinkOrdersPage;
  caSmartLinks: SmartLinksPage;
  caTalksChannels?: Maybe<CaTalksChannelsResponse>;
  caTalksChat?: Maybe<CaTalksChatResponse>;
  caTalksChats?: Maybe<CaTalksChatsResponse>;
  caUserActivityLog?: Maybe<CaUserActivityLogResponse>;
  calendarAvailableLocations?: Maybe<Array<CalendarLocation>>;
  calendarEvents?: Maybe<CalendarEventsResponse>;
  calendarUnseenEvents?: Maybe<Scalars['Int']>;
  catalogItem?: Maybe<DisplayDetailedCatalogItem>;
  catalogItems?: Maybe<CatalogItemsResult>;
  checkoutPostReturn?: Maybe<CheckoutPostReturnResult>;
  clientConfig?: Maybe<ClientConfigResponse>;
  community?: Maybe<Community>;
  communityInfo?: Maybe<CommunityInfoResult>;
  communityInventory?: Maybe<CommunityInventoryResult>;
  communityInviteCodes?: Maybe<CommunityInviteCodesResult>;
  communityLanding?: Maybe<CommunityLandingResult>;
  communityRadios?: Maybe<CommunityRadiosReturn>;
  competitionTicket?: Maybe<CompetitionTicket>;
  contentPreview?: Maybe<DisplayContentPreview>;
  curatedNews?: Maybe<CuratedNewsResponse>;
  curatedScheduleItems?: Maybe<CuratedScheduleItemsResponse>;
  detectCountry?: Maybe<Scalars['String']>;
  event?: Maybe<Event>;
  eventAttendees?: Maybe<UbiqEventAttendees>;
  eventRecommendedBy?: Maybe<EventRecommendedBy>;
  eventSalesStats?: Maybe<EventSalesStatsResponse>;
  eventV2?: Maybe<Event>;
  eventWithTickets?: Maybe<EventWithTicketsResponse>;
  events: Array<Event>;
  eventsCalendar?: Maybe<EventsCalendarResult>;
  eventsV2?: Maybe<EventsV2Response>;
  exploreCommunities?: Maybe<ExploreCommunitiesResponse>;
  exploreShortcuts?: Maybe<ExploreShortcuts>;
  faqCategories: Array<FaqCategory>;
  feedEventsView?: Maybe<FeedEventsViewResponse>;
  feedFestival?: Maybe<FeedFestivalResponse>;
  feedItemComments?: Maybe<FeedItemComments>;
  feedItemEventInfo?: Maybe<FeedItemEventInfo>;
  feedReleases?: Maybe<FeedReleasesResponse>;
  festivalCalendarEvents?: Maybe<FestivalCalendarEventsResponse>;
  festivalSeason: Array<FestivalSeasonItem>;
  forumPost?: Maybe<ForumPost>;
  forumPostComments?: Maybe<ForumPostCommentsReturn>;
  forumPosts?: Maybe<ForumPostsReturn>;
  getCommunity?: Maybe<Community>;
  getCommunityByInviteCode?: Maybe<CommunityByInviteCode>;
  guestListInvite?: Maybe<DisplayGuestListInvite>;
  guestListInvites?: Maybe<GuestListInvites>;
  identityQrTokenBatch: IdentityQrTokenBatch;
  instajumpSignees?: Maybe<InstajumpSigneesResponse>;
  interests: Array<Maybe<DisplayInterestCategory>>;
  inventory?: Maybe<InventoryReturnType>;
  inventoryEvent?: Maybe<InventoryEventResult>;
  inventoryPurchase?: Maybe<Purchase>;
  inventoryV2?: Maybe<InventoryV2Result>;
  inviteFriendsPromptPage?: Maybe<InviteFriendsPromptPage>;
  legacyTalksChats?: Maybe<TalksChatsResponse>;
  legacyTalksMessages?: Maybe<TalksMessagesResponse>;
  locationSupported?: Maybe<Scalars['Boolean']>;
  mapLocations?: Maybe<Array<Maybe<DisplayMapLocation>>>;
  matchDiscoveryState: MatchDiscoveryState;
  matchInterest?: Maybe<MatchInterest>;
  matchPair?: Maybe<UbiqMatchPair>;
  matchPairs: MatchPairsResult;
  matchProfile?: Maybe<MatchProfile>;
  me?: Maybe<User>;
  membershipStatus?: Maybe<DisplayPaidMembership>;
  myBadges?: Maybe<Array<Maybe<ClaimedBadge>>>;
  myCalendarEvents?: Maybe<MyCalendarEventsResponse>;
  newsFeedView?: Maybe<FeedNewsViewResponse>;
  popularEvents?: Maybe<PopularEventsResponse>;
  product?: Maybe<Product>;
  purchases?: Maybe<PurchasesResponse>;
  qrCodeScan: QrCodeScan;
  radioTrack?: Maybe<Track>;
  radioTrackSections: Array<RadioTrackSection>;
  radioTracks?: Maybe<RadioTracksReturn>;
  radioTracksByCategory?: Maybe<RadioTracksReturn>;
  resolveDeferredLink?: Maybe<DeferredLinkResult>;
  scheduleItem?: Maybe<CatalogItemSchedule>;
  scheduleItemAttendees?: Maybe<UbiqScheduleItemAttendees>;
  scheduleItems?: Maybe<ScheduleItemsResult>;
  searchUsers?: Maybe<Array<User>>;
  shopPurchases: Array<Purchase>;
  shopV2?: Maybe<ShopV2Response>;
  shopV3?: Maybe<ShopV3Response>;
  shopValidCode?: Maybe<Scalars['Boolean']>;
  suggestedCommunities?: Maybe<SuggestedCommunitiesResponse>;
  swapCheckoutInfo?: Maybe<SwapCheckoutInfo>;
  swapEvent?: Maybe<SwapEventResponse>;
  swapEvents?: Maybe<SwapEventsResponse>;
  swapMyTickets?: Maybe<SwapMyTickets>;
  swapOfferableTicketsList: Array<SwapOfferableEvent>;
  swapPurchaseStatus?: Maybe<SwapPurchaseStatus>;
  talksAvailableReactions?: Maybe<Array<TalksAvailableReaction>>;
  talksChannel?: Maybe<TalksChannelResponse>;
  talksChannels?: Maybe<TalksChannelsResponse>;
  talksChat?: Maybe<TalksChatResponse>;
  talksChats?: Maybe<TalksChatsRespo>;
  talksCommunities?: Maybe<TalksCommunitiesResponse>;
  talksMentionSuggestions?: Maybe<Array<TalksMentionSuggestion>>;
  talksUnreadMessages?: Maybe<Scalars['Int']>;
  talksV2?: Maybe<TalksV2Response>;
  talksWerzyChats?: Maybe<TalksWerzyChatsResponse>;
  testInternetConnection?: Maybe<Scalars['Boolean']>;
  thirdPartyIntegrationUpdates: Array<ThirdPartyIntegrationUpdate>;
  thirdPartyIntegrations: Array<ThirdPartyIntegration>;
  topGameScores: Array<TopGameScores>;
  ubiqFeedItems?: Maybe<UbiqFeedItemsResponse>;
  ubiqNotifications?: Maybe<UbiqNotificationsResponse>;
  user?: Maybe<User>;
  userIndicators?: Maybe<UserIndicators>;
  userPopups?: Maybe<Array<Maybe<Modal>>>;
  userProfile?: Maybe<UserProfile>;
  userPrompt?: Maybe<UserPrompt>;
  userSubscriptions?: Maybe<UserSubscriptionsDisplay>;
  usernameAvailable?: Maybe<Scalars['Boolean']>;
  warmer?: Maybe<Scalars['Boolean']>;
};


export type QueryAdminCommunityArgs = {
  where: AdminCommunityWhereUniqueInput;
};


export type QueryAdminGuestListProductsArgs = {
  eventId: Scalars['ID'];
};


export type QueryAdminListEventAttendeeArgs = {
  communityId?: InputMaybe<Scalars['ID']>;
  eventId?: InputMaybe<Scalars['ID']>;
  identifier: Scalars['String'];
};


export type QueryAdminListEventAttendeesArgs = {
  eventId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryAllCalendarEventsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  locationId?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAmbassadorCampaignByCodeArgs = {
  code: Scalars['String'];
};


export type QueryAnnouncementArgs = {
  announcementId: Scalars['ID'];
  communityId?: InputMaybe<Scalars['ID']>;
};


export type QueryAnnouncementsArgs = {
  communityId: Scalars['ID'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryAvailableLocationsArgs = {
  includeNearby?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<AvailableLocationsSource>;
};


export type QueryCaActiveProductsArgs = {
  communityId: Scalars['ID'];
};


export type QueryCaAdminsArgs = {
  communityId: Scalars['ID'];
};


export type QueryCaAgentAttachmentArgs = {
  attachmentId: Scalars['ID'];
  communityId: Scalars['ID'];
  threadId: Scalars['ID'];
};


export type QueryCaAgentBrowserLiveViewArgs = {
  communityId: Scalars['ID'];
  runId: Scalars['ID'];
};


export type QueryCaAgentEmailDraftPreviewArgs = {
  actionId: Scalars['ID'];
  communityId: Scalars['ID'];
};


export type QueryCaAgentRoleThreadsArgs = {
  communityId: Scalars['ID'];
};


export type QueryCaAgentThreadArgs = {
  communityId: Scalars['ID'];
  threadId: Scalars['ID'];
};


export type QueryCaAgentThreadEventsArgs = {
  afterSeq: Scalars['Int'];
  communityId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  runId?: InputMaybe<Scalars['ID']>;
  threadId: Scalars['ID'];
};


export type QueryCaAmbassadorCampaignsArgs = {
  communityId: Scalars['ID'];
  ids?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaAnnouncementArgs = {
  announcementId: Scalars['ID'];
  communityId: Scalars['ID'];
};


export type QueryCaAnnouncementsArgs = {
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  statuses?: InputMaybe<Array<FeedItemPublishingStatus>>;
  take?: Scalars['Int'];
};


export type QueryCaAssignableSegmentsArgs = {
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaCatalogCategoriesArgs = {
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaCatalogItemArgs = {
  catalogItemId: Scalars['ID'];
  communityId: Scalars['ID'];
};


export type QueryCaCatalogItemsArgs = {
  communityId: Scalars['ID'];
  orderBy?: InputMaybe<CaCatalogItemOrderByInput>;
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaCatalogScheduleItemsArgs = {
  catalogItemId?: InputMaybe<Scalars['ID']>;
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaCommunityArgs = {
  code: Scalars['String'];
};


export type QueryCaCommunityMembersArgs = {
  communityId: Scalars['String'];
  numberedId?: InputMaybe<Scalars['Int']>;
  orderByJoinDate?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaCommunityMembersStatsArgs = {
  communityId: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
};


export type QueryCaCommunityMembersV2Args = {
  banned?: InputMaybe<Scalars['Boolean']>;
  communityId: Scalars['String'];
  orderBy?: InputMaybe<Scalars['Json']>;
  search?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaCommunityOverviewStatsArgs = {
  communityId: Scalars['ID'];
};


export type QueryCaCommunityRevenueStatsArgs = {
  communityId: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
};


export type QueryCaCommunitySubscriptionsArgs = {
  communityId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaCommunityThemeArgs = {
  communityId: Scalars['ID'];
  communityThemeId?: InputMaybe<Scalars['ID']>;
  communityThemeSlug?: InputMaybe<Scalars['String']>;
};


export type QueryCaCommunityThemesArgs = {
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaEmailCampaignArgs = {
  communityId: Scalars['ID'];
  emailCampaignId: Scalars['ID'];
};


export type QueryCaEmailCampaignActivityArgs = {
  communityId: Scalars['ID'];
  emailCampaignId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaEmailCampaignStatsArgs = {
  communityId: Scalars['ID'];
  emailCampaignId: Scalars['ID'];
};


export type QueryCaEmailCampaignsArgs = {
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  sendAtSort?: InputMaybe<SortOrder>;
  skip?: Scalars['Int'];
  statuses?: InputMaybe<Array<EmailCampaignStatus>>;
  take?: Scalars['Int'];
};


export type QueryCaEventArgs = {
  eventId: Scalars['ID'];
};


export type QueryCaEventActivityArgs = {
  communityId: Scalars['ID'];
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  eventId: Scalars['ID'];
};


export type QueryCaEventAnalyticsArgs = {
  eventId: Scalars['ID'];
};


export type QueryCaEventAttendanceArgs = {
  eventId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CaEventAttendanceStatus>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCaEventBenchmarkArgs = {
  compareEventId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
};


export type QueryCaEventBenchmarkDetailsArgs = {
  compareEventId?: InputMaybe<Scalars['ID']>;
  day: Scalars['Int'];
  eventId: Scalars['ID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCaEventCategoriesArgs = {
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaEventFunnelArgs = {
  eventId: Scalars['ID'];
};


export type QueryCaEventFunnelDetailsArgs = {
  eventId: Scalars['ID'];
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<CaEventFunnelStage>;
  tab: CaEventFunnelTab;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCaEventGuestsArgs = {
  communityId: Scalars['ID'];
  eventId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaEventOverviewArgs = {
  eventId: Scalars['ID'];
};


export type QueryCaEventProgressDetailsArgs = {
  bucket: Scalars['String'];
  end?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  range: CaEventProgressRange;
  skip?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  tab: CaEventProgressTab;
  take?: InputMaybe<Scalars['Int']>;
  unit?: InputMaybe<CaEventProgressUnit>;
};


export type QueryCaEventSalesProgressArgs = {
  end?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  range: CaEventProgressRange;
  start?: InputMaybe<Scalars['String']>;
};


export type QueryCaEventTicketsActivityArgs = {
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  eventId: Scalars['String'];
};


export type QueryCaEventTopSourcesArgs = {
  eventId: Scalars['ID'];
};


export type QueryCaEventTractionArgs = {
  communityId: Scalars['ID'];
  eventId: Scalars['ID'];
};


export type QueryCaEventViewsProgressArgs = {
  end?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  range: CaEventProgressRange;
  start?: InputMaybe<Scalars['String']>;
};


export type QueryCaEventsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  statuses?: InputMaybe<Array<EventStatus>>;
  take?: Scalars['Int'];
  temporal?: InputMaybe<CaEventTemporalFilter>;
};


export type QueryCaFinancesOverviewArgs = {
  communityId: Scalars['String'];
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  selectedDateFrom?: InputMaybe<Scalars['DateTime']>;
  selectedDateTo?: InputMaybe<Scalars['DateTime']>;
};


export type QueryCaForumItemsArgs = {
  communityId: Scalars['ID'];
  pendingOnly?: Scalars['Boolean'];
  skipPosts?: Scalars['Int'];
  skipReported?: Scalars['Int'];
  takePosts?: Scalars['Int'];
  takeReported?: Scalars['Int'];
};


export type QueryCaGuestListArgs = {
  communityId: Scalars['ID'];
  createdAtSort?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CaGuestListInviteStatus>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCaGuestListClaimsArgs = {
  communityId: Scalars['ID'];
  inviteId: Scalars['ID'];
};


export type QueryCaInstagramCommentsArgs = {
  communityId: Scalars['ID'];
  postId: Scalars['ID'];
};


export type QueryCaInstagramConversationArgs = {
  communityId: Scalars['ID'];
  conversationId: Scalars['ID'];
};


export type QueryCaInstagramConversationsArgs = {
  communityId: Scalars['ID'];
};


export type QueryCaInstagramStoriesArgs = {
  communityId: Scalars['ID'];
};


export type QueryCaJoinRequestDetailArgs = {
  communityId: Scalars['String'];
  userId: Scalars['ID'];
};


export type QueryCaJoinRequestsArgs = {
  communityId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaMassMessageArgs = {
  communityId: Scalars['ID'];
  massMessageId: Scalars['ID'];
};


export type QueryCaMassMessagesArgs = {
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  sendAtSort?: InputMaybe<SortOrder>;
  sentOnly?: InputMaybe<Scalars['Boolean']>;
  skip?: Scalars['Int'];
  statuses?: InputMaybe<Array<MassMessageStatus>>;
  take?: Scalars['Int'];
};


export type QueryCaMemberArgs = {
  communityId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryCaMemberEventsArgs = {
  communityId: Scalars['ID'];
  includeDeclined?: InputMaybe<Scalars['Boolean']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
  userId: Scalars['ID'];
};


export type QueryCaMemberOrdersArgs = {
  communityId: Scalars['ID'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
  userId: Scalars['ID'];
};


export type QueryCaMemberPurchasesArgs = {
  communityId: Scalars['ID'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
  userId: Scalars['ID'];
};


export type QueryCaMonthlyActivityUsersArgs = {
  communityId: Scalars['String'];
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
};


export type QueryCaPotentialAdminsArgs = {
  communityId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaProductArgs = {
  communityId: Scalars['ID'];
  productId: Scalars['ID'];
};


export type QueryCaProductConfigsArgs = {
  communityId: Scalars['ID'];
};


export type QueryCaProductEventArgs = {
  communityId: Scalars['ID'];
  eventId: Scalars['ID'];
};


export type QueryCaProductEventsArgs = {
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCaProductUsageStatsArgs = {
  communityId: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  productId: Scalars['ID'];
};


export type QueryCaProductsArgs = {
  availableToEventId?: InputMaybe<Scalars['ID']>;
  communityId?: InputMaybe<Scalars['ID']>;
  eventId?: InputMaybe<Scalars['ID']>;
  futureOnly?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  statuses?: InputMaybe<Array<ProductStatus>>;
  take?: Scalars['Int'];
  type?: InputMaybe<ProductType>;
};


export type QueryCaPromocodeArgs = {
  communityId: Scalars['ID'];
  promocodeId: Scalars['ID'];
};


export type QueryCaPromocodeRedemptionsArgs = {
  communityId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCaPromocodeUsageStatsArgs = {
  communityId: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  promocodeId: Scalars['ID'];
};


export type QueryCaPromocodesArgs = {
  communityId: Scalars['ID'];
  haveBeenUsed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  statuses?: InputMaybe<Array<PromocodeAdminStatus>>;
  take?: Scalars['Int'];
};


export type QueryCaPromocodesRecentUsagesArgs = {
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaPurchasesArgs = {
  activityEnd?: InputMaybe<Scalars['DateTime']>;
  activityStart?: InputMaybe<Scalars['DateTime']>;
  communityId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaPurchasesActivityArgs = {
  communityId: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
};


export type QueryCaPurchasesFunnelArgs = {
  communityId: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
};


export type QueryCaRadioTrackArgs = {
  communityId: Scalars['ID'];
  trackId: Scalars['ID'];
};


export type QueryCaRadioTracksArgs = {
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaRecentPurchasesArgs = {
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaReviewQueueArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCaReviewReleaseQueueArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCaScheduleCalendarStatsArgs = {
  communityId: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  scheduleItemId: Scalars['ID'];
};


export type QueryCaScheduleItemArgs = {
  communityId: Scalars['ID'];
  scheduleItemId: Scalars['ID'];
};


export type QueryCaScheduleItemsArgs = {
  communityId: Scalars['ID'];
  orderBy?: InputMaybe<Scalars['Json']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCaSegmentArgs = {
  communityId: Scalars['ID'];
  segmentId: Scalars['ID'];
};


export type QueryCaSegmentUsageArgs = {
  communityId: Scalars['ID'];
  segmentId: Scalars['ID'];
};


export type QueryCaSegmentsArgs = {
  communityId: Scalars['ID'];
  order?: InputMaybe<SortOrder>;
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  sort?: InputMaybe<CaSegmentSort>;
  take?: Scalars['Int'];
};


export type QueryCaShopActivityArgs = {
  communityId: Scalars['ID'];
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
};


export type QueryCaSmartLinkArgs = {
  communityId: Scalars['ID'];
  smartLinkId: Scalars['ID'];
};


export type QueryCaSmartLinkOrdersArgs = {
  communityId: Scalars['ID'];
  skip?: InputMaybe<Scalars['Int']>;
  smartLinkId: Scalars['ID'];
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCaSmartLinksArgs = {
  communityId: Scalars['ID'];
  createdAtSort?: InputMaybe<SortOrder>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<SmartLinkStatus>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCaTalksChannelsArgs = {
  communityId: Scalars['ID'];
  orderByName?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCaTalksChatArgs = {
  chatId: Scalars['ID'];
  communityId: Scalars['ID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCaTalksChatsArgs = {
  communityId: Scalars['ID'];
};


export type QueryCaUserActivityLogArgs = {
  communityId?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
  userId: Scalars['ID'];
};


export type QueryCalendarEventsArgs = {
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCatalogItemArgs = {
  catalogItemId: Scalars['ID'];
};


export type QueryCatalogItemsArgs = {
  communityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  selectedCategoryId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: Scalars['Int'];
};


export type QueryCheckoutPostReturnArgs = {
  purchaseIds: Array<Scalars['ID']>;
};


export type QueryCommunityArgs = {
  where: CommunityWhereUniqueInput;
};


export type QueryCommunityInfoArgs = {
  code: Scalars['String'];
};


export type QueryCommunityInventoryArgs = {
  communityId: Scalars['ID'];
  type?: InputMaybe<ProductType>;
};


export type QueryCommunityLandingArgs = {
  communityCode: Scalars['String'];
};


export type QueryCommunityRadiosArgs = {
  communityCode?: InputMaybe<Scalars['String']>;
  curationSlug?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCompetitionTicketArgs = {
  communityCode?: InputMaybe<Scalars['String']>;
  ticketUuid?: InputMaybe<Scalars['String']>;
};


export type QueryContentPreviewArgs = {
  itemId: Scalars['String'];
  landingCode: Scalars['String'];
  type: Scalars['String'];
};


export type QueryCuratedNewsArgs = {
  communityCode?: InputMaybe<Scalars['String']>;
  communityId?: InputMaybe<Scalars['ID']>;
  curationSlug?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryCuratedScheduleItemsArgs = {
  communityCode: Scalars['String'];
  curationSlug: Scalars['String'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryEventArgs = {
  where: EventWhereUniqueInput2;
};


export type QueryEventAttendeesArgs = {
  eventId: Scalars['String'];
  filter: EventRsvpStatus;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryEventRecommendedByArgs = {
  eventId: Scalars['String'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryEventSalesStatsArgs = {
  eventIdOrSlug: Scalars['String'];
  landingCode: Scalars['String'];
};


export type QueryEventV2Args = {
  communityId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
};


export type QueryEventWithTicketsArgs = {
  accessCode?: InputMaybe<Scalars['String']>;
  communityId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
};


export type QueryEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  orderBy?: InputMaybe<Array<EventOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};


export type QueryEventsCalendarArgs = {
  communityId: Scalars['ID'];
  selectedCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  selectedDate?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: Scalars['Int'];
};


export type QueryEventsV2Args = {
  communityId: Scalars['ID'];
  futureOnly?: Scalars['Boolean'];
  search?: Scalars['ID'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryExploreCommunitiesArgs = {
  campaignKey?: InputMaybe<Scalars['String']>;
  fromOnboarding?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  source?: InputMaybe<ExploreCommunitiesSource>;
  take?: Scalars['Int'];
};


export type QueryExploreShortcutsArgs = {
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryFaqCategoriesArgs = {
  communityId: Scalars['ID'];
};


export type QueryFeedEventsViewArgs = {
  communityCode?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  locationId?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryFeedFestivalArgs = {
  communityCode: Scalars['String'];
};


export type QueryFeedItemCommentsArgs = {
  feedItemId: Scalars['ID'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryFeedItemEventInfoArgs = {
  eventId: Scalars['String'];
};


export type QueryFestivalCalendarEventsArgs = {
  communityId: Scalars['ID'];
};


export type QueryForumPostArgs = {
  communityId?: InputMaybe<Scalars['ID']>;
  postId: Scalars['ID'];
};


export type QueryForumPostCommentsArgs = {
  postId: Scalars['ID'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryForumPostsArgs = {
  communityId: Scalars['ID'];
  filterTagId?: InputMaybe<Scalars['ID']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryGetCommunityArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  landingCode?: InputMaybe<Scalars['String']>;
};


export type QueryGetCommunityByInviteCodeArgs = {
  inviteCode: Scalars['String'];
};


export type QueryGuestListInviteArgs = {
  code: Scalars['String'];
};


export type QueryGuestListInvitesArgs = {
  eventId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryInventoryEventArgs = {
  eventId: Scalars['ID'];
};


export type QueryInventoryPurchaseArgs = {
  purchaseId: Scalars['ID'];
};


export type QueryInviteFriendsPromptPageArgs = {
  communityId: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLegacyTalksChatsArgs = {
  chatId?: InputMaybe<Scalars['String']>;
};


export type QueryLegacyTalksMessagesArgs = {
  chatId?: InputMaybe<Scalars['String']>;
};


export type QueryLocationSupportedArgs = {
  userIP?: InputMaybe<Scalars['String']>;
};


export type QueryMapLocationsArgs = {
  communityId: Scalars['ID'];
};


export type QueryMatchDiscoveryStateArgs = {
  communityCode: Scalars['String'];
};


export type QueryMatchInterestArgs = {
  communityCode: Scalars['String'];
};


export type QueryMatchPairArgs = {
  pairId: Scalars['String'];
};


export type QueryMatchPairsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  type: MatchPairListType;
};


export type QueryMatchProfileArgs = {
  communityCode: Scalars['String'];
};


export type QueryMembershipStatusArgs = {
  membershipId: Scalars['ID'];
};


export type QueryMyBadgesArgs = {
  communityId: Scalars['ID'];
};


export type QueryMyCalendarEventsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  skip?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryNewsFeedViewArgs = {
  communityCode?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPopularEventsArgs = {
  includeScheduleItems?: Scalars['Boolean'];
  showHiddenEvents?: Scalars['Boolean'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
  type?: InputMaybe<Scalars['String']>;
};


export type QueryProductArgs = {
  productId: Scalars['ID'];
};


export type QueryQrCodeScanArgs = {
  communityId?: InputMaybe<Scalars['ID']>;
  eventId?: InputMaybe<Scalars['ID']>;
  qrCode: Scalars['String'];
};


export type QueryRadioTrackArgs = {
  communityId?: InputMaybe<Scalars['ID']>;
  trackId: Scalars['ID'];
};


export type QueryRadioTrackSectionsArgs = {
  communityId: Scalars['ID'];
  take?: Scalars['Int'];
};


export type QueryRadioTracksArgs = {
  communityId: Scalars['ID'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryRadioTracksByCategoryArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  communityId: Scalars['ID'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryResolveDeferredLinkArgs = {
  locale: Scalars['String'];
  screenWidth: Scalars['Int'];
  timezone: Scalars['String'];
};


export type QueryScheduleItemArgs = {
  scheduleItemId: Scalars['ID'];
};


export type QueryScheduleItemAttendeesArgs = {
  scheduleItemId: Scalars['String'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryScheduleItemsArgs = {
  communityId: Scalars['ID'];
  curationId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  selectedDate?: InputMaybe<Scalars['String']>;
  selectedTagIds?: InputMaybe<Array<Scalars['ID']>>;
  skip?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  take?: Scalars['Int'];
};


export type QuerySearchUsersArgs = {
  communityId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryShopPurchasesArgs = {
  cursor?: InputMaybe<PurchaseWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PurchaseOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PurchaseWhereInput>;
};


export type QueryShopV2Args = {
  accessCode?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryShopV3Args = {
  accessCode?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  selectedProductType: SelectedProductType;
};


export type QueryShopValidCodeArgs = {
  code: Scalars['String'];
  communityId: Scalars['ID'];
};


export type QuerySuggestedCommunitiesArgs = {
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QuerySwapCheckoutInfoArgs = {
  purchaseId: Scalars['ID'];
};


export type QuerySwapEventArgs = {
  eventId: Scalars['ID'];
};


export type QuerySwapEventsArgs = {
  search?: Scalars['ID'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QuerySwapMyTicketsArgs = {
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QuerySwapPurchaseStatusArgs = {
  purchaseId: Scalars['ID'];
};


export type QueryTalksChannelArgs = {
  channelId: Scalars['ID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTalksChannelsArgs = {
  communityId?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTalksChatArgs = {
  communityId?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  werzySenderId?: InputMaybe<Scalars['String']>;
};


export type QueryTalksChatsArgs = {
  communityId?: InputMaybe<Scalars['String']>;
};


export type QueryTalksMentionSuggestionsArgs = {
  channelId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTalksV2Args = {
  communityId?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryThirdPartyIntegrationUpdatesArgs = {
  id: Scalars['String'];
};


export type QueryThirdPartyIntegrationsArgs = {
  communityId: Scalars['String'];
};


export type QueryTopGameScoresArgs = {
  game?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryUbiqFeedItemsArgs = {
  feedSessionId?: InputMaybe<Scalars['String']>;
  recentlySeenFeedItemIds?: InputMaybe<Array<Scalars['String']>>;
  seed?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QueryUbiqNotificationsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUserProfileArgs = {
  userId: Scalars['ID'];
};


export type QueryUsernameAvailableArgs = {
  username: Scalars['String'];
};

export type RadioTrackSection = {
  __typename?: 'RadioTrackSection';
  categoryId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  items: Array<Track>;
  next: Scalars['Int'];
  title: Scalars['String'];
  total: Scalars['Int'];
};

export type ReadMessageResponse = {
  __typename?: 'ReadMessageResponse';
  errors?: Maybe<Array<Maybe<TranslatableError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RecommendedByUser = {
  __typename?: 'RecommendedByUser';
  avatar?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['String'];
};

export type RegisterPushDeviceInput = {
  app: PushApp;
  expoPushToken: Scalars['String'];
  permissionGranted: Scalars['Boolean'];
  platform: PushPlatform;
};

export type RequestProductsPurchase = {
  __typename?: 'RequestProductsPurchase';
  kustomCheckoutHtmlSnippet?: Maybe<Scalars['String']>;
  kustomCheckoutOrderId?: Maybe<Scalars['String']>;
  orderId: Scalars['String'];
  purchaseIds?: Maybe<Array<Scalars['String']>>;
  stripeFallbackUrl?: Maybe<Scalars['String']>;
  stripePaymentIntentClientSecret?: Maybe<Scalars['String']>;
  stripeRedirectUrl?: Maybe<Scalars['String']>;
  stripeSwishQRUrl?: Maybe<Scalars['String']>;
  swishCheckoutDeepLink?: Maybe<Scalars['String']>;
};

export type RequestProductsPurchaseInput = {
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  fairPrice?: InputMaybe<Scalars['Float']>;
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  variant?: InputMaybe<ProductVariantInput>;
};

export type RequestSubscriptionPurchase = {
  __typename?: 'RequestSubscriptionPurchase';
  membershipId?: Maybe<Scalars['String']>;
  stripePaymentIntentClientSecret?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
};

export type RequestSwapPayload = {
  __typename?: 'RequestSwapPayload';
  purchaseId: Scalars['ID'];
  stripeFallbackUrl?: Maybe<Scalars['String']>;
  stripePaymentIntentClientSecret?: Maybe<Scalars['String']>;
  stripeRedirectUrl?: Maybe<Scalars['String']>;
  stripeSwishQRUrl?: Maybe<Scalars['String']>;
};

export type RequestTalksChannelAccessResponse = {
  __typename?: 'RequestTalksChannelAccessResponse';
  accessState: TalksChannelAccessState;
  channelId: Scalars['String'];
};

export type SalesData = {
  __typename?: 'SalesData';
  endDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
  total?: Maybe<Scalars['Float']>;
};

export type SaveMatchProfileInput = {
  activate?: InputMaybe<Scalars['Boolean']>;
  additionalInfo?: InputMaybe<Scalars['JSON']>;
  answer?: InputMaybe<MatchAnswerInput>;
  contacts?: InputMaybe<Scalars['JSON']>;
  elevatorPitch?: InputMaybe<Scalars['String']>;
  optOut?: InputMaybe<Scalars['Boolean']>;
  photos?: InputMaybe<Array<Scalars['String']>>;
};

export type ScheduleCalendarDailyData = {
  __typename?: 'ScheduleCalendarDailyData';
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
};

export enum ScheduleItemRsvpStatus {
  Going = 'Going',
  Interested = 'Interested',
  NotInterested = 'NotInterested'
}

export type Segment = {
  __typename?: 'Segment';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instructions?: Maybe<Scalars['String']>;
  membersCount: Scalars['Int'];
  name: Scalars['String'];
  systemGenerated: Scalars['Boolean'];
  type: SegmentType;
  updatedAt: Scalars['DateTime'];
};

export enum SegmentType {
  Dynamic = 'Dynamic',
  Static = 'Static'
}

export enum SelectedProductType {
  Accomodation = 'Accomodation',
  All = 'All',
  Bundle = 'Bundle',
  Clothing = 'Clothing',
  Digital = 'Digital',
  Membership = 'Membership',
  Merch = 'Merch',
  Music = 'Music',
  Sauna = 'Sauna',
  Ticket = 'Ticket',
  Token = 'Token'
}

export type ShopV2Response = {
  __typename?: 'ShopV2Response';
  items: Array<Product>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type ShopV3Response = {
  __typename?: 'ShopV3Response';
  availableProductTypes: Array<ProductType>;
  eventsWithProducts: Array<EventWithProducts>;
  nonTicketProducts: Array<Product>;
};

export enum SignUpStep {
  AddIg = 'AddIG',
  ConfirmationCode = 'ConfirmationCode',
  Email = 'Email',
  FirstName = 'FirstName',
  Interests = 'Interests',
  JoinCommunities = 'JoinCommunities',
  LastName = 'LastName',
  Password = 'Password',
  ProfilePicture = 'ProfilePicture',
  Pronouns = 'Pronouns',
  PushNotifications = 'PushNotifications',
  StartAndEnterPhone = 'StartAndEnterPhone',
  Username = 'Username'
}

export type SmartLink = {
  __typename?: 'SmartLink';
  createdAt: Scalars['DateTime'];
  destination: SmartLinkDestination;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Orders with a Paid purchase the link was credited with */
  purchases: Scalars['Int'];
  status: SmartLinkStatus;
  url: Scalars['String'];
  /** People who opened the link: the account, else the web visitor */
  views: Scalars['Int'];
};

export enum SmartLinkAction {
  Activate = 'Activate',
  Archive = 'Archive',
  Create = 'Create',
  Deactivate = 'Deactivate',
  Duplicate = 'Duplicate',
  Publish = 'Publish',
  Update = 'Update'
}

export type SmartLinkChangeInput = {
  action: SmartLinkAction;
  /** Create; Update while the link is a Draft; Publish: the Event the admin reviewed (SMART_LINK_EVENT_CHANGED if the link points elsewhere) */
  eventId?: InputMaybe<Scalars['ID']>;
  /** Create and Update */
  name?: InputMaybe<Scalars['String']>;
  /** Create: Active instead of Draft */
  publish?: InputMaybe<Scalars['Boolean']>;
  /** Every action but Create */
  smartLinkId?: InputMaybe<Scalars['ID']>;
};

export type SmartLinkDestination = {
  __typename?: 'SmartLinkDestination';
  eventId: Scalars['ID'];
  name: Scalars['String'];
  publishingStatus: EventStatus;
  start?: Maybe<Scalars['DateTime']>;
};

export type SmartLinkOrdersPage = {
  __typename?: 'SmartLinkOrdersPage';
  /** The currency of every amount */
  currency: Scalars['String'];
  /** One row per order, as the event Overview's Sales details */
  items: Array<CaEventDetail>;
  /** Orders */
  total: Scalars['Int'];
  /** Every order's amount */
  totalAmount: Scalars['Float'];
  /** Every order's products */
  totalProducts: Scalars['Int'];
};

export enum SmartLinkStatus {
  Active = 'Active',
  Draft = 'Draft',
  Inactive = 'Inactive'
}

export type SmartLinksPage = {
  __typename?: 'SmartLinksPage';
  items: Array<SmartLink>;
  total: Scalars['Int'];
};

/** Sort order for query results */
export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
};

export type StringFilter2 = {
  equals?: InputMaybe<Scalars['String']>;
};

export type StringFilter3 = {
  equals?: InputMaybe<Scalars['String']>;
};

export type StringFilter8 = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
};

export type StringInFilter = {
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type StringUpdateInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type SuggestedCommunitiesResponse = {
  __typename?: 'SuggestedCommunitiesResponse';
  description?: Maybe<Scalars['String']>;
  items: Array<SuggestedCommunity>;
  next: Scalars['Int'];
  thankYouMessage?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

export type SuggestedCommunity = {
  __typename?: 'SuggestedCommunity';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  liked?: Maybe<Scalars['Boolean']>;
  likesCount: Scalars['Int'];
  name: Scalars['String'];
  suggestedByUserId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum SuggestedCommunityStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
  Submitted = 'Submitted'
}

export enum SupportedCountries {
  De = 'DE',
  Dk = 'DK',
  Fi = 'FI',
  Gb = 'GB',
  It = 'IT',
  Nl = 'NL',
  Se = 'SE',
  Us = 'US'
}

export enum SupportedCurrencies {
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Sek = 'SEK',
  Usd = 'USD'
}

export type SwapAvailablePaymentMethod = {
  __typename?: 'SwapAvailablePaymentMethod';
  iconUrl: Scalars['String'];
  name: Scalars['String'];
  paymentMethod: PurchasePaymentMethod;
};

export type SwapCheckoutInfo = {
  __typename?: 'SwapCheckoutInfo';
  availablePaymentMethods: Array<SwapAvailablePaymentMethod>;
  currency: SupportedCurrencies;
  isFree: Scalars['Boolean'];
  stripeAccountId: Scalars['String'];
  summaryItems: Array<SwapSummaryItem>;
  terms: Array<Scalars['String']>;
};

export type SwapEventResponse = {
  __typename?: 'SwapEventResponse';
  event: Event;
  offers: Array<Purchase>;
};

export type SwapEventsResponse = {
  __typename?: 'SwapEventsResponse';
  items: Array<Event>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type SwapMyTickets = {
  __typename?: 'SwapMyTickets';
  items: Array<Purchase>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type SwapOfferableCommunity = {
  __typename?: 'SwapOfferableCommunity';
  currency: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SwapOfferableEvent = {
  __typename?: 'SwapOfferableEvent';
  end: Scalars['DateTime'];
  id: Scalars['String'];
  location: Scalars['String'];
  locationDisplayCompact: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentCommunity: SwapOfferableCommunity;
  products: Array<SwapOfferableProduct>;
  start: Scalars['DateTime'];
  swapTerms: Array<Scalars['String']>;
};

export type SwapOfferableProduct = {
  __typename?: 'SwapOfferableProduct';
  id: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  purchases: Array<SwapOfferablePurchase>;
};

export type SwapOfferablePurchase = {
  __typename?: 'SwapOfferablePurchase';
  currency: SupportedCurrencies;
  id: Scalars['String'];
  productDescription: Scalars['String'];
  productName: Scalars['String'];
};

export type SwapPurchaseStatus = {
  __typename?: 'SwapPurchaseStatus';
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
};

export type SwapSummaryItem = {
  __typename?: 'SwapSummaryItem';
  item: Scalars['String'];
  value: Scalars['String'];
};

export type SyncPushPlayerIdsResponse = {
  __typename?: 'SyncPushPlayerIdsResponse';
  errors?: Maybe<Array<Maybe<TranslatableError>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TalksAvailableReaction = {
  __typename?: 'TalksAvailableReaction';
  displayChar: Scalars['String'];
  reactionType: Scalars['String'];
};

export type TalksChannel = {
  __typename?: 'TalksChannel';
  community: Community;
  communityId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  latestMessage?: Maybe<TalksMessage>;
  name: Scalars['String'];
  talksMessages: Array<TalksMessage>;
  unreadCount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export enum TalksChannelAccessState {
  Accessible = 'Accessible',
  RequestPending = 'RequestPending',
  RequiresOptIn = 'RequiresOptIn',
  RequiresRequest = 'RequiresRequest'
}

export type TalksChannelResponse = {
  __typename?: 'TalksChannelResponse';
  items: Array<TalksMessage>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type TalksChannelsItem = {
  __typename?: 'TalksChannelsItem';
  accessState: TalksChannelAccessState;
  channelId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  joinRequirements?: Maybe<Scalars['Json']>;
  latestMessage?: Maybe<Scalars['String']>;
  latestMessageTimestamp?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  unreadCount: Scalars['Int'];
};

export type TalksChannelsResponse = {
  __typename?: 'TalksChannelsResponse';
  items: Array<TalksChannelsItem>;
  next?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TalksChatOld = {
  __typename?: 'TalksChatOld';
  communityId: Scalars['String'];
  iconUrl: Scalars['String'];
  latestMessageTime?: Maybe<Scalars['DateTime']>;
  unreadCount: Scalars['Int'];
};

export type TalksChatResponse = {
  __typename?: 'TalksChatResponse';
  items: Array<TalksMessage>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type TalksChatsItem = {
  __typename?: 'TalksChatsItem';
  communityId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  iconUrl?: Maybe<Scalars['String']>;
  latestMessage?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  unreadCount: Scalars['Int'];
};

export type TalksChatsRespo = {
  __typename?: 'TalksChatsRespo';
  items: Array<TalksChatsItem>;
};

export type TalksChatsResponse = {
  __typename?: 'TalksChatsResponse';
  chats?: Maybe<Array<Maybe<AdminChat>>>;
};

export type TalksCommunitiesResponse = {
  __typename?: 'TalksCommunitiesResponse';
  communities: Array<TalksCommunity>;
  werzyUnreadCount: Scalars['Int'];
};

export type TalksCommunity = {
  __typename?: 'TalksCommunity';
  communityId: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  unreadCount: Scalars['Int'];
};

export type TalksMentionSuggestion = {
  __typename?: 'TalksMentionSuggestion';
  avatar?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['String'];
  username: Scalars['String'];
};

export type TalksMessage = {
  __typename?: 'TalksMessage';
  actionDeepLink?: Maybe<Scalars['String']>;
  attachmentId?: Maybe<Scalars['String']>;
  channel?: Maybe<TalksChannel>;
  channelId?: Maybe<Scalars['String']>;
  community?: Maybe<Community>;
  communityId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  data: Scalars['Json'];
  event?: Maybe<Event>;
  id: Scalars['String'];
  inAppLink?: Maybe<Scalars['String']>;
  joinedCommunityAlready: Scalars['Boolean'];
  linkedPurchase?: Maybe<Purchase>;
  media: Array<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  mine: Scalars['Boolean'];
  reactions: Array<DisplayReaction>;
  read: Scalars['Boolean'];
  recipient?: Maybe<User>;
  recipientId?: Maybe<Scalars['String']>;
  replyToMessageId?: Maybe<Scalars['String']>;
  sender?: Maybe<User>;
  senderId?: Maybe<Scalars['String']>;
  senderTitle?: Maybe<Scalars['String']>;
  status: MessageHighlightStatus;
  type: TalksMessageType;
  updatedAt: Scalars['DateTime'];
};

export enum TalksMessageType {
  AccountDeleted = 'AccountDeleted',
  CommentLiked = 'CommentLiked',
  CommentReplied = 'CommentReplied',
  CommunityInvite = 'CommunityInvite',
  Direct = 'Direct',
  InvitedPrivateEvent = 'InvitedPrivateEvent',
  JoinedWithInviteCode = 'JoinedWithInviteCode',
  LocationDropped = 'LocationDropped',
  NewEventDetails = 'NewEventDetails',
  SharedInventory = 'SharedInventory',
  UserSuggestionAdmin = 'UserSuggestionAdmin',
  WelcomeCommunity = 'WelcomeCommunity'
}

export type TalksMessagesResponse = {
  __typename?: 'TalksMessagesResponse';
  adminId?: Maybe<Scalars['String']>;
  chats?: Maybe<Array<Maybe<Chat>>>;
  talksMessages?: Maybe<Array<Maybe<TalksMessage>>>;
};

export type TalksV2Response = {
  __typename?: 'TalksV2Response';
  chats: Array<TalksChatOld>;
  items: Array<TalksMessage>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type TalksWerzyChatsResponse = {
  __typename?: 'TalksWerzyChatsResponse';
  chats?: Maybe<Array<Maybe<WerzyChat>>>;
};

export type TemplateBadge = {
  __typename?: 'TemplateBadge';
  claimedBadges: Array<ClaimedBadge>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentCommunity: Community;
  parentCommunityId: Scalars['String'];
  products: Array<Product>;
  updatedAt: Scalars['DateTime'];
};

export type ThirdPartyIntegration = {
  __typename?: 'ThirdPartyIntegration';
  allowAction: Scalars['Boolean'];
  canBeActivated: Scalars['Boolean'];
  connectedAccountType?: Maybe<Scalars['String']>;
  connectedAccountUsername?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  icon: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  instagramFeatures: Array<InstagramFeature>;
  instagramReconnectMessage?: Maybe<Scalars['String']>;
  instagramScopes: Array<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  requiresReauth: Scalars['Boolean'];
  statusColor: Scalars['String'];
  statusName: Scalars['String'];
};

export type ThirdPartyIntegrationUpdate = {
  __typename?: 'ThirdPartyIntegrationUpdate';
  caption?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  igComments?: Maybe<Scalars['Int']>;
  igInsights: Array<CaInstagramInsight>;
  igLikes?: Maybe<Scalars['Int']>;
  igMediaId?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['String']>;
  mediaIcon?: Maybe<Scalars['String']>;
  scLikes?: Maybe<Scalars['Int']>;
  scPlays?: Maybe<Scalars['Int']>;
};

export enum TicketBarDestination {
  External = 'External',
  Shop = 'Shop'
}

export type Token = {
  __typename?: 'Token';
  communityCode: Scalars['String'];
  communityName: Scalars['String'];
  tokenIds: Array<Maybe<Scalars['String']>>;
  tokenImageUrl?: Maybe<Scalars['String']>;
  tokenName: Scalars['String'];
  tokensAvailable: Scalars['Int'];
};

export type Tools = {
  __typename?: 'Tools';
  calendarEvents: Array<Maybe<Scalars['String']>>;
  inventory: Scalars['Boolean'];
  settings: Scalars['Boolean'];
};

export type TopGameScores = {
  __typename?: 'TopGameScores';
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isCurrentPlayer?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
};

export type Track = {
  __typename?: 'Track';
  artist?: Maybe<Scalars['String']>;
  artistDetails?: Maybe<Scalars['String']>;
  category?: Maybe<TrackCategory>;
  categoryId?: Maybe<Scalars['String']>;
  community: Community;
  communityId: Scalars['String'];
  coverUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  socialMediaLinks: Array<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  status: TrackPublishingStatus;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  type: TrackType;
  updatedAt: Scalars['DateTime'];
};

export type TrackCategory = {
  __typename?: 'TrackCategory';
  community: Community;
  communityId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export enum TrackPublishingStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  PendingReview = 'PendingReview',
  Published = 'Published',
  Rejected = 'Rejected',
  UneditedDraft = 'UneditedDraft'
}

export enum TrackType {
  AudioLive = 'AudioLive',
  AudioRecorded = 'AudioRecorded'
}

export type TranslatableError = {
  __typename?: 'TranslatableError';
  errorCode?: Maybe<TranslatableErrorCode>;
  path?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum TranslatableErrorCode {
  AlreadyBought = 'AlreadyBought',
  AlreadyInUse = 'AlreadyInUse',
  InternalServerError = 'InternalServerError',
  InvalidFirstName = 'InvalidFirstName',
  InvalidInviteCode = 'InvalidInviteCode',
  InvalidLastName = 'InvalidLastName',
  InvalidPassword = 'InvalidPassword',
  InvalidPasswordResetCode = 'InvalidPasswordResetCode',
  InvalidUsername = 'InvalidUsername',
  InvalidVerificationCode = 'InvalidVerificationCode',
  InvalidWalletSignature = 'InvalidWalletSignature',
  NotAllowedToMutatePost = 'NotAllowedToMutatePost',
  NotAllowedToMutateUser = 'NotAllowedToMutateUser',
  ProductNotFound = 'ProductNotFound',
  SpecifyIdentifier = 'SpecifyIdentifier',
  SpecifyUsernameOrPhone = 'SpecifyUsernameOrPhone',
  UserNotFound = 'UserNotFound',
  UserNotFoundOAuth = 'UserNotFoundOAuth'
}

export type UbiqEventAttendee = {
  __typename?: 'UbiqEventAttendee';
  avatar?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['String'];
};

export type UbiqEventAttendees = {
  __typename?: 'UbiqEventAttendees';
  attendees: Array<UbiqEventAttendee>;
  myRSVP?: Maybe<EventRsvpStatus>;
  next: Scalars['Int'];
  totalGoing: Scalars['Int'];
  totalInterested: Scalars['Int'];
};

export type UbiqFeedItem = {
  __typename?: 'UbiqFeedItem';
  alreadyJoinedLinkedCommunity: Scalars['Boolean'];
  commentsCount?: Maybe<Scalars['Int']>;
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayType?: Maybe<Scalars['String']>;
  headerCTAText: Scalars['String'];
  headerCTAUrl: Scalars['String'];
  headerIconUrl?: Maybe<Scalars['String']>;
  headerSecondaryText?: Maybe<Scalars['String']>;
  headerText: Scalars['String'];
  id: Scalars['String'];
  isSmallMedia: Scalars['Boolean'];
  liked?: Maybe<Scalars['Boolean']>;
  likesCount?: Maybe<Scalars['Int']>;
  linkedCommunity?: Maybe<Community>;
  linkedCommunityCode?: Maybe<Scalars['String']>;
  linkedItemId?: Maybe<Scalars['String']>;
  linkedModule?: Maybe<Module>;
  media: Array<Scalars['String']>;
  mediaHeight?: Maybe<Scalars['Int']>;
  mediaWidth?: Maybe<Scalars['Int']>;
  needToRequestAccess: Scalars['Boolean'];
  order?: Maybe<Scalars['Int']>;
  shareUrl?: Maybe<Scalars['String']>;
  showReactions: Scalars['Boolean'];
  status: UbiqFeedItemStatus;
  suggestJoin: Scalars['Boolean'];
  suggestionText: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  totalRequestedAccess?: Maybe<Scalars['Int']>;
  type: UbiqFeedItemType;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export enum UbiqFeedItemStatus {
  Active = 'Active',
  Hidden = 'Hidden'
}

export enum UbiqFeedItemType {
  Custom = 'Custom',
  EventDatesUpdated = 'EventDatesUpdated',
  EventDescriptionUpdated = 'EventDescriptionUpdated',
  EventLocationDropped = 'EventLocationDropped',
  EventLocationDroppingSoon = 'EventLocationDroppingSoon',
  EventLocationUpdated = 'EventLocationUpdated',
  EventPublished = 'EventPublished',
  NewsItemPublished = 'NewsItemPublished',
  RadioTrackPublished = 'RadioTrackPublished',
  ShopItemAlmostSoldOut = 'ShopItemAlmostSoldOut',
  ShopItemAvailable = 'ShopItemAvailable',
  ShopItemSoldOut = 'ShopItemSoldOut'
}

export type UbiqFeedItemsResponse = {
  __typename?: 'UbiqFeedItemsResponse';
  feedBanners: Array<FeedBanner>;
  feedViews: Array<FeedView>;
  items: Array<UbiqFeedItem>;
  next: Scalars['Int'];
  specialItems: Array<FeedSpecialItem>;
  total: Scalars['Int'];
};

export type UbiqMatchCommunity = {
  __typename?: 'UbiqMatchCommunity';
  code?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UbiqMatchPair = {
  __typename?: 'UbiqMatchPair';
  community: UbiqMatchCommunity;
  contacts?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  profile: MatchCandidateProfile;
  status: MatchPairStatus;
  updatedAt: Scalars['DateTime'];
};

export type UbiqNotification = {
  __typename?: 'UbiqNotification';
  clickedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  deeplink: Scalars['String'];
  iconUrls: Array<Scalars['String']>;
  id: Scalars['String'];
  isNew: Scalars['Boolean'];
  lastMeaningfulUpdateAt: Scalars['DateTime'];
  originators: Scalars['Json'];
  recipientId: Scalars['String'];
  seenAt?: Maybe<Scalars['DateTime']>;
  text: Scalars['String'];
  type: UbiqNotificationType;
  updatedAt: Scalars['DateTime'];
};

export enum UbiqNotificationStateAction {
  Clicked = 'Clicked',
  Seen = 'Seen'
}

export enum UbiqNotificationType {
  ChatMessageReacted = 'ChatMessageReacted',
  ChatMessageReplied = 'ChatMessageReplied',
  CommunityRecommendation = 'CommunityRecommendation',
  EmailVerification = 'EmailVerification',
  EventCommunityInvite = 'EventCommunityInvite',
  EventInvite = 'EventInvite',
  EventOpeningSoon = 'EventOpeningSoon',
  EventRecommendation = 'EventRecommendation',
  EventUpcoming = 'EventUpcoming',
  NewsCommentLiked = 'NewsCommentLiked',
  NewsCommentReplied = 'NewsCommentReplied',
  ProfileBioMissing = 'ProfileBioMissing',
  ProfilePhotoMissing = 'ProfilePhotoMissing',
  PushMirror = 'PushMirror',
  TicketSwapMatched = 'TicketSwapMatched',
  TicketSwapWanted = 'TicketSwapWanted',
  TicketTransferIncoming = 'TicketTransferIncoming',
  TicketTransferPending = 'TicketTransferPending'
}

export type UbiqNotificationsResponse = {
  __typename?: 'UbiqNotificationsResponse';
  items: Array<UbiqNotification>;
  next: Scalars['Int'];
  total: Scalars['Int'];
  unseenCount: Scalars['Int'];
};

export type UbiqScheduleItemAttendee = {
  __typename?: 'UbiqScheduleItemAttendee';
  avatar?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['String'];
};

export type UbiqScheduleItemAttendees = {
  __typename?: 'UbiqScheduleItemAttendees';
  attendees: Array<UbiqScheduleItemAttendee>;
  myRsvp?: Maybe<ScheduleItemRsvpStatus>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export enum UnifiedPublishingStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Published = 'Published'
}

export type UpcomingEventsResponse = {
  __typename?: 'UpcomingEventsResponse';
  items: Array<DisplayEvent>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type UpdateCompetitionTicketResult = {
  __typename?: 'UpdateCompetitionTicketResult';
  correct?: Maybe<Scalars['Boolean']>;
  isWinner?: Maybe<Scalars['Boolean']>;
  state: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']>;
  badges: Array<ClaimedBadge>;
  bio?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateTime']>;
  checkedInEvents: Array<Event>;
  communitiesWhereAdmin: Array<Community>;
  communitiesWhereMember: Array<Community>;
  communitiesWhereRequested: Array<Community>;
  communityMemberSince?: Maybe<Scalars['Date']>;
  communityOnboardingInfo?: Maybe<Scalars['Json']>;
  completedDiscoverOnboarding?: Maybe<Scalars['Boolean']>;
  completedIDCardOnboarding: Scalars['Boolean'];
  completedInventoryOnboarding: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  displayNameSetting: UserDisplayNameSetting;
  email?: Maybe<Scalars['String']>;
  emailSubStatuses: Scalars['Json'];
  emailVerified: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  fromWeb: Scalars['Boolean'];
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instagramHandle?: Maybe<Scalars['String']>;
  interests: Array<DisplayInterest>;
  /** @deprecated Legacy event invitation relation retained for compatibility; not current membership or RSVP/attendance. */
  invitedEvents: Array<Event>;
  karma: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  mcaUpdateRequired: Scalars['Boolean'];
  mcaVersion?: Maybe<Scalars['String']>;
  notificationsEnabled?: Maybe<Scalars['Boolean']>;
  notificationsLastPromptedAt?: Maybe<Scalars['DateTime']>;
  numberedId: Scalars['Int'];
  passwordSet: Scalars['Boolean'];
  phone?: Maybe<Scalars['String']>;
  phoneVerified: Scalars['Boolean'];
  postalCode?: Maybe<Scalars['String']>;
  primaryCommunity?: Maybe<Community>;
  pronouns?: Maybe<Scalars['String']>;
  purchases: Array<Purchase>;
  pushPlayerIds: Scalars['String'];
  registeredEvents: Array<Event>;
  requirePasswordChange: Scalars['Boolean'];
  role: UserRole;
  socialLinks: Scalars['Json'];
  solanaWalletAddress?: Maybe<Scalars['String']>;
  ticketsEvents: Array<Event>;
  updatedAt: Scalars['DateTime'];
  username?: Maybe<Scalars['String']>;
  versionOfWerz?: Maybe<Scalars['String']>;
};


export type UserCommunitiesWhereMemberArgs = {
  where?: InputMaybe<CommunityWhereInput>;
};


export type UserCommunityMemberSinceArgs = {
  communityId?: InputMaybe<Scalars['String']>;
};


export type UserPurchasesArgs = {
  where?: InputMaybe<PurchaseWhereInput>;
};

export type UserActivityEvent = {
  __typename?: 'UserActivityEvent';
  communityCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  data: Scalars['Json'];
  id: Scalars['String'];
  source: UserActivityEventSource;
  type: UserActivityEventType;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export enum UserActivityEventSource {
  Api = 'API',
  MobileMembers = 'MobileMembers',
  WebMembers = 'WebMembers'
}

export enum UserActivityEventType {
  ActivityClicked = 'ActivityClicked',
  ActivityScreenOpened = 'ActivityScreenOpened',
  AppActive = 'AppActive',
  AppBackground = 'AppBackground',
  AppOpened = 'AppOpened',
  AppstoreLinksClicked = 'AppstoreLinksClicked',
  AuthCompleteAccountSubmitAttempt = 'AuthCompleteAccountSubmitAttempt',
  AuthCompleteAccountSubmitFailed = 'AuthCompleteAccountSubmitFailed',
  AuthCompleteAccountSubmitSuccess = 'AuthCompleteAccountSubmitSuccess',
  AuthEmailPasswordSubmitAttempt = 'AuthEmailPasswordSubmitAttempt',
  AuthEmailPasswordSubmitFailed = 'AuthEmailPasswordSubmitFailed',
  AuthEmailPasswordSubmitSuccess = 'AuthEmailPasswordSubmitSuccess',
  AuthEnterEmailStepOpened = 'AuthEnterEmailStepOpened',
  AuthEnterPasswordStepOpened = 'AuthEnterPasswordStepOpened',
  AuthEnterPhoneNumberStepOpened = 'AuthEnterPhoneNumberStepOpened',
  AuthLandingStepOpened = 'AuthLandingStepOpened',
  AuthLoginEnterNewPasswordStepOpened = 'AuthLoginEnterNewPasswordStepOpened',
  AuthLoginEnterNewPasswordSubmitAttempt = 'AuthLoginEnterNewPasswordSubmitAttempt',
  AuthLoginEnterNewPasswordSubmitFailed = 'AuthLoginEnterNewPasswordSubmitFailed',
  AuthLoginEnterNewPasswordSubmitSuccess = 'AuthLoginEnterNewPasswordSubmitSuccess',
  AuthLoginEnterResetCodeStepOpened = 'AuthLoginEnterResetCodeStepOpened',
  AuthLoginNoAccount = 'AuthLoginNoAccount',
  AuthLoginOpened = 'AuthLoginOpened',
  AuthLoginResendCodeSubmitAttempt = 'AuthLoginResendCodeSubmitAttempt',
  AuthLoginResendCodeSubmitFailed = 'AuthLoginResendCodeSubmitFailed',
  AuthLoginResendCodeSubmitSuccess = 'AuthLoginResendCodeSubmitSuccess',
  AuthLoginResetCodeSubmitAttempt = 'AuthLoginResetCodeSubmitAttempt',
  AuthLoginResetCodeSubmitFailed = 'AuthLoginResetCodeSubmitFailed',
  AuthLoginResetCodeSubmitSuccess = 'AuthLoginResetCodeSubmitSuccess',
  AuthLoginResetPasswordStepOpened = 'AuthLoginResetPasswordStepOpened',
  AuthLoginResetPasswordSubmitAttempt = 'AuthLoginResetPasswordSubmitAttempt',
  AuthLoginResetPasswordSubmitFailed = 'AuthLoginResetPasswordSubmitFailed',
  AuthLoginResetPasswordSubmitSuccess = 'AuthLoginResetPasswordSubmitSuccess',
  AuthPasswordResetCodeResendSubmitAttempt = 'AuthPasswordResetCodeResendSubmitAttempt',
  AuthPasswordResetCodeResendSubmitFailed = 'AuthPasswordResetCodeResendSubmitFailed',
  AuthPasswordResetCodeResendSubmitSuccess = 'AuthPasswordResetCodeResendSubmitSuccess',
  AuthPasswordResetCodeSubmitAttempt = 'AuthPasswordResetCodeSubmitAttempt',
  AuthPasswordResetCodeSubmitFailed = 'AuthPasswordResetCodeSubmitFailed',
  AuthPasswordResetCodeSubmitSuccess = 'AuthPasswordResetCodeSubmitSuccess',
  AuthPasswordResetEnterCodeStepOpened = 'AuthPasswordResetEnterCodeStepOpened',
  AuthPasswordResetEnterUsernameOrEmailStepOpened = 'AuthPasswordResetEnterUsernameOrEmailStepOpened',
  AuthPasswordResetSetNewPasswordStepOpened = 'AuthPasswordResetSetNewPasswordStepOpened',
  AuthPasswordResetSetNewPasswordSubmitAttempt = 'AuthPasswordResetSetNewPasswordSubmitAttempt',
  AuthPasswordResetSetNewPasswordSubmitFailed = 'AuthPasswordResetSetNewPasswordSubmitFailed',
  AuthPasswordResetSetNewPasswordSubmitSuccess = 'AuthPasswordResetSetNewPasswordSubmitSuccess',
  AuthPasswordResetUsernameOrEmailSubmitAttempt = 'AuthPasswordResetUsernameOrEmailSubmitAttempt',
  AuthPasswordResetUsernameOrEmailSubmitFailed = 'AuthPasswordResetUsernameOrEmailSubmitFailed',
  AuthPasswordResetUsernameOrEmailSubmitSuccess = 'AuthPasswordResetUsernameOrEmailSubmitSuccess',
  AuthPhoneNumberSubmitAttempt = 'AuthPhoneNumberSubmitAttempt',
  AuthPhoneNumberSubmitFailed = 'AuthPhoneNumberSubmitFailed',
  AuthPhoneNumberSubmitSuccess = 'AuthPhoneNumberSubmitSuccess',
  AuthQuitConfirmationOpened = 'AuthQuitConfirmationOpened',
  AuthQuitConfirmationYes = 'AuthQuitConfirmationYes',
  AuthRegisterAddIgStepOpened = 'AuthRegisterAddIGStepOpened',
  AuthRegisterAddIgSubmitAttempt = 'AuthRegisterAddIGSubmitAttempt',
  AuthRegisterAddIgSubmitFailed = 'AuthRegisterAddIGSubmitFailed',
  AuthRegisterAddIgSubmitSuccess = 'AuthRegisterAddIGSubmitSuccess',
  AuthRegisterAlreadyHaveAccountStepOpened = 'AuthRegisterAlreadyHaveAccountStepOpened',
  AuthRegisterCreatePasswordStepOpened = 'AuthRegisterCreatePasswordStepOpened',
  AuthRegisterCreateUsernameStepOpened = 'AuthRegisterCreateUsernameStepOpened',
  AuthRegisterEnterEmailStepOpened = 'AuthRegisterEnterEmailStepOpened',
  AuthRegisterEnterEmailSubmitAttempt = 'AuthRegisterEnterEmailSubmitAttempt',
  AuthRegisterEnterEmailSubmitFailed = 'AuthRegisterEnterEmailSubmitFailed',
  AuthRegisterEnterEmailSubmitSuccess = 'AuthRegisterEnterEmailSubmitSuccess',
  AuthRegisterEnterPasswordStepOpened = 'AuthRegisterEnterPasswordStepOpened',
  AuthRegisterInterestsStepOpened = 'AuthRegisterInterestsStepOpened',
  AuthRegisterInterestsSubmitAttempt = 'AuthRegisterInterestsSubmitAttempt',
  AuthRegisterInterestsSubmitFailed = 'AuthRegisterInterestsSubmitFailed',
  AuthRegisterInterestsSubmitSuccess = 'AuthRegisterInterestsSubmitSuccess',
  AuthRegisterJoinCommunitiesStepOpened = 'AuthRegisterJoinCommunitiesStepOpened',
  AuthRegisterJoinCommunitiesSubmitAttempt = 'AuthRegisterJoinCommunitiesSubmitAttempt',
  AuthRegisterJoinCommunitiesSubmitFailed = 'AuthRegisterJoinCommunitiesSubmitFailed',
  AuthRegisterJoinCommunitiesSubmitSuccess = 'AuthRegisterJoinCommunitiesSubmitSuccess',
  AuthRegisterNameStepOpened = 'AuthRegisterNameStepOpened',
  AuthRegisterNameSubmitAttempt = 'AuthRegisterNameSubmitAttempt',
  AuthRegisterNameSubmitFailed = 'AuthRegisterNameSubmitFailed',
  AuthRegisterNameSubmitSuccess = 'AuthRegisterNameSubmitSuccess',
  AuthRegisterOpened = 'AuthRegisterOpened',
  AuthRegisterPasswordSubmitAttempt = 'AuthRegisterPasswordSubmitAttempt',
  AuthRegisterPasswordSubmitFailed = 'AuthRegisterPasswordSubmitFailed',
  AuthRegisterPasswordSubmitSuccess = 'AuthRegisterPasswordSubmitSuccess',
  AuthRegisterProfilePictureStepOpened = 'AuthRegisterProfilePictureStepOpened',
  AuthRegisterProfilePictureSubmitAttempt = 'AuthRegisterProfilePictureSubmitAttempt',
  AuthRegisterProfilePictureSubmitFailed = 'AuthRegisterProfilePictureSubmitFailed',
  AuthRegisterProfilePictureSubmitSuccess = 'AuthRegisterProfilePictureSubmitSuccess',
  AuthRegisterPronounsStepOpened = 'AuthRegisterPronounsStepOpened',
  AuthRegisterPronounsSubmitAttempt = 'AuthRegisterPronounsSubmitAttempt',
  AuthRegisterPronounsSubmitFailed = 'AuthRegisterPronounsSubmitFailed',
  AuthRegisterPronounsSubmitSuccess = 'AuthRegisterPronounsSubmitSuccess',
  AuthRegisterPushNotificationsStepOpened = 'AuthRegisterPushNotificationsStepOpened',
  AuthRegisterPushNotificationsSubmitAttempt = 'AuthRegisterPushNotificationsSubmitAttempt',
  AuthRegisterPushNotificationsSubmitFailed = 'AuthRegisterPushNotificationsSubmitFailed',
  AuthRegisterPushNotificationsSubmitSuccess = 'AuthRegisterPushNotificationsSubmitSuccess',
  AuthRegisterUsernameSubmitAttempt = 'AuthRegisterUsernameSubmitAttempt',
  AuthRegisterUsernameSubmitFailed = 'AuthRegisterUsernameSubmitFailed',
  AuthRegisterUsernameSubmitSuccess = 'AuthRegisterUsernameSubmitSuccess',
  AuthRegistrationCompletedModalOpened = 'AuthRegistrationCompletedModalOpened',
  AuthVerificationCodeResendChoiceOpened = 'AuthVerificationCodeResendChoiceOpened',
  AuthVerificationCodeResendSubmitAttempt = 'AuthVerificationCodeResendSubmitAttempt',
  AuthVerificationCodeResendSubmitFailed = 'AuthVerificationCodeResendSubmitFailed',
  AuthVerificationCodeResendSubmitSuccess = 'AuthVerificationCodeResendSubmitSuccess',
  AuthVerificationCodeStepOpened = 'AuthVerificationCodeStepOpened',
  AuthVerificationCodeSubmitAttempt = 'AuthVerificationCodeSubmitAttempt',
  AuthVerificationCodeSubmitFailed = 'AuthVerificationCodeSubmitFailed',
  AuthVerificationCodeSubmitSuccess = 'AuthVerificationCodeSubmitSuccess',
  BecomeACommunityScreenOpened = 'BecomeACommunityScreenOpened',
  CalendarClosed = 'CalendarClosed',
  CalendarOpened = 'CalendarOpened',
  CartCheckoutClicked = 'CartCheckoutClicked',
  CatalogItemScheduleScreenClosed = 'CatalogItemScheduleScreenClosed',
  CatalogItemScheduleScreenOpened = 'CatalogItemScheduleScreenOpened',
  CatalogItemScreenClosed = 'CatalogItemScreenClosed',
  CatalogItemScreenOpened = 'CatalogItemScreenOpened',
  CatalogModuleClosed = 'CatalogModuleClosed',
  CatalogModuleOpened = 'CatalogModuleOpened',
  ChatChannelClosed = 'ChatChannelClosed',
  ChatChannelOpened = 'ChatChannelOpened',
  ChatCommunityOverviewOpened = 'ChatCommunityOverviewOpened',
  ChatDirectClosed = 'ChatDirectClosed',
  ChatDirectOpened = 'ChatDirectOpened',
  ChatMessageSent = 'ChatMessageSent',
  CheckoutClosed = 'CheckoutClosed',
  CheckoutOpened = 'CheckoutOpened',
  CheckoutPaymentAttempt = 'CheckoutPaymentAttempt',
  CheckoutPaymentFailed = 'CheckoutPaymentFailed',
  CheckoutPaymentSuccess = 'CheckoutPaymentSuccess',
  CommunityInfoModalClosed = 'CommunityInfoModalClosed',
  CommunityInfoModalOpened = 'CommunityInfoModalOpened',
  CommunityWorldClosed = 'CommunityWorldClosed',
  CommunityWorldOpened = 'CommunityWorldOpened',
  CompleteProfileDone = 'CompleteProfileDone',
  CompleteProfileStep1Opened = 'CompleteProfileStep1Opened',
  CompleteProfileStep2Opened = 'CompleteProfileStep2Opened',
  CompleteProfileStep3Opened = 'CompleteProfileStep3Opened',
  DownloadMobilePopupOpened = 'DownloadMobilePopupOpened',
  EmailBounced = 'EmailBounced',
  EmailDelivered = 'EmailDelivered',
  EmailLinkClicked = 'EmailLinkClicked',
  EmailOpened = 'EmailOpened',
  EmailSpamComplaint = 'EmailSpamComplaint',
  EmailUnsubscribed = 'EmailUnsubscribed',
  EnterCommunityPromptDismissed = 'EnterCommunityPromptDismissed',
  EnterCommunityPromptOpened = 'EnterCommunityPromptOpened',
  EnterCommunityPromptPressed = 'EnterCommunityPromptPressed',
  EventRsvp = 'EventRSVP',
  EventScreenClosed = 'EventScreenClosed',
  EventScreenOpened = 'EventScreenOpened',
  EventSeen = 'EventSeen',
  EventShared = 'EventShared',
  EventTicketsScreenOpened = 'EventTicketsScreenOpened',
  EventsCalendarModuleClosed = 'EventsCalendarModuleClosed',
  EventsCalendarModuleOpened = 'EventsCalendarModuleOpened',
  EventsModuleClosed = 'EventsModuleClosed',
  EventsModuleOpened = 'EventsModuleOpened',
  ExploreItemClicked = 'ExploreItemClicked',
  ExploreItemSeen = 'ExploreItemSeen',
  ExploreSearchAttempt = 'ExploreSearchAttempt',
  ExploreSearchClosed = 'ExploreSearchClosed',
  ExploreSearchOpened = 'ExploreSearchOpened',
  ExploreSearchResultClicked = 'ExploreSearchResultClicked',
  FeedBannerClicked = 'FeedBannerClicked',
  FestivalSeasonClosed = 'FestivalSeasonClosed',
  FestivalSeasonOpened = 'FestivalSeasonOpened',
  FestivalSeasonProductCtaPressed = 'FestivalSeasonProductCTAPressed',
  IdCardBadgeOpened = 'IDCardBadgeOpened',
  IdCardFlipped = 'IDCardFlipped',
  IdCardModuleClosed = 'IDCardModuleClosed',
  IdCardModuleOpened = 'IDCardModuleOpened',
  InventoryItemOpened = 'InventoryItemOpened',
  InventoryItemTransferModalOpened = 'InventoryItemTransferModalOpened',
  InventoryItemTransferSendAttempt = 'InventoryItemTransferSendAttempt',
  InventoryItemTransferSendFailed = 'InventoryItemTransferSendFailed',
  InventoryItemTransferSendSuccess = 'InventoryItemTransferSendSuccess',
  InventoryMembershipsOpened = 'InventoryMembershipsOpened',
  InviteCodeSendAttempt = 'InviteCodeSendAttempt',
  InviteFriendsClaimed = 'InviteFriendsClaimed',
  InviteFriendsContinued = 'InviteFriendsContinued',
  InviteFriendsDismissed = 'InviteFriendsDismissed',
  InviteFriendsLinkOpened = 'InviteFriendsLinkOpened',
  InviteFriendsOpened = 'InviteFriendsOpened',
  InviteFriendsShareOpened = 'InviteFriendsShareOpened',
  InviteFriendsSlotStarted = 'InviteFriendsSlotStarted',
  InviteLandingOpened = 'InviteLandingOpened',
  JoinCommunitiesModalClosed = 'JoinCommunitiesModalClosed',
  JoinCommunitiesModalOpened = 'JoinCommunitiesModalOpened',
  JoinCommunitiesPromptDismissed = 'JoinCommunitiesPromptDismissed',
  JoinCommunitiesPromptOpened = 'JoinCommunitiesPromptOpened',
  JoinCommunitiesPromptPressed = 'JoinCommunitiesPromptPressed',
  JoinCommunityAttempt = 'JoinCommunityAttempt',
  JoinCommunityFailed = 'JoinCommunityFailed',
  JoinCommunitySuccess = 'JoinCommunitySuccess',
  ListenScreenClosed = 'ListenScreenClosed',
  ListenScreenOpened = 'ListenScreenOpened',
  NewsItemCtaClicked = 'NewsItemCTAClicked',
  NewsItemClosed = 'NewsItemClosed',
  NewsItemCommentLiked = 'NewsItemCommentLiked',
  NewsItemCommentReported = 'NewsItemCommentReported',
  NewsItemCommented = 'NewsItemCommented',
  NewsItemLiked = 'NewsItemLiked',
  NewsItemOpened = 'NewsItemOpened',
  NewsItemSeen = 'NewsItemSeen',
  NewsModuleClosed = 'NewsModuleClosed',
  NewsModuleOpened = 'NewsModuleOpened',
  NotificationClicked = 'NotificationClicked',
  OnlyMobilePopupOpened = 'OnlyMobilePopupOpened',
  PopularEventsClosed = 'PopularEventsClosed',
  PopularEventsOpened = 'PopularEventsOpened',
  PreviewVisitClicked = 'PreviewVisitClicked',
  PrimaryCommunityChanged = 'PrimaryCommunityChanged',
  PrimaryCommunityModalOpened = 'PrimaryCommunityModalOpened',
  ProductCardAdd = 'ProductCardAdd',
  ProductCardRemove = 'ProductCardRemove',
  ProductLiked = 'ProductLiked',
  ProductPurchased = 'ProductPurchased',
  ProductSeen = 'ProductSeen',
  PromocodeApplyAttempt = 'PromocodeApplyAttempt',
  PromocodeApplyFailed = 'PromocodeApplyFailed',
  PromocodeApplySuccess = 'PromocodeApplySuccess',
  RadioModuleClosed = 'RadioModuleClosed',
  RadioModuleOpened = 'RadioModuleOpened',
  RadioTrackClosed = 'RadioTrackClosed',
  RadioTrackOpened = 'RadioTrackOpened',
  RadioTrackPlayed = 'RadioTrackPlayed',
  RadioTrackSeen = 'RadioTrackSeen',
  RadioTrackStopped = 'RadioTrackStopped',
  ScheduleItemScreenClosed = 'ScheduleItemScreenClosed',
  ScheduleItemScreenOpened = 'ScheduleItemScreenOpened',
  ScheduleItemSeen = 'ScheduleItemSeen',
  ScheduleModuleClosed = 'ScheduleModuleClosed',
  ScheduleModuleOpened = 'ScheduleModuleOpened',
  ScheduleModuleViewChanged = 'ScheduleModuleViewChanged',
  ShopModuleClosed = 'ShopModuleClosed',
  ShopModuleOpened = 'ShopModuleOpened',
  ShortcutClicked = 'ShortcutClicked',
  ShortcutSeen = 'ShortcutSeen',
  SocialLinksClicked = 'SocialLinksClicked',
  SuggestedCommunitiesScreenClosed = 'SuggestedCommunitiesScreenClosed',
  SuggestedCommunitiesScreenOpened = 'SuggestedCommunitiesScreenOpened',
  SuggestedCommunityLiked = 'SuggestedCommunityLiked',
  SuggestedCommunitySubmitAttempt = 'SuggestedCommunitySubmitAttempt',
  SuggestedCommunitySubmitFailed = 'SuggestedCommunitySubmitFailed',
  SuggestedCommunitySubmitModalOpened = 'SuggestedCommunitySubmitModalOpened',
  SuggestedCommunitySubmitSuccess = 'SuggestedCommunitySubmitSuccess',
  SwapCheckoutPaymentAttempt = 'SwapCheckoutPaymentAttempt',
  SwapCheckoutPaymentFailed = 'SwapCheckoutPaymentFailed',
  SwapCheckoutPaymentSuccess = 'SwapCheckoutPaymentSuccess',
  SwapCheckoutScreenClosed = 'SwapCheckoutScreenClosed',
  SwapCheckoutScreenOpened = 'SwapCheckoutScreenOpened',
  SwapClosed = 'SwapClosed',
  SwapEventScreenClosed = 'SwapEventScreenClosed',
  SwapEventScreenOpened = 'SwapEventScreenOpened',
  SwapListAttempt = 'SwapListAttempt',
  SwapListFailed = 'SwapListFailed',
  SwapListSuccess = 'SwapListSuccess',
  SwapOpened = 'SwapOpened',
  SwapRemoveAttempt = 'SwapRemoveAttempt',
  SwapRemoveFailed = 'SwapRemoveFailed',
  SwapRemoveSuccess = 'SwapRemoveSuccess',
  SwitchCommunity = 'SwitchCommunity',
  SwitchCommunityOpened = 'SwitchCommunityOpened',
  TermsAndPrivacyOpened = 'TermsAndPrivacyOpened',
  TicketOptionsViewed = 'TicketOptionsViewed',
  UbiqChatOpened = 'UbiqChatOpened',
  UbiqCommunitiesOpened = 'UbiqCommunitiesOpened',
  UbiqFeedOpened = 'UbiqFeedOpened',
  UbiqInventoryOpened = 'UbiqInventoryOpened',
  UbiqMenuOpened = 'UbiqMenuOpened',
  WebViewScreenOpened = 'WebViewScreenOpened'
}

export enum UserDisplayNameSetting {
  Anonymous = 'Anonymous',
  Full = 'Full',
  Shortened = 'Shortened'
}

export type UserIndicators = {
  __typename?: 'UserIndicators';
  feedOnHome: Scalars['Boolean'];
  hasUbiqThemesAccess: Scalars['Boolean'];
  inventory: Scalars['Boolean'];
  settings: Scalars['Boolean'];
  shouldRepromptNotifications: Scalars['Boolean'];
  tools: Tools;
  ubiqNotifications: Scalars['Boolean'];
  ubiqNotificationsUnseenCount: Scalars['Int'];
  unreadMessages: Scalars['Int'];
};

export enum UserInfoField {
  Dob = 'DOB',
  Email = 'Email',
  FirstName = 'FirstName',
  LastName = 'LastName',
  ProfilePicture = 'ProfilePicture',
  Username = 'Username'
}

export type UserListRelationFilter = {
  some?: InputMaybe<UserWhereInput2>;
};

export type UserOrderByInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  avatar: Scalars['String'];
  bio?: Maybe<Scalars['String']>;
  communities: Array<ProfileCommunity>;
  daysOnWerz: Scalars['Int'];
  displayName: Scalars['String'];
  displayNameSetting: UserDisplayNameSetting;
  id: Scalars['String'];
  isOwnProfile: Scalars['Boolean'];
  karma: Scalars['Int'];
  socialLinks: Array<ProfileSocialLink>;
  username?: Maybe<Scalars['String']>;
};

export type UserPrompt = {
  __typename?: 'UserPrompt';
  metadata: Scalars['Json'];
  type: UserPromptType;
};

export enum UserPromptAction {
  Dismissed = 'Dismissed',
  Opened = 'Opened',
  Pressed = 'Pressed'
}

export enum UserPromptType {
  EnterCommunity = 'EnterCommunity',
  JoinCommunities = 'JoinCommunities'
}

export enum UserRole {
  Administrator = 'Administrator',
  Intern = 'Intern',
  User = 'User'
}

export enum UserSegmentAction {
  Add = 'add',
  Remove = 'remove'
}

export enum UserStatus {
  Active = 'Active',
  DeleteRequested = 'DeleteRequested',
  Deleted = 'Deleted'
}

export type UserStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
};

export type UserSubscriptionsDisplay = {
  __typename?: 'UserSubscriptionsDisplay';
  subscriptions: Array<DisplaySubscription>;
};

export type UserUpdateInput = {
  versionOfWerz?: InputMaybe<StringUpdateInput>;
};

export type UserUpdateV2Input = {
  communityOnboardingInfo?: InputMaybe<Scalars['Json']>;
  mcaVersion?: InputMaybe<Scalars['String']>;
};

export type UserWhereEqualsInput = {
  id?: InputMaybe<StringFilter>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UserWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserWhereInput>>>;
  id?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<UserStringFilter>;
};

export type UserWhereInput2 = {
  id?: InputMaybe<StringFilter3>;
};

export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export enum WaitlistSource {
  Mobile = 'Mobile',
  Website = 'Website'
}

export type WaitlistUser = {
  __typename?: 'WaitlistUser';
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  source: WaitlistSource;
  updatedAt: Scalars['DateTime'];
};

export type WerzyChat = {
  __typename?: 'WerzyChat';
  hasUnread: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  message: Scalars['String'];
  name: Scalars['String'];
  time?: Maybe<Scalars['DateTime']>;
};

export type CaAmbassadorCampaignsResult = {
  __typename?: 'caAmbassadorCampaignsResult';
  items: Array<AmbassadorCampaign>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaAnnouncementsResult = {
  __typename?: 'caAnnouncementsResult';
  items: Array<FeedItem>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaAssignableSegmentsResult = {
  __typename?: 'caAssignableSegmentsResult';
  items: Array<Segment>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaCatalogCategoriesResult = {
  __typename?: 'caCatalogCategoriesResult';
  items: Array<CatalogItemCategoryRef>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaCatalogItemsResult = {
  __typename?: 'caCatalogItemsResult';
  items: Array<CatalogItem>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaCatalogScheduleItemsResult = {
  __typename?: 'caCatalogScheduleItemsResult';
  items: Array<CaCatalogScheduleItemRef>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaCommunityMembersResponse = {
  __typename?: 'caCommunityMembersResponse';
  members: Array<User>;
  next: Scalars['Int'];
  totalMembers: Scalars['Int'];
};

export type CaCommunityMembersStatsResponse = {
  __typename?: 'caCommunityMembersStatsResponse';
  breakdown?: Maybe<Array<Maybe<DailyMembersData>>>;
  newMembers?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type CaCommunityOverviewStatsResponse = {
  __typename?: 'caCommunityOverviewStatsResponse';
  changeInActiveUsers?: Maybe<Scalars['Int']>;
  newMembers?: Maybe<Scalars['Int']>;
  newPurchases?: Maybe<Scalars['Int']>;
  newRevenue?: Maybe<Scalars['Float']>;
  newTicketsPurchasesForWeek?: Maybe<Scalars['Int']>;
  previousActiveUsersCount?: Maybe<Scalars['Int']>;
  ticketsPurchases?: Maybe<Scalars['Int']>;
  totalMembers?: Maybe<Scalars['Int']>;
  totalPurchases?: Maybe<Scalars['Int']>;
  totalRevenue?: Maybe<Scalars['Float']>;
};

export type CaCommunityRevenueStatusResponse = {
  __typename?: 'caCommunityRevenueStatusResponse';
  breakdown?: Maybe<Array<Maybe<CommunityDailyRevenueData>>>;
  total?: Maybe<Scalars['Float']>;
  totalPurchases?: Maybe<Scalars['Float']>;
};

export type CaCommunitySubscriptionsResponse = {
  __typename?: 'caCommunitySubscriptionsResponse';
  next: Scalars['Int'];
  subscriptions: Array<CommunitySubscription>;
  totalSubscriptions: Scalars['Int'];
};

export type CaCommunityThemesResult = {
  __typename?: 'caCommunityThemesResult';
  items: Array<CommunityTheme>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaEmailCampaignsResult = {
  __typename?: 'caEmailCampaignsResult';
  items: Array<EmailCampaign>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaEventActivityQueryResponse = {
  __typename?: 'caEventActivityQueryResponse';
  checkedInCount: Scalars['Int'];
  eventsViewCount: Scalars['Int'];
  registeredCount: Scalars['Int'];
  ticketsBoughtCount: Scalars['Int'];
};

export type CaEventAnalyticsResult = {
  __typename?: 'caEventAnalyticsResult';
  boughtTickets: Scalars['Int'];
  checkedIn: Scalars['Int'];
  members: Scalars['Int'];
  registered: Scalars['Int'];
  rsvped: Scalars['Int'];
  ticketsSold: Scalars['Int'];
};

export type CaEventCategoriesResult = {
  __typename?: 'caEventCategoriesResult';
  items: Array<EventCategory>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaEventCreateOrUpdateInput = {
  additionalConfig?: InputMaybe<Scalars['Json']>;
  additionalDetails?: InputMaybe<Scalars['String']>;
  allowFreeGuestList?: InputMaybe<Scalars['Boolean']>;
  buyTicketsLink?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  end?: InputMaybe<Scalars['DateTime']>;
  /** Legacy invitation list for existing clients only. New event editors must omit this field to preserve existing invitations. */
  invitedUsers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Float']>;
  location?: InputMaybe<Scalars['String']>;
  locationAvailability?: InputMaybe<Scalars['String']>;
  locationDescription?: InputMaybe<Scalars['String']>;
  locationDropTime?: InputMaybe<Scalars['DateTime']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mediaUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  registrationRequired?: InputMaybe<Scalars['Boolean']>;
  shouldInviteCommunityMembersAutomatically?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['DateTime']>;
  timezone?: InputMaybe<Scalars['String']>;
  totalTicketsOverride?: InputMaybe<Scalars['Int']>;
  venueName?: InputMaybe<Scalars['String']>;
};

export type CaEventGuestsResult = {
  __typename?: 'caEventGuestsResult';
  guests: Array<CommunityMemberInfo>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaEventsResult = {
  __typename?: 'caEventsResult';
  items: Array<Event>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaMassMessagesResult = {
  __typename?: 'caMassMessagesResult';
  items: Array<MassMessage>;
  next: Scalars['Int'];
  notifsThisMonth: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaMonthlyActivityUsersResponse = {
  __typename?: 'caMonthlyActivityUsersResponse';
  breakdown?: Maybe<Array<Maybe<DailyActivityData>>>;
};

export type CaPotentialAdminsResponse = {
  __typename?: 'caPotentialAdminsResponse';
  next: Scalars['Int'];
  total: Scalars['Int'];
  users: Array<User>;
};

export type CaProductUsageStatsResponse = {
  __typename?: 'caProductUsageStatsResponse';
  breakdown?: Maybe<Array<Maybe<ProductUsageDailyData>>>;
  total?: Maybe<Scalars['Int']>;
};

export type CaPromocodeUsageStatsResponse = {
  __typename?: 'caPromocodeUsageStatsResponse';
  basis: Scalars['String'];
  breakdown?: Maybe<Array<Maybe<PromocodeUsageDailyData>>>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo: Scalars['DateTime'];
  lifetimeTotal: Scalars['Int'];
  recent: Array<PromocodeRecentRedemption>;
  remaining?: Maybe<Scalars['Int']>;
  timezone: Scalars['String'];
  total?: Maybe<Scalars['Int']>;
};

export type CaPromocodesResentUsagesReturn = {
  __typename?: 'caPromocodesResentUsagesReturn';
  items: Array<Purchase>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaPromocodesReturn = {
  __typename?: 'caPromocodesReturn';
  items: Array<Promocode>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaPurchasesActivityResponse = {
  __typename?: 'caPurchasesActivityResponse';
  breakdown?: Maybe<Array<Maybe<DailySalesData>>>;
  commonTotalSales: Scalars['Float'];
  lastWeekPurchasesCount?: Maybe<Scalars['Int']>;
  lastWeekRevenue?: Maybe<Scalars['Float']>;
  purchasesCount?: Maybe<Scalars['Int']>;
  revenue?: Maybe<Scalars['Float']>;
};

export type CaPurchasesFunnelResponse = {
  __typename?: 'caPurchasesFunnelResponse';
  keyMetrics?: Maybe<KeyMetricsData>;
};

export type CaPurchasesResult = {
  __typename?: 'caPurchasesResult';
  items: Array<Purchase>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaRadioTrackCreateOrUpdateInput = {
  artist?: InputMaybe<Scalars['String']>;
  artistDetails?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['DateTime']>;
  mediaUrl?: InputMaybe<Scalars['String']>;
  socialMediaLinks?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  start?: InputMaybe<Scalars['DateTime']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TrackType>;
};

export type CaRadioTracksResult = {
  __typename?: 'caRadioTracksResult';
  items: Array<Track>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaResentPurchasesReturn = {
  __typename?: 'caResentPurchasesReturn';
  items: Array<Purchase>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaScheduleCalendarStatsResponse = {
  __typename?: 'caScheduleCalendarStatsResponse';
  breakdown?: Maybe<Array<Maybe<ScheduleCalendarDailyData>>>;
  total?: Maybe<Scalars['Int']>;
};

export type CaScheduleItemsResult = {
  __typename?: 'caScheduleItemsResult';
  items: Array<CatalogItemSchedule>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CaShopActivityQueryResponse = {
  __typename?: 'caShopActivityQueryResponse';
  addedToCartCount: Scalars['Int'];
  committedPurchasesCount: Scalars['Int'];
  promoCodesUsedCount: Scalars['Int'];
  reachedCheckoutCount: Scalars['Int'];
  shopVisitsCount: Scalars['Int'];
  totalPurchasesCount: Scalars['Int'];
};

export type CatalogItemsResult = {
  __typename?: 'catalogItemsResult';
  categories: Array<DisplayCatalogItemCategory>;
  items: Array<DisplayCatalogItem>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type CheckoutPostReturnResult = {
  __typename?: 'checkoutPostReturnResult';
  byEmail: Scalars['Boolean'];
  currency: Scalars['String'];
  digitalItems?: Maybe<Array<DigitalItem>>;
  discount: Scalars['Float'];
  fees: Scalars['Float'];
  purchases: Array<CheckoutPostReturnPurchase>;
  status: Scalars['String'];
  vat: Scalars['Float'];
};

export type CommunityInfoResult = {
  __typename?: 'communityInfoResult';
  community: CommunityResultV2;
};

export type CommunityInventoryResult = {
  __typename?: 'communityInventoryResult';
  availableTypes?: Maybe<Array<Maybe<ProductType>>>;
  purchases?: Maybe<Array<Maybe<Purchase>>>;
};

export type CommunityInviteCodesResult = {
  __typename?: 'communityInviteCodesResult';
  codes: Array<InviteCode>;
  count: Scalars['Int'];
};

export type CommunityLandingResult = {
  __typename?: 'communityLandingResult';
  community: CommunityResult;
  latestNews?: Maybe<Array<LatestNewsResult>>;
  otherLinks?: Maybe<Array<OtherLinksResult>>;
  radioTracks?: Maybe<Array<RadioTracksResult>>;
  upcomingEvents?: Maybe<Array<UpcomingEventsResult>>;
};

export type CommunityResult = {
  __typename?: 'communityResult';
  availablePaymentMethods?: Maybe<Array<Scalars['String']>>;
  code?: Maybe<Scalars['String']>;
  configs?: Maybe<Scalars['Json']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  iconUrl: Scalars['String'];
  id: Scalars['String'];
  joinRequirements?: Maybe<Scalars['Json']>;
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  preselectedPaymentMethod?: Maybe<Scalars['String']>;
  radioModule: Scalars['Boolean'];
  requestToJoin: Scalars['Boolean'];
  socialLinks: Array<SocialLinksResult>;
  stripeConnectedAccountId?: Maybe<Scalars['String']>;
};

export type CommunityResultV2 = {
  __typename?: 'communityResultV2';
  globalInviteCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  socialLinks?: Maybe<Array<SocialLinksResultV2>>;
};

export type DailyActivityData = {
  __typename?: 'dailyActivityData';
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
};

export type DailySalesData = {
  __typename?: 'dailySalesData';
  date?: Maybe<Scalars['Date']>;
  sales?: Maybe<Scalars['Int']>;
};

export type EventResult = {
  __typename?: 'eventResult';
  event: Event;
  numberOfTicketsAvailableSoon: Scalars['Int'];
  numberOfTicketsAvailableToCheckIn: Scalars['Int'];
  numberOfTicketsChecked: Scalars['Int'];
  numberOfTicketsToTransfer: Scalars['Int'];
  totalTickets: Scalars['Int'];
};

export type EventsCalendarResult = {
  __typename?: 'eventsCalendarResult';
  end?: Maybe<Scalars['DateTime']>;
  eventCategories: Array<DisplayEventCategory>;
  events: Array<Event>;
  next: Scalars['Int'];
  start?: Maybe<Scalars['DateTime']>;
  total: Scalars['Int'];
};

export type InventoryEventResult = {
  __typename?: 'inventoryEventResult';
  event?: Maybe<Event>;
  purchases?: Maybe<Array<Maybe<Purchase>>>;
};

export type InventoryV2Result = {
  __typename?: 'inventoryV2Result';
  communitiesWithPurchases?: Maybe<Array<Maybe<Community>>>;
  communityShops?: Maybe<Array<CommunityShop>>;
  eventsWithPurchases?: Maybe<Array<EventResult>>;
  featured?: Maybe<Array<FeaturedItem>>;
  myLatest?: Maybe<Array<MyLatestItem>>;
  purchases?: Maybe<Array<Maybe<Purchase>>>;
  tokens: Array<Token>;
};

export type LatestNewsResult = {
  __typename?: 'latestNewsResult';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  mediaUrl: Scalars['String'];
  name: Scalars['String'];
};

export type OtherLinksResult = {
  __typename?: 'otherLinksResult';
  icon?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  url: Scalars['String'];
};

export type ProductsResult = {
  __typename?: 'productsResult';
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  name: Scalars['String'];
  price: Scalars['String'];
  start?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
};

export type RadioTracksResult = {
  __typename?: 'radioTracksResult';
  coverUrl: Scalars['String'];
  duration: Scalars['Int'];
  end?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  mediaUrl: Scalars['String'];
  start?: Maybe<Scalars['Date']>;
  title: Scalars['String'];
  type: TrackType;
};

export type RadioTracksReturn = {
  __typename?: 'radioTracksReturn';
  items: Array<Track>;
  next: Scalars['Int'];
  total: Scalars['Int'];
};

export type ScheduleItemsResult = {
  __typename?: 'scheduleItemsResult';
  allStageNames: Array<Scalars['String']>;
  allTags: Array<Scalars['String']>;
  curations: Array<DisplayScheduleCuration>;
  end?: Maybe<Scalars['DateTime']>;
  items: Array<DisplayScheduleItem>;
  next: Scalars['Int'];
  selectedTagIds?: Maybe<Array<Scalars['String']>>;
  start?: Maybe<Scalars['DateTime']>;
  tagCategories: Array<DisplayTagCategory>;
  timezone: Scalars['String'];
  total: Scalars['Int'];
};

export type SocialLinksResult = {
  __typename?: 'socialLinksResult';
  platform: Scalars['String'];
  url: Scalars['String'];
};

export type SocialLinksResultV2 = {
  __typename?: 'socialLinksResultV2';
  platform?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type UpcomingEventsResult = {
  __typename?: 'upcomingEventsResult';
  buyTicketsLink?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  location: Scalars['String'];
  locationAvailable: Scalars['Boolean'];
  locationDisplayCompact: Scalars['String'];
  mediaUrl: Scalars['String'];
  name: Scalars['String'];
  products: Array<ProductsResult>;
  start?: Maybe<Scalars['DateTime']>;
  webLink: Scalars['String'];
};

export type TrackUserActivityMutationVariables = Exact<{
  type: UserActivityEventType;
  communityCode?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['Json']>;
  envelope: Scalars['Json'];
}>;


export type TrackUserActivityMutation = { __typename?: 'Mutation', trackUserActivity?: boolean | null };

export type RegisterUserActivityIdentityMutationVariables = Exact<{
  anonymousId: Scalars['String'];
  identityToken: Scalars['String'];
}>;


export type RegisterUserActivityIdentityMutation = { __typename?: 'Mutation', registerUserActivityIdentity: boolean };

export type AssociateUserActivityIdentityMutationVariables = Exact<{
  anonymousId: Scalars['String'];
  identityToken: Scalars['String'];
}>;


export type AssociateUserActivityIdentityMutation = { __typename?: 'Mutation', associateUserActivityIdentity: boolean };

export type RevokeUserActivityIdentityMutationVariables = Exact<{
  anonymousId: Scalars['String'];
  identityToken: Scalars['String'];
}>;


export type RevokeUserActivityIdentityMutation = { __typename?: 'Mutation', revokeUserActivityIdentity: boolean };

export type AmbassadorCampaignByCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type AmbassadorCampaignByCodeQuery = { __typename?: 'Query', ambassadorCampaignByCode?: { __typename?: 'DisplayAmbassadorCampaign', id: string, status: AmbassadorCampaignStatus, spotsAvailable: boolean, userHasClaimed: boolean, segmentDisplayName?: string | null, segmentInstructions?: string | null, community: { __typename?: 'Community', id: string, name: string, iconUrl?: string | null, code?: string | null } } | null };

export type ClaimAmbassadorCampaignMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type ClaimAmbassadorCampaignMutation = { __typename?: 'Mutation', claimAmbassadorCampaign: boolean };

export type AnnouncementsQueryVariables = Exact<{
  communityId: Scalars['ID'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type AnnouncementsQuery = { __typename?: 'Query', announcements?: { __typename?: 'AnnouncementsReturn', next: number, total: number, items: Array<{ __typename?: 'FeedItem', id: string, title: string, media: Array<string>, liked?: boolean | null, subtitle?: string | null, createdAt: Date, likesCount?: number | null, externalUrl?: string | null, description?: string | null, commentsCount?: number | null }> } | null };

export type AnnouncementQueryVariables = Exact<{
  announcementId: Scalars['ID'];
  communityId?: InputMaybe<Scalars['ID']>;
}>;


export type AnnouncementQuery = { __typename?: 'Query', announcement?: { __typename?: 'FeedItem', id: string, title: string, media: Array<string>, liked?: boolean | null, subtitle?: string | null, createdAt: Date, likesCount?: number | null, externalUrl?: string | null, description?: string | null, commentsCount?: number | null } | null };

export type ReactAnnouncementMutationVariables = Exact<{
  feedItemId: Scalars['ID'];
}>;


export type ReactAnnouncementMutation = { __typename?: 'Mutation', reactFeedItem?: boolean | null };

export type BaseFeedItemFragment = { __typename?: 'FeedItem', id: string, title: string, media: Array<string>, liked?: boolean | null, subtitle?: string | null, createdAt: Date, likesCount?: number | null, externalUrl?: string | null, description?: string | null, commentsCount?: number | null };

export type AuthV2MutationVariables = Exact<{
  phone: Scalars['String'];
  phoneVerificationCode?: InputMaybe<Scalars['String']>;
  fromWeb?: InputMaybe<Scalars['Boolean']>;
}>;


export type AuthV2Mutation = { __typename?: 'Mutation', authV2?: { __typename?: 'AuthV2Response', token?: string | null, verificationCodeSent?: boolean | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, avatar?: string | null, birthday?: Date | null, lastName?: string | null, username?: string | null, firstName?: string | null, phoneVerified: boolean, emailVerified: boolean, communityOnboardingInfo?: any | null, communitiesWhereMember: Array<{ __typename?: 'Community', id: string, name: string, code?: string | null, currency: SupportedCurrencies, iconUrl?: string | null, landingCode?: string | null, availablePaymentMethods: Array<string>, preselectedPaymentMethod?: PurchasePaymentMethod | null, configs: any, stripeConnectedAccountId?: string | null, joinRequirements?: any | null, requiredUserFields: Array<UserInfoField>, missingRequiredUserFields: Array<string>, requestToJoin: boolean }>, communitiesWhereRequested: Array<{ __typename?: 'Community', id: string, code?: string | null }> } | null } | null };

export type LoginMutationVariables = Exact<{
  identifier?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'AuthPayload', token?: string | null, errors?: Array<{ __typename?: 'TranslatableError', errorCode?: TranslatableErrorCode | null, path?: Array<string | null> | null } | null> | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, avatar?: string | null, birthday?: Date | null, lastName?: string | null, username?: string | null, firstName?: string | null, phoneVerified: boolean, emailVerified: boolean, communityOnboardingInfo?: any | null, communitiesWhereMember: Array<{ __typename?: 'Community', id: string, name: string, code?: string | null, currency: SupportedCurrencies, iconUrl?: string | null, landingCode?: string | null, availablePaymentMethods: Array<string>, preselectedPaymentMethod?: PurchasePaymentMethod | null, configs: any, stripeConnectedAccountId?: string | null, joinRequirements?: any | null, requiredUserFields: Array<UserInfoField>, missingRequiredUserFields: Array<string>, requestToJoin: boolean }>, communitiesWhereRequested: Array<{ __typename?: 'Community', id: string, code?: string | null }> } | null } | null };

export type JoinCommunityMutationVariables = Exact<{
  inviteCode: Scalars['String'];
  doInfoChecks?: InputMaybe<Scalars['Boolean']>;
  joinRequirementsResponses?: InputMaybe<Scalars['Json']>;
}>;


export type JoinCommunityMutation = { __typename?: 'Mutation', joinCommunityWithInfoCheck?: { __typename?: 'JoinCommunityReturnType', missingInfo?: Array<UserInfoField | null> | null, joinRequirements?: any | null, requestToJoinSubmitted?: boolean | null, communities?: Array<{ __typename?: 'Community', id: string, name: string, code?: string | null, iconUrl?: string | null, currency: SupportedCurrencies, landingCode?: string | null, availablePaymentMethods: Array<string>, preselectedPaymentMethod?: PurchasePaymentMethod | null, configs: any, stripeConnectedAccountId?: string | null, joinRequirements?: any | null, requiredUserFields: Array<UserInfoField>, missingRequiredUserFields: Array<string>, requestToJoin: boolean }> | null, communityToJoin?: { __typename?: 'Community', id: string, name: string, code?: string | null, iconUrl?: string | null, currency: SupportedCurrencies, landingCode?: string | null, availablePaymentMethods: Array<string>, preselectedPaymentMethod?: PurchasePaymentMethod | null, configs: any, stripeConnectedAccountId?: string | null, joinRequirements?: any | null, requiredUserFields: Array<UserInfoField>, missingRequiredUserFields: Array<string>, requestToJoin: boolean } | null } | null };

export type MarkInviteFriendsLinkOpenedMutationVariables = Exact<{
  inviteCode: Scalars['String'];
  communityCode?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
}>;


export type MarkInviteFriendsLinkOpenedMutation = { __typename?: 'Mutation', markInviteFriendsLinkOpened?: { __typename?: 'MarkInviteFriendsLinkOpenedPayload', tracked: boolean } | null };

export type RequestPhoneVerificationMutationVariables = Exact<{
  phone: Scalars['String'];
  whatsapp?: InputMaybe<Scalars['Boolean']>;
}>;


export type RequestPhoneVerificationMutation = { __typename?: 'Mutation', requestPhoneVerification?: boolean | null };

export type VerifyUserMutationVariables = Exact<{
  phoneVerificationCode: Scalars['String'];
}>;


export type VerifyUserMutation = { __typename?: 'Mutation', verifyUser?: { __typename?: 'AuthPayload', token?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, avatar?: string | null, birthday?: Date | null, lastName?: string | null, username?: string | null, firstName?: string | null, phoneVerified: boolean, emailVerified: boolean, communityOnboardingInfo?: any | null, communitiesWhereMember: Array<{ __typename?: 'Community', id: string, name: string, code?: string | null, currency: SupportedCurrencies }>, communitiesWhereRequested: Array<{ __typename?: 'Community', id: string, code?: string | null }> } | null, errors?: Array<{ __typename?: 'TranslatableError', errorCode?: TranslatableErrorCode | null, path?: Array<string | null> | null } | null> | null } | null };

export type RequestEmailVerificationMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestEmailVerificationMutation = { __typename?: 'Mutation', requestEmailVerification?: boolean | null };

export type VerifyEmailMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail?: boolean | null };

export type RequestEmailVerificationLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestEmailVerificationLinkMutation = { __typename?: 'Mutation', requestEmailVerificationLink?: boolean | null };

export type VerifyEmailTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyEmailTokenMutation = { __typename?: 'Mutation', verifyEmailToken?: boolean | null };

export type ResetPasswordMutationVariables = Exact<{
  identifier: Scalars['String'];
  password: Scalars['String'];
  passwordResetCode: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'AuthPayload', token?: string | null, errors?: Array<{ __typename?: 'TranslatableError', errorCode?: TranslatableErrorCode | null, path?: Array<string | null> | null } | null> | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, avatar?: string | null, birthday?: Date | null, lastName?: string | null, username?: string | null, firstName?: string | null, phoneVerified: boolean, emailVerified: boolean, communityOnboardingInfo?: any | null, communitiesWhereMember: Array<{ __typename?: 'Community', id: string, name: string, code?: string | null, currency: SupportedCurrencies }>, communitiesWhereRequested: Array<{ __typename?: 'Community', id: string, code?: string | null }> } | null } | null };

export type ResetPasswordRequestMutationVariables = Exact<{
  identifier: Scalars['String'];
}>;


export type ResetPasswordRequestMutation = { __typename?: 'Mutation', resetPasswordRequest?: { __typename?: 'PasswordResetRequestPayload', requested: boolean, errors?: Array<{ __typename?: 'TranslatableError', errorCode?: TranslatableErrorCode | null, path?: Array<string | null> | null } | null> | null } | null };

export type ValidateResetPasswordCodeMutationVariables = Exact<{
  passwordResetCode: Scalars['String'];
}>;


export type ValidateResetPasswordCodeMutation = { __typename?: 'Mutation', validatePasswordResetCode?: boolean | null };

export type BaseUserFragment = { __typename?: 'User', id: string, email?: string | null, phone?: string | null, avatar?: string | null, birthday?: Date | null, lastName?: string | null, username?: string | null, firstName?: string | null, phoneVerified: boolean, emailVerified: boolean, communityOnboardingInfo?: any | null, communitiesWhereMember: Array<{ __typename?: 'Community', id: string, name: string, code?: string | null, currency: SupportedCurrencies }>, communitiesWhereRequested: Array<{ __typename?: 'Community', id: string, code?: string | null }> };

export type BaseCommunityFragment = { __typename?: 'Community', id: string, name: string, code?: string | null, iconUrl?: string | null, currency: SupportedCurrencies, landingCode?: string | null, availablePaymentMethods: Array<string>, preselectedPaymentMethod?: PurchasePaymentMethod | null, configs: any, stripeConnectedAccountId?: string | null, joinRequirements?: any | null, requiredUserFields: Array<UserInfoField>, missingRequiredUserFields: Array<string>, requestToJoin: boolean };

export type UserUpdateAuthMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  sendEmailVerification?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['String']>;
}>;


export type UserUpdateAuthMutation = { __typename?: 'Mutation', userUpdate?: { __typename?: 'User', id: string, phone?: string | null } | null };

export type RequestSubscriptionPurchaseMutationVariables = Exact<{
  productId: Scalars['String'];
  fromWeb?: InputMaybe<Scalars['Boolean']>;
  postPaymentReturnUrl?: InputMaybe<Scalars['String']>;
}>;


export type RequestSubscriptionPurchaseMutation = { __typename?: 'Mutation', requestSubscriptionPurchase?: { __typename?: 'RequestSubscriptionPurchase', subscriptionId?: string | null, stripePaymentIntentClientSecret?: string | null, stripeSubscriptionId?: string | null, membershipId?: string | null } | null };

export type GetSubscriptionProductQueryVariables = Exact<{
  productId: Scalars['ID'];
}>;


export type GetSubscriptionProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, name: string, description?: string | null, price: number, currency: SupportedCurrencies, displayPrice: string, productType: ProductType, mediaUrl?: string | null, shortTerms?: string | null, postPurchaseInstructions?: string | null, community: { __typename?: 'Community', id: string, name: string, currency: SupportedCurrencies } } | null };

export type GetMembershipStatusQueryVariables = Exact<{
  membershipId: Scalars['ID'];
}>;


export type GetMembershipStatusQuery = { __typename?: 'Query', membershipStatus?: { __typename?: 'DisplayPaidMembership', id: string, status: string, currentPeriodEnd?: Date | null, stripeSubscriptionId?: string | null, product?: { __typename?: 'DisplayMembershipProduct', id: string, name: string, price: number, community?: { __typename?: 'DisplayMembershipCommunity', name: string, currency: string } | null } | null } | null };

export type CreateStripeCustomerPortalMutationVariables = Exact<{
  membershipId: Scalars['ID'];
}>;


export type CreateStripeCustomerPortalMutation = { __typename?: 'Mutation', createStripeCustomerPortal?: { __typename?: 'CreateStripeCustomerPortalResponse', url: string } | null };

export type CalculateDiscountAndFeesMutationVariables = Exact<{
  cart: Array<RequestProductsPurchaseInput> | RequestProductsPurchaseInput;
  paymentMethod?: InputMaybe<PurchasePaymentMethod>;
  promocodeId?: InputMaybe<Scalars['String']>;
  shippingCountry?: InputMaybe<Scalars['String']>;
  printfulShippingFee?: InputMaybe<Scalars['Float']>;
}>;


export type CalculateDiscountAndFeesMutation = { __typename?: 'Mutation', calculateDiscountAndFees?: { __typename?: 'DiscountAndFees', discount?: number | null, fees?: number | null, deliveryFees?: number | null, vat?: number | null, invalidProductIds?: Array<string> | null, checkoutMode: CheckoutMode, paymentMethods: Array<PurchasePaymentMethod> } | null };

export type RequestProductsPurchaseMutationVariables = Exact<{
  arrivedViaSlugs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  paymentMethod: PurchasePaymentMethod;
  cart: Array<RequestProductsPurchaseInput> | RequestProductsPurchaseInput;
  promocodeId?: InputMaybe<Scalars['String']>;
  fromWeb?: InputMaybe<Scalars['Boolean']>;
  postPaymentReturnUrl?: InputMaybe<Scalars['String']>;
  additionalInfo?: InputMaybe<Scalars['Json']>;
  joinRequirementsResponses?: InputMaybe<Scalars['Json']>;
  checkoutRequirementsResponses?: InputMaybe<Scalars['Json']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  printfulShippingMethod?: InputMaybe<Scalars['String']>;
  printfulShippingRate?: InputMaybe<Scalars['Float']>;
}>;


export type RequestProductsPurchaseMutation = { __typename?: 'Mutation', requestProductsPurchase?: { __typename?: 'RequestProductsPurchase', orderId: string, purchaseIds?: Array<string> | null, swishCheckoutDeepLink?: string | null, stripePaymentIntentClientSecret?: string | null, stripeRedirectUrl?: string | null, stripeSwishQRUrl?: string | null, kustomCheckoutHtmlSnippet?: string | null, kustomCheckoutOrderId?: string | null } | null };

export type ShopPurchasesQueryVariables = Exact<{
  purchaseIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ShopPurchasesQuery = { __typename?: 'Query', shopPurchases: Array<{ __typename?: 'Purchase', id: string, status: PurchaseStatus, statusMessage?: string | null, deliveryMethod?: DeliveryMethod | null, competitionInfo?: any | null, product: { __typename?: 'Product', name: string, additionalConfig: any } }> };

export type CheckoutPostReturnQueryVariables = Exact<{
  purchaseIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CheckoutPostReturnQuery = { __typename?: 'Query', checkoutPostReturn?: { __typename?: 'checkoutPostReturnResult', currency: string, discount: number, fees: number, status: string, vat: number, byEmail: boolean, purchases: Array<{ __typename?: 'CheckoutPostReturnPurchase', additionalInfo?: any | null, deliveryMethod?: DeliveryMethod | null, price: number, status: PurchaseStatus, statusMessage?: string | null, product: { __typename?: 'Product', id: string, vat: number, name: string, limit: number, price: number, pricingType: ProductPricingType, minPrice?: number | null, order: number, status: string, currency: SupportedCurrencies, endDate?: Date | null, mediaUrl?: string | null, media?: Array<string> | null, slugs?: Array<string> | null, startDate?: Date | null, isDisabled: boolean, description?: string | null, productType: ProductType, externalBuyLink?: string | null, maxAllowedPurchases: number, additionalInfo?: string | null, additionalConfig: any, validFrom?: Date | null, validTo?: Date | null, userMembershipId?: string | null, shortTerms?: string | null, displayPrice: string, postPurchaseInstructions?: string | null, event?: { __typename?: 'Event', id: string, name: string, mediaUrl?: string | null, start?: Date | null, checkoutRequirements?: any | null } | null } }>, digitalItems?: Array<{ __typename?: 'DigitalItem', ticketUuid: string, productName: string, label: string }> | null } | null };

export type ValidatePromocodeMutationVariables = Exact<{
  parentCommunityId: Scalars['String'];
  parentCommunityCode?: InputMaybe<Scalars['String']>;
  promocode: Scalars['String'];
  productIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ValidatePromocodeMutation = { __typename?: 'Mutation', validatePromocode?: { __typename?: 'Promocode', id: string, name?: string | null } | null };

export type CreateOrUpdateKustomOrderMutationVariables = Exact<{
  arrivedViaSlugs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  cart: Array<RequestProductsPurchaseInput> | RequestProductsPurchaseInput;
  communityCode: Scalars['String'];
  orderId?: InputMaybe<Scalars['String']>;
  promocodeId?: InputMaybe<Scalars['String']>;
  additionalInfo?: InputMaybe<Scalars['Json']>;
  checkoutRequirementsResponses?: InputMaybe<Scalars['Json']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  printfulShippingMethod?: InputMaybe<Scalars['String']>;
  printfulShippingRate?: InputMaybe<Scalars['Float']>;
}>;


export type CreateOrUpdateKustomOrderMutation = { __typename?: 'Mutation', createOrUpdateKustomOrder?: { __typename?: 'CreateOrUpdateKustomOrderResponse', htmlSnippet: string, orderId: string, purchaseIds?: Array<string> | null, werzOrderId: string } | null };

export type GetPrintfulShippingRatesMutationVariables = Exact<{
  cart: Array<RequestProductsPurchaseInput> | RequestProductsPurchaseInput;
  shippingAddress: PrintfulShippingAddressInput;
}>;


export type GetPrintfulShippingRatesMutation = { __typename?: 'Mutation', getPrintfulShippingRates?: { __typename?: 'PrintfulShippingRatesResult', selectedShippingMethod?: string | null, rates: Array<{ __typename?: 'PrintfulShippingRateResult', currency: string, customsFeesPossible: boolean, maxDeliveryDate?: string | null, maxDeliveryDays?: number | null, minDeliveryDate?: string | null, minDeliveryDays?: number | null, rate: number, shipping: string, shippingMethodName?: string | null }> } | null };

export type ConfirmKustomOrderMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type ConfirmKustomOrderMutation = { __typename?: 'Mutation', confirmKustomOrder?: { __typename?: 'ConfirmKustomOrderResponse', success: boolean, discount: number, fees: number, vat: number, currency: string, byEmail: boolean, purchases?: Array<{ __typename?: 'Purchase', additionalInfo?: any | null, deliveryMethod?: DeliveryMethod | null, id: string, amount: number, discount: number, fee: number, price: number, status: PurchaseStatus, statusMessage?: string | null, product: { __typename?: 'Product', id: string, vat: number, name: string, limit: number, price: number, pricingType: ProductPricingType, minPrice?: number | null, order: number, status: string, currency: SupportedCurrencies, endDate?: Date | null, mediaUrl?: string | null, media?: Array<string> | null, slugs?: Array<string> | null, startDate?: Date | null, isDisabled: boolean, description?: string | null, productType: ProductType, externalBuyLink?: string | null, maxAllowedPurchases: number, additionalInfo?: string | null, additionalConfig: any, validFrom?: Date | null, validTo?: Date | null, userMembershipId?: string | null, shortTerms?: string | null, displayPrice: string, postPurchaseInstructions?: string | null, event?: { __typename?: 'Event', id: string, name: string, mediaUrl?: string | null, start?: Date | null, checkoutRequirements?: any | null } | null } }> | null, digitalItems?: Array<{ __typename?: 'DigitalItem', ticketUuid: string, productName: string, label: string }> | null } | null };

export type CommunityLandingQueryVariables = Exact<{
  communityCode: Scalars['String'];
}>;


export type CommunityLandingQuery = { __typename?: 'Query', communityLanding?: { __typename?: 'communityLandingResult', community: { __typename?: 'communityResult', id: string, name: string, code?: string | null, iconUrl: string, location?: string | null, radioModule: boolean, description?: string | null, currency?: string | null, availablePaymentMethods?: Array<string> | null, preselectedPaymentMethod?: string | null, configs?: any | null, stripeConnectedAccountId?: string | null, requestToJoin: boolean, joinRequirements?: any | null, socialLinks: Array<{ __typename?: 'socialLinksResult', url: string, platform: string }> }, upcomingEvents?: Array<{ __typename?: 'upcomingEventsResult', id: string, webLink: string, end?: Date | null, name: string, start?: Date | null, locationDisplayCompact: string, mediaUrl: string, buyTicketsLink?: string | null, products: Array<{ __typename?: 'productsResult', id: string, end?: Date | null, name: string, price: string, start?: Date | null, status: string }> }> | null, latestNews?: Array<{ __typename?: 'latestNewsResult', id: string, name: string, mediaUrl: string, createdAt?: Date | null }> | null, radioTracks?: Array<{ __typename?: 'radioTracksResult', id: string, end?: Date | null, type: TrackType, title: string, start?: Date | null, duration: number, coverUrl: string }> | null, otherLinks?: Array<{ __typename?: 'otherLinksResult', url: string, text: string, icon?: string | null }> | null } | null };

export type CommunityContentQueryVariables = Exact<{
  communityId: Scalars['ID'];
}>;


export type CommunityContentQuery = { __typename?: 'Query', announcements?: { __typename?: 'AnnouncementsReturn', items: Array<{ __typename?: 'FeedItem', id: string, title: string, media: Array<string>, liked?: boolean | null, subtitle?: string | null, createdAt: Date, likesCount?: number | null, externalUrl?: string | null, description?: string | null, commentsCount?: number | null }> } | null, eventsV2?: { __typename?: 'EventsV2Response', items: Array<{ __typename?: 'Event', id: string, end?: Date | null, name: string, start?: Date | null, mediaUrl?: string | null, locationDisplayCompact: string, webLink?: string | null }> } | null };

export type CompetitionTicketQueryVariables = Exact<{
  ticketUuid?: InputMaybe<Scalars['String']>;
}>;


export type CompetitionTicketQuery = { __typename?: 'Query', competitionTicket?: { __typename?: 'CompetitionTicket', ticketUuid: string, state: string, isWinner?: boolean | null, question?: string | null, options?: Array<string> | null, communityCode: string, productSlug?: string | null, charityName: string, charityUrl: string, donationPool: number, productName: string, productImage?: string | null } | null };

export type CompetitionLandingQueryVariables = Exact<{
  communityCode?: InputMaybe<Scalars['String']>;
}>;


export type CompetitionLandingQuery = { __typename?: 'Query', competitionTicket?: { __typename?: 'CompetitionTicket', donationPool: number, charityName: string, charityUrl: string, donateProductSlug?: string | null, productSlug?: string | null, communityCode: string } | null };

export type UpdateCompetitionTicketMutationVariables = Exact<{
  ticketUuid: Scalars['String'];
  answerIndex?: InputMaybe<Scalars['Int']>;
  reveal?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCompetitionTicketMutation = { __typename?: 'Mutation', updateCompetitionTicket?: { __typename?: 'UpdateCompetitionTicketResult', correct?: boolean | null, isWinner?: boolean | null, state: string } | null };

export type ContentPreviewQueryVariables = Exact<{
  landingCode: Scalars['String'];
  type: Scalars['String'];
  itemId: Scalars['String'];
}>;


export type ContentPreviewQuery = { __typename?: 'Query', contentPreview?: { __typename?: 'DisplayContentPreview', id?: string | null, type?: string | null, title?: string | null, subtitle?: string | null, image?: string | null, community?: { __typename?: 'DisplayContentPreviewCommunity', name?: string | null, iconUrl?: string | null } | null } | null };

export type CreateDeferredLinkMutationVariables = Exact<{
  inviteUrl: Scalars['String'];
  communityCode: Scalars['String'];
  inviteCode: Scalars['String'];
  screenWidth: Scalars['Int'];
  timezone: Scalars['String'];
  locale: Scalars['String'];
}>;


export type CreateDeferredLinkMutation = { __typename?: 'Mutation', createDeferredLink?: boolean | null };

export type DetectCountryQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectCountryQuery = { __typename?: 'Query', detectCountry?: string | null };

export type EventsQueryVariables = Exact<{
  communityId: Scalars['ID'];
  futureOnly: Scalars['Boolean'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type EventsQuery = { __typename?: 'Query', eventsV2?: { __typename?: 'EventsV2Response', next: number, total: number, items: Array<{ __typename?: 'Event', id: string, end?: Date | null, name: string, start?: Date | null, mediaUrl?: string | null, locationDisplayCompact: string, webLink?: string | null }> } | null };

export type EventQueryVariables = Exact<{
  communityId: Scalars['ID'];
  eventId: Scalars['ID'];
}>;


export type EventQuery = { __typename?: 'Query', eventV2?: { __typename?: 'Event', arrivedViaSlug?: string | null, id: string, end?: Date | null, name: string, start?: Date | null, mediaUrl?: string | null, locationDisplayCompact: string, locationDisplayFull: string, webLink?: string | null, latitude?: number | null, longitude?: number | null, buyTicketsLink?: string | null, locationDropTime?: Date | null, locationAvailable: boolean, additionalDetails?: string | null, locationDescription?: string | null, freeGuestListProductId?: string | null, products: Array<{ __typename?: 'Product', id: string, vat: number, name: string, limit: number, price: number, pricingType: ProductPricingType, minPrice?: number | null, order: number, status: string, currency: SupportedCurrencies, endDate?: Date | null, mediaUrl?: string | null, media?: Array<string> | null, slugs?: Array<string> | null, startDate?: Date | null, isDisabled: boolean, description?: string | null, productType: ProductType, externalBuyLink?: string | null, maxAllowedPurchases: number, additionalInfo?: string | null, additionalConfig: any, validFrom?: Date | null, validTo?: Date | null, userMembershipId?: string | null, shortTerms?: string | null, displayPrice: string, postPurchaseInstructions?: string | null, event?: { __typename?: 'Event', id: string, name: string, mediaUrl?: string | null, start?: Date | null, checkoutRequirements?: any | null } | null }> } | null };

export type EventWithTicketsQueryVariables = Exact<{
  eventId: Scalars['ID'];
  communityId?: InputMaybe<Scalars['ID']>;
  accessCode?: InputMaybe<Scalars['String']>;
}>;


export type EventWithTicketsQuery = { __typename?: 'Query', eventWithTickets?: { __typename?: 'EventWithTicketsResponse', showGotCode: boolean, eventInfo: { __typename?: 'DisplayEventInfo', id: string, name: string, start?: Date | null, end?: Date | null, locationDisplayCompact: string, locationDisplayFull: string, description?: string | null, mediaUrl?: string | null }, products: Array<{ __typename?: 'Product', id: string, vat: number, name: string, limit: number, price: number, pricingType: ProductPricingType, minPrice?: number | null, order: number, status: string, currency: SupportedCurrencies, endDate?: Date | null, mediaUrl?: string | null, media?: Array<string> | null, slugs?: Array<string> | null, startDate?: Date | null, isDisabled: boolean, description?: string | null, productType: ProductType, externalBuyLink?: string | null, maxAllowedPurchases: number, additionalInfo?: string | null, additionalConfig: any, validFrom?: Date | null, validTo?: Date | null, userMembershipId?: string | null, shortTerms?: string | null, displayPrice: string, postPurchaseInstructions?: string | null, event?: { __typename?: 'Event', id: string, name: string, mediaUrl?: string | null, start?: Date | null, checkoutRequirements?: any | null } | null }>, requestBundleProducts: Array<{ __typename?: 'Product', id: string, vat: number, name: string, limit: number, price: number, pricingType: ProductPricingType, minPrice?: number | null, order: number, status: string, currency: SupportedCurrencies, endDate?: Date | null, mediaUrl?: string | null, media?: Array<string> | null, slugs?: Array<string> | null, startDate?: Date | null, isDisabled: boolean, description?: string | null, productType: ProductType, externalBuyLink?: string | null, maxAllowedPurchases: number, additionalInfo?: string | null, additionalConfig: any, validFrom?: Date | null, validTo?: Date | null, userMembershipId?: string | null, shortTerms?: string | null, displayPrice: string, postPurchaseInstructions?: string | null, event?: { __typename?: 'Event', id: string, name: string, mediaUrl?: string | null, start?: Date | null, checkoutRequirements?: any | null } | null }> } | null };

export type EventListItemFragment = { __typename?: 'Event', id: string, end?: Date | null, name: string, start?: Date | null, mediaUrl?: string | null, locationDisplayCompact: string, webLink?: string | null };

export type EventDetailFragment = { __typename?: 'Event', id: string, end?: Date | null, name: string, start?: Date | null, mediaUrl?: string | null, locationDisplayCompact: string, locationDisplayFull: string, webLink?: string | null, latitude?: number | null, longitude?: number | null, buyTicketsLink?: string | null, locationDropTime?: Date | null, locationAvailable: boolean, additionalDetails?: string | null, locationDescription?: string | null, freeGuestListProductId?: string | null, products: Array<{ __typename?: 'Product', id: string, vat: number, name: string, limit: number, price: number, pricingType: ProductPricingType, minPrice?: number | null, order: number, status: string, currency: SupportedCurrencies, endDate?: Date | null, mediaUrl?: string | null, media?: Array<string> | null, slugs?: Array<string> | null, startDate?: Date | null, isDisabled: boolean, description?: string | null, productType: ProductType, externalBuyLink?: string | null, maxAllowedPurchases: number, additionalInfo?: string | null, additionalConfig: any, validFrom?: Date | null, validTo?: Date | null, userMembershipId?: string | null, shortTerms?: string | null, displayPrice: string, postPurchaseInstructions?: string | null, event?: { __typename?: 'Event', id: string, name: string, mediaUrl?: string | null, start?: Date | null, checkoutRequirements?: any | null } | null }> };

export type BaseProductFragment = { __typename?: 'Product', id: string, vat: number, name: string, limit: number, price: number, pricingType: ProductPricingType, minPrice?: number | null, order: number, status: string, currency: SupportedCurrencies, endDate?: Date | null, mediaUrl?: string | null, media?: Array<string> | null, slugs?: Array<string> | null, startDate?: Date | null, isDisabled: boolean, description?: string | null, productType: ProductType, externalBuyLink?: string | null, maxAllowedPurchases: number, additionalInfo?: string | null, additionalConfig: any, validFrom?: Date | null, validTo?: Date | null, userMembershipId?: string | null, shortTerms?: string | null, displayPrice: string, postPurchaseInstructions?: string | null, event?: { __typename?: 'Event', id: string, name: string, mediaUrl?: string | null, start?: Date | null, checkoutRequirements?: any | null } | null };

export type TrackEventSlugVisitMutationVariables = Exact<{
  slug: Scalars['String'];
  visitorId?: InputMaybe<Scalars['String']>;
}>;


export type TrackEventSlugVisitMutation = { __typename?: 'Mutation', trackEventSlugVisit: boolean };

export type SaveFormResponseMutationVariables = Exact<{
  source: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['Json']>;
}>;


export type SaveFormResponseMutation = { __typename?: 'Mutation', saveFormResponse?: boolean | null };

export type ForumPostsQueryVariables = Exact<{
  communityId: Scalars['ID'];
  filterTagId?: InputMaybe<Scalars['ID']>;
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type ForumPostsQuery = { __typename?: 'Query', forumPosts?: { __typename?: 'ForumPostsReturn', next: number, total: number, allTags: Array<{ __typename?: 'ForumTag', id: string, name: string }>, posts: Array<{ __typename?: 'ForumPost', id: string, media: Array<string>, liked: boolean, content?: string | null, headline?: string | null, createdAt: Date, likesCount: number, likesBoost: number, commentsCount: number, publishingStatus: ForumPostPublishingStatus, commentsAndRepliesCount: number, tags: Array<{ __typename?: 'ForumTag', id: string, name: string }>, author: { __typename?: 'User', id: string, avatar?: string | null, username?: string | null } }> } | null };

export type ForumPostQueryVariables = Exact<{
  communityId?: InputMaybe<Scalars['ID']>;
  postId: Scalars['ID'];
}>;


export type ForumPostQuery = { __typename?: 'Query', forumPost?: { __typename?: 'ForumPost', id: string, media: Array<string>, liked: boolean, content?: string | null, headline?: string | null, createdAt: Date, likesCount: number, likesBoost: number, commentsCount: number, publishingStatus: ForumPostPublishingStatus, commentsAndRepliesCount: number, tags: Array<{ __typename?: 'ForumTag', id: string, name: string }>, author: { __typename?: 'User', id: string, avatar?: string | null, username?: string | null } } | null };

export type ForumPostCommentsQueryVariables = Exact<{
  postId: Scalars['ID'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type ForumPostCommentsQuery = { __typename?: 'Query', forumPostComments?: { __typename?: 'ForumPostCommentsReturn', total: number, next: number, comments: Array<{ __typename?: 'ForumComment', id: string, liked: boolean, media: Array<string>, content: string, createdAt: Date, likesCount: number, replies: Array<{ __typename?: 'ForumComment', id: string, liked: boolean, media: Array<string>, content: string, createdAt: Date, likesCount: number, post: { __typename?: 'ForumPost', id: string }, author: { __typename?: 'User', id: string, avatar?: string | null, username?: string | null } }>, post: { __typename?: 'ForumPost', id: string }, author: { __typename?: 'User', id: string, avatar?: string | null, username?: string | null } }> } | null };

export type SubmitForumPostMutationVariables = Exact<{
  communityId: Scalars['ID'];
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  media?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SubmitForumPostMutation = { __typename?: 'Mutation', submitForumPost?: { __typename?: 'ForumPost', id: string } | null };

export type ReactForumPostMutationVariables = Exact<{
  forumPostId: Scalars['ID'];
}>;


export type ReactForumPostMutation = { __typename?: 'Mutation', reactForumPost?: boolean | null };

export type ReactForumCommentMutationVariables = Exact<{
  forumCommentId: Scalars['ID'];
}>;


export type ReactForumCommentMutation = { __typename?: 'Mutation', reactForumComment?: boolean | null };

export type DeleteForumContentMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['ID']>;
  commentId?: InputMaybe<Scalars['ID']>;
}>;


export type DeleteForumContentMutation = { __typename?: 'Mutation', deleteForumContent?: boolean | null };

export type ReportForumContentMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['ID']>;
  commentId?: InputMaybe<Scalars['ID']>;
  reason: Scalars['String'];
}>;


export type ReportForumContentMutation = { __typename?: 'Mutation', reportForumContent?: { __typename?: 'ForumContentReport', id: string } | null };

export type CommentForumPostMutationVariables = Exact<{
  postId: Scalars['ID'];
  commentId?: InputMaybe<Scalars['ID']>;
  content: Scalars['String'];
  media?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CommentForumPostMutation = { __typename?: 'Mutation', commentForumPost?: { __typename?: 'ForumComment', id: string } | null };

export type BaseForumPostFragment = { __typename?: 'ForumPost', id: string, media: Array<string>, liked: boolean, content?: string | null, headline?: string | null, createdAt: Date, likesCount: number, likesBoost: number, commentsCount: number, publishingStatus: ForumPostPublishingStatus, commentsAndRepliesCount: number, tags: Array<{ __typename?: 'ForumTag', id: string, name: string }>, author: { __typename?: 'User', id: string, avatar?: string | null, username?: string | null } };

export type BaseCommentFragment = { __typename?: 'ForumComment', id: string, liked: boolean, media: Array<string>, content: string, createdAt: Date, likesCount: number, post: { __typename?: 'ForumPost', id: string }, author: { __typename?: 'User', id: string, avatar?: string | null, username?: string | null } };

export type StartGameRunMutationVariables = Exact<{
  game: Scalars['String'];
  player: Scalars['String'];
}>;


export type StartGameRunMutation = { __typename?: 'Mutation', startGameRun?: string | null };

export type FinishGameRunMutationVariables = Exact<{
  runId: Scalars['ID'];
  score: Scalars['Int'];
  playSeconds: Scalars['Float'];
}>;


export type FinishGameRunMutation = { __typename?: 'Mutation', finishGameRun?: boolean | null };

export type TopGameScoresQueryVariables = Exact<{
  game?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
}>;


export type TopGameScoresQuery = { __typename?: 'Query', topGameScores: Array<{ __typename?: 'TopGameScores', displayName?: string | null, id?: string | null, isCurrentPlayer?: boolean | null, score?: number | null }> };

export type ClaimCardMutationVariables = Exact<{
  userId: Scalars['String'];
  communityCode: Scalars['String'];
}>;


export type ClaimCardMutation = { __typename?: 'Mutation', claimCard?: boolean | null };

export type GuestListInviteQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GuestListInviteQuery = { __typename?: 'Query', guestListInvite?: { __typename?: 'DisplayGuestListInvite', code?: string | null, status?: string | null, fullName?: string | null, note?: string | null, numPlus?: number | null, claimerId?: string | null, productName?: string | null, eventId?: string | null, plusGuests: Array<{ __typename?: 'DisplayGuestListPlusGuest', name?: string | null, phone?: string | null, status?: string | null }>, event?: { __typename?: 'DisplayGuestListEvent', id?: string | null, name?: string | null, start?: Date | null, locationDisplayFull?: string | null, mediaUrl?: string | null, community?: { __typename?: 'DisplayGuestListCommunity', name?: string | null, code?: string | null, globalInviteCode?: string | null, iconUrl?: string | null } | null } | null } | null };

export type ClaimGuestListInviteMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type ClaimGuestListInviteMutation = { __typename?: 'Mutation', claimGuestListInvite?: boolean | null };

export type AddGuestListInviteMutationVariables = Exact<{
  code: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
}>;


export type AddGuestListInviteMutation = { __typename?: 'Mutation', addGuestListInvite?: boolean | null };

export type RemoveGuestListInviteMutationVariables = Exact<{
  code: Scalars['String'];
  phone: Scalars['String'];
}>;


export type RemoveGuestListInviteMutation = { __typename?: 'Mutation', removeGuestListInvite?: boolean | null };

export type MarkGuestListInviteAsOpenedMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type MarkGuestListInviteAsOpenedMutation = { __typename?: 'Mutation', updateGuestListInviteStatus?: boolean | null };

export type CreateMediaMutationVariables = Exact<{
  filename?: InputMaybe<Scalars['String']>;
  mimeType: Scalars['String'];
  subpath: Scalars['String'];
}>;


export type CreateMediaMutation = { __typename?: 'Mutation', createMedia?: { __typename?: 'CreateMediaResponse', publicUrl?: string | null, uploadURL?: string | null } | null };

export type CreateShareMutationVariables = Exact<{
  communityCode: Scalars['String'];
  module: Module;
}>;


export type CreateShareMutation = { __typename?: 'Mutation', createShare?: string | null };

export type ShopQueryVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type ShopQuery = { __typename?: 'Query', shopV2?: { __typename?: 'ShopV2Response', next: number, total: number, items: Array<{ __typename?: 'Product', id: string, vat: number, name: string, limit: number, price: number, pricingType: ProductPricingType, minPrice?: number | null, order: number, status: string, currency: SupportedCurrencies, endDate?: Date | null, mediaUrl?: string | null, media?: Array<string> | null, slugs?: Array<string> | null, startDate?: Date | null, isDisabled: boolean, description?: string | null, productType: ProductType, externalBuyLink?: string | null, maxAllowedPurchases: number, additionalInfo?: string | null, additionalConfig: any, validFrom?: Date | null, validTo?: Date | null, userMembershipId?: string | null, shortTerms?: string | null, displayPrice: string, postPurchaseInstructions?: string | null, event?: { __typename?: 'Event', id: string, name: string, mediaUrl?: string | null, start?: Date | null, checkoutRequirements?: any | null } | null }> } | null };

export type ShopV3QueryVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  selectedProductType: SelectedProductType;
}>;


export type ShopV3Query = { __typename?: 'Query', shopV3?: { __typename?: 'ShopV3Response', availableProductTypes: Array<ProductType>, eventsWithProducts: Array<{ __typename?: 'EventWithProducts', id: string, name: string, start: Date, end: Date, locationDisplayCompact: string, buyTicketsLink?: string | null, products: Array<{ __typename?: 'Product', id: string, vat: number, name: string, limit: number, price: number, pricingType: ProductPricingType, minPrice?: number | null, order: number, status: string, currency: SupportedCurrencies, endDate?: Date | null, mediaUrl?: string | null, media?: Array<string> | null, slugs?: Array<string> | null, startDate?: Date | null, isDisabled: boolean, description?: string | null, productType: ProductType, externalBuyLink?: string | null, maxAllowedPurchases: number, additionalInfo?: string | null, additionalConfig: any, validFrom?: Date | null, validTo?: Date | null, userMembershipId?: string | null, shortTerms?: string | null, displayPrice: string, postPurchaseInstructions?: string | null, event?: { __typename?: 'Event', id: string, name: string, mediaUrl?: string | null, start?: Date | null, checkoutRequirements?: any | null } | null }> }>, nonTicketProducts: Array<{ __typename?: 'Product', id: string, vat: number, name: string, limit: number, price: number, pricingType: ProductPricingType, minPrice?: number | null, order: number, status: string, currency: SupportedCurrencies, endDate?: Date | null, mediaUrl?: string | null, media?: Array<string> | null, slugs?: Array<string> | null, startDate?: Date | null, isDisabled: boolean, description?: string | null, productType: ProductType, externalBuyLink?: string | null, maxAllowedPurchases: number, additionalInfo?: string | null, additionalConfig: any, validFrom?: Date | null, validTo?: Date | null, userMembershipId?: string | null, shortTerms?: string | null, displayPrice: string, postPurchaseInstructions?: string | null, event?: { __typename?: 'Event', id: string, name: string, mediaUrl?: string | null, start?: Date | null, checkoutRequirements?: any | null } | null }> } | null };

export type ProductQueryVariables = Exact<{
  productId: Scalars['ID'];
}>;


export type ProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, vat: number, name: string, limit: number, price: number, pricingType: ProductPricingType, minPrice?: number | null, order: number, status: string, currency: SupportedCurrencies, endDate?: Date | null, mediaUrl?: string | null, media?: Array<string> | null, slugs?: Array<string> | null, startDate?: Date | null, isDisabled: boolean, description?: string | null, productType: ProductType, externalBuyLink?: string | null, maxAllowedPurchases: number, additionalInfo?: string | null, additionalConfig: any, validFrom?: Date | null, validTo?: Date | null, userMembershipId?: string | null, shortTerms?: string | null, displayPrice: string, postPurchaseInstructions?: string | null, event?: { __typename?: 'Event', id: string, name: string, mediaUrl?: string | null, start?: Date | null, checkoutRequirements?: any | null } | null } | null };

export type UserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, avatar?: string | null, birthday?: Date | null, lastName?: string | null, username?: string | null, firstName?: string | null, phoneVerified: boolean, emailVerified: boolean, communityOnboardingInfo?: any | null, communitiesWhereMember: Array<{ __typename?: 'Community', id: string, name: string, code?: string | null, currency: SupportedCurrencies, iconUrl?: string | null, landingCode?: string | null, availablePaymentMethods: Array<string>, preselectedPaymentMethod?: PurchasePaymentMethod | null, configs: any, stripeConnectedAccountId?: string | null, joinRequirements?: any | null, requiredUserFields: Array<UserInfoField>, missingRequiredUserFields: Array<string>, requestToJoin: boolean }>, communitiesWhereRequested: Array<{ __typename?: 'Community', id: string, code?: string | null }> } | null };

export type PostCreateUserUpdateMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type PostCreateUserUpdateMutation = { __typename?: 'Mutation', postCreateUserUpdate?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, avatar?: string | null, birthday?: Date | null, lastName?: string | null, username?: string | null, firstName?: string | null, phoneVerified: boolean, emailVerified: boolean, communityOnboardingInfo?: any | null, communitiesWhereMember: Array<{ __typename?: 'Community', id: string, name: string, code?: string | null, currency: SupportedCurrencies }>, communitiesWhereRequested: Array<{ __typename?: 'Community', id: string, code?: string | null }> } | null };

export type UserUpdateMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  birthday?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', userUpdate?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, avatar?: string | null, birthday?: Date | null, lastName?: string | null, username?: string | null, firstName?: string | null, phoneVerified: boolean, emailVerified: boolean, communityOnboardingInfo?: any | null, communitiesWhereMember: Array<{ __typename?: 'Community', id: string, name: string, code?: string | null, currency: SupportedCurrencies }>, communitiesWhereRequested: Array<{ __typename?: 'Community', id: string, code?: string | null }> } | null };

export type UserUpdateV2MutationVariables = Exact<{
  data: UserUpdateV2Input;
}>;


export type UserUpdateV2Mutation = { __typename?: 'Mutation', userUpdateV2?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, avatar?: string | null, birthday?: Date | null, lastName?: string | null, username?: string | null, firstName?: string | null, phoneVerified: boolean, emailVerified: boolean, communityOnboardingInfo?: any | null, communitiesWhereMember: Array<{ __typename?: 'Community', id: string, name: string, code?: string | null, currency: SupportedCurrencies }>, communitiesWhereRequested: Array<{ __typename?: 'Community', id: string, code?: string | null }> } | null };

export type JoinCommunityWaitlistMutationVariables = Exact<{
  communityCode: Scalars['String'];
}>;


export type JoinCommunityWaitlistMutation = { __typename?: 'Mutation', joinCommunityWaitlist?: { __typename?: 'JoinWaitlistResult', success: boolean, alreadyOnWaitlist: boolean } | null };

export const BaseFeedItemFragmentDoc = `
    fragment baseFeedItem on FeedItem {
  id
  title
  media
  liked
  subtitle
  createdAt
  likesCount
  externalUrl
  description
  commentsCount
}
    `;
export const BaseUserFragmentDoc = `
    fragment baseUser on User {
  id
  email
  phone
  avatar
  birthday
  lastName
  username
  firstName
  phoneVerified
  emailVerified
  communityOnboardingInfo
  communitiesWhereMember {
    id
    name
    code
    currency
  }
  communitiesWhereRequested {
    id
    code
  }
}
    `;
export const BaseCommunityFragmentDoc = `
    fragment baseCommunity on Community {
  id
  name
  code
  iconUrl
  currency
  landingCode
  availablePaymentMethods
  preselectedPaymentMethod
  configs
  stripeConnectedAccountId
  joinRequirements
  requiredUserFields
  missingRequiredUserFields
  requestToJoin
}
    `;
export const EventListItemFragmentDoc = `
    fragment eventListItem on Event {
  id
  end
  name
  start
  mediaUrl
  locationDisplayCompact
  webLink
}
    `;
export const BaseProductFragmentDoc = `
    fragment baseProduct on Product {
  id
  vat
  name
  limit
  price
  pricingType
  minPrice
  order
  status
  currency
  endDate
  mediaUrl
  media
  slugs
  startDate
  isDisabled
  description
  productType
  externalBuyLink
  maxAllowedPurchases
  additionalInfo
  additionalConfig
  validFrom
  validTo
  userMembershipId
  shortTerms
  displayPrice
  postPurchaseInstructions
  event {
    id
    name
    mediaUrl
    start
    checkoutRequirements
  }
}
    `;
export const EventDetailFragmentDoc = `
    fragment eventDetail on Event {
  id
  end
  name
  start
  mediaUrl
  locationDisplayCompact
  locationDisplayFull
  webLink
  latitude
  longitude
  buyTicketsLink
  locationDropTime
  locationAvailable
  additionalDetails
  locationDescription
  freeGuestListProductId
  products {
    ...baseProduct
  }
}
    ${BaseProductFragmentDoc}`;
export const BaseForumPostFragmentDoc = `
    fragment baseForumPost on ForumPost {
  id
  media
  liked
  content
  headline
  createdAt
  likesCount
  likesBoost
  commentsCount
  publishingStatus
  commentsAndRepliesCount
  tags {
    id
    name
  }
  author {
    id
    avatar
    username
  }
}
    `;
export const BaseCommentFragmentDoc = `
    fragment baseComment on ForumComment {
  id
  liked
  media
  content
  createdAt
  likesCount
  post {
    id
  }
  author {
    id
    avatar
    username
  }
}
    `;
export const TrackUserActivityDocument = `
    mutation TrackUserActivity($type: UserActivityEventType!, $communityCode: String, $data: Json, $envelope: Json!) {
  trackUserActivity(
    type: $type
    source: WebMembers
    communityCode: $communityCode
    data: $data
    envelope: $envelope
  )
}
    `;
export const useTrackUserActivityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TrackUserActivityMutation, TError, TrackUserActivityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TrackUserActivityMutation, TError, TrackUserActivityMutationVariables, TContext>(
      ['TrackUserActivity'],
      (variables?: TrackUserActivityMutationVariables) => fetcher<TrackUserActivityMutation, TrackUserActivityMutationVariables>(client, TrackUserActivityDocument, variables, headers)(),
      options
    );
export const RegisterUserActivityIdentityDocument = `
    mutation RegisterUserActivityIdentity($anonymousId: String!, $identityToken: String!) {
  registerUserActivityIdentity(
    anonymousId: $anonymousId
    identityToken: $identityToken
  )
}
    `;
export const useRegisterUserActivityIdentityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RegisterUserActivityIdentityMutation, TError, RegisterUserActivityIdentityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RegisterUserActivityIdentityMutation, TError, RegisterUserActivityIdentityMutationVariables, TContext>(
      ['RegisterUserActivityIdentity'],
      (variables?: RegisterUserActivityIdentityMutationVariables) => fetcher<RegisterUserActivityIdentityMutation, RegisterUserActivityIdentityMutationVariables>(client, RegisterUserActivityIdentityDocument, variables, headers)(),
      options
    );
export const AssociateUserActivityIdentityDocument = `
    mutation AssociateUserActivityIdentity($anonymousId: String!, $identityToken: String!) {
  associateUserActivityIdentity(
    anonymousId: $anonymousId
    identityToken: $identityToken
  )
}
    `;
export const useAssociateUserActivityIdentityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AssociateUserActivityIdentityMutation, TError, AssociateUserActivityIdentityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AssociateUserActivityIdentityMutation, TError, AssociateUserActivityIdentityMutationVariables, TContext>(
      ['AssociateUserActivityIdentity'],
      (variables?: AssociateUserActivityIdentityMutationVariables) => fetcher<AssociateUserActivityIdentityMutation, AssociateUserActivityIdentityMutationVariables>(client, AssociateUserActivityIdentityDocument, variables, headers)(),
      options
    );
export const RevokeUserActivityIdentityDocument = `
    mutation RevokeUserActivityIdentity($anonymousId: String!, $identityToken: String!) {
  revokeUserActivityIdentity(
    anonymousId: $anonymousId
    identityToken: $identityToken
  )
}
    `;
export const useRevokeUserActivityIdentityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RevokeUserActivityIdentityMutation, TError, RevokeUserActivityIdentityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RevokeUserActivityIdentityMutation, TError, RevokeUserActivityIdentityMutationVariables, TContext>(
      ['RevokeUserActivityIdentity'],
      (variables?: RevokeUserActivityIdentityMutationVariables) => fetcher<RevokeUserActivityIdentityMutation, RevokeUserActivityIdentityMutationVariables>(client, RevokeUserActivityIdentityDocument, variables, headers)(),
      options
    );
export const AmbassadorCampaignByCodeDocument = `
    query AmbassadorCampaignByCode($code: String!) {
  ambassadorCampaignByCode(code: $code) {
    id
    status
    spotsAvailable
    userHasClaimed
    segmentDisplayName
    segmentInstructions
    community {
      id
      name
      iconUrl
      code
    }
  }
}
    `;
export const useAmbassadorCampaignByCodeQuery = <
      TData = AmbassadorCampaignByCodeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AmbassadorCampaignByCodeQueryVariables,
      options?: UseQueryOptions<AmbassadorCampaignByCodeQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AmbassadorCampaignByCodeQuery, TError, TData>(
      ['AmbassadorCampaignByCode', variables],
      fetcher<AmbassadorCampaignByCodeQuery, AmbassadorCampaignByCodeQueryVariables>(client, AmbassadorCampaignByCodeDocument, variables, headers),
      options
    );
export const useInfiniteAmbassadorCampaignByCodeQuery = <
      TData = AmbassadorCampaignByCodeQuery,
      TError = unknown
    >(
      pageParamKey: keyof AmbassadorCampaignByCodeQueryVariables,
      client: GraphQLClient,
      variables: AmbassadorCampaignByCodeQueryVariables,
      options?: UseInfiniteQueryOptions<AmbassadorCampaignByCodeQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<AmbassadorCampaignByCodeQuery, TError, TData>(
      ['AmbassadorCampaignByCode.infinite', variables],
      (metaData) => fetcher<AmbassadorCampaignByCodeQuery, AmbassadorCampaignByCodeQueryVariables>(client, AmbassadorCampaignByCodeDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const ClaimAmbassadorCampaignDocument = `
    mutation ClaimAmbassadorCampaign($code: String!) {
  claimAmbassadorCampaign(code: $code)
}
    `;
export const useClaimAmbassadorCampaignMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ClaimAmbassadorCampaignMutation, TError, ClaimAmbassadorCampaignMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ClaimAmbassadorCampaignMutation, TError, ClaimAmbassadorCampaignMutationVariables, TContext>(
      ['ClaimAmbassadorCampaign'],
      (variables?: ClaimAmbassadorCampaignMutationVariables) => fetcher<ClaimAmbassadorCampaignMutation, ClaimAmbassadorCampaignMutationVariables>(client, ClaimAmbassadorCampaignDocument, variables, headers)(),
      options
    );
export const AnnouncementsDocument = `
    query Announcements($communityId: ID!, $skip: Int!, $take: Int!) {
  announcements(communityId: $communityId, skip: $skip, take: $take) {
    next
    total
    items {
      ...baseFeedItem
    }
  }
}
    ${BaseFeedItemFragmentDoc}`;
export const useAnnouncementsQuery = <
      TData = AnnouncementsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AnnouncementsQueryVariables,
      options?: UseQueryOptions<AnnouncementsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AnnouncementsQuery, TError, TData>(
      ['Announcements', variables],
      fetcher<AnnouncementsQuery, AnnouncementsQueryVariables>(client, AnnouncementsDocument, variables, headers),
      options
    );
export const useInfiniteAnnouncementsQuery = <
      TData = AnnouncementsQuery,
      TError = unknown
    >(
      pageParamKey: keyof AnnouncementsQueryVariables,
      client: GraphQLClient,
      variables: AnnouncementsQueryVariables,
      options?: UseInfiniteQueryOptions<AnnouncementsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<AnnouncementsQuery, TError, TData>(
      ['Announcements.infinite', variables],
      (metaData) => fetcher<AnnouncementsQuery, AnnouncementsQueryVariables>(client, AnnouncementsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const AnnouncementDocument = `
    query Announcement($announcementId: ID!, $communityId: ID) {
  announcement(announcementId: $announcementId, communityId: $communityId) {
    ...baseFeedItem
  }
}
    ${BaseFeedItemFragmentDoc}`;
export const useAnnouncementQuery = <
      TData = AnnouncementQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AnnouncementQueryVariables,
      options?: UseQueryOptions<AnnouncementQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AnnouncementQuery, TError, TData>(
      ['Announcement', variables],
      fetcher<AnnouncementQuery, AnnouncementQueryVariables>(client, AnnouncementDocument, variables, headers),
      options
    );
export const useInfiniteAnnouncementQuery = <
      TData = AnnouncementQuery,
      TError = unknown
    >(
      pageParamKey: keyof AnnouncementQueryVariables,
      client: GraphQLClient,
      variables: AnnouncementQueryVariables,
      options?: UseInfiniteQueryOptions<AnnouncementQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<AnnouncementQuery, TError, TData>(
      ['Announcement.infinite', variables],
      (metaData) => fetcher<AnnouncementQuery, AnnouncementQueryVariables>(client, AnnouncementDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const ReactAnnouncementDocument = `
    mutation ReactAnnouncement($feedItemId: ID!) {
  reactFeedItem(feedItemId: $feedItemId)
}
    `;
export const useReactAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReactAnnouncementMutation, TError, ReactAnnouncementMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReactAnnouncementMutation, TError, ReactAnnouncementMutationVariables, TContext>(
      ['ReactAnnouncement'],
      (variables?: ReactAnnouncementMutationVariables) => fetcher<ReactAnnouncementMutation, ReactAnnouncementMutationVariables>(client, ReactAnnouncementDocument, variables, headers)(),
      options
    );
export const AuthV2Document = `
    mutation AuthV2($phone: String!, $phoneVerificationCode: String, $fromWeb: Boolean) {
  authV2(
    phone: $phone
    phoneVerificationCode: $phoneVerificationCode
    fromWeb: $fromWeb
  ) {
    token
    verificationCodeSent
    user {
      ...baseUser
      communitiesWhereMember {
        ...baseCommunity
      }
    }
  }
}
    ${BaseUserFragmentDoc}
${BaseCommunityFragmentDoc}`;
export const useAuthV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AuthV2Mutation, TError, AuthV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AuthV2Mutation, TError, AuthV2MutationVariables, TContext>(
      ['AuthV2'],
      (variables?: AuthV2MutationVariables) => fetcher<AuthV2Mutation, AuthV2MutationVariables>(client, AuthV2Document, variables, headers)(),
      options
    );
export const LoginDocument = `
    mutation Login($identifier: String, $password: String) {
  login(identifier: $identifier, password: $password) {
    errors {
      ... on TranslatableError {
        errorCode
        path
      }
    }
    token
    user {
      ...baseUser
      communitiesWhereMember {
        ...baseCommunity
      }
    }
  }
}
    ${BaseUserFragmentDoc}
${BaseCommunityFragmentDoc}`;
export const useLoginMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<LoginMutation, TError, LoginMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<LoginMutation, TError, LoginMutationVariables, TContext>(
      ['Login'],
      (variables?: LoginMutationVariables) => fetcher<LoginMutation, LoginMutationVariables>(client, LoginDocument, variables, headers)(),
      options
    );
export const JoinCommunityDocument = `
    mutation JoinCommunity($inviteCode: String!, $doInfoChecks: Boolean = true, $joinRequirementsResponses: Json) {
  joinCommunityWithInfoCheck(
    inviteCode: $inviteCode
    doInfoChecks: $doInfoChecks
    joinRequirementsResponses: $joinRequirementsResponses
  ) {
    communities {
      ...baseCommunity
    }
    missingInfo
    joinRequirements
    requestToJoinSubmitted
    communityToJoin {
      ...baseCommunity
    }
  }
}
    ${BaseCommunityFragmentDoc}`;
export const useJoinCommunityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<JoinCommunityMutation, TError, JoinCommunityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<JoinCommunityMutation, TError, JoinCommunityMutationVariables, TContext>(
      ['JoinCommunity'],
      (variables?: JoinCommunityMutationVariables) => fetcher<JoinCommunityMutation, JoinCommunityMutationVariables>(client, JoinCommunityDocument, variables, headers)(),
      options
    );
export const MarkInviteFriendsLinkOpenedDocument = `
    mutation MarkInviteFriendsLinkOpened($inviteCode: String!, $communityCode: String, $source: String) {
  markInviteFriendsLinkOpened(
    inviteCode: $inviteCode
    communityCode: $communityCode
    source: $source
  ) {
    tracked
  }
}
    `;
export const useMarkInviteFriendsLinkOpenedMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MarkInviteFriendsLinkOpenedMutation, TError, MarkInviteFriendsLinkOpenedMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MarkInviteFriendsLinkOpenedMutation, TError, MarkInviteFriendsLinkOpenedMutationVariables, TContext>(
      ['MarkInviteFriendsLinkOpened'],
      (variables?: MarkInviteFriendsLinkOpenedMutationVariables) => fetcher<MarkInviteFriendsLinkOpenedMutation, MarkInviteFriendsLinkOpenedMutationVariables>(client, MarkInviteFriendsLinkOpenedDocument, variables, headers)(),
      options
    );
export const RequestPhoneVerificationDocument = `
    mutation RequestPhoneVerification($phone: String!, $whatsapp: Boolean) {
  requestPhoneVerification(phone: $phone, whatsapp: $whatsapp)
}
    `;
export const useRequestPhoneVerificationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RequestPhoneVerificationMutation, TError, RequestPhoneVerificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RequestPhoneVerificationMutation, TError, RequestPhoneVerificationMutationVariables, TContext>(
      ['RequestPhoneVerification'],
      (variables?: RequestPhoneVerificationMutationVariables) => fetcher<RequestPhoneVerificationMutation, RequestPhoneVerificationMutationVariables>(client, RequestPhoneVerificationDocument, variables, headers)(),
      options
    );
export const VerifyUserDocument = `
    mutation VerifyUser($phoneVerificationCode: String!) {
  verifyUser(phoneVerificationCode: $phoneVerificationCode) {
    token
    user {
      ...baseUser
    }
    errors {
      errorCode
      path
    }
  }
}
    ${BaseUserFragmentDoc}`;
export const useVerifyUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<VerifyUserMutation, TError, VerifyUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<VerifyUserMutation, TError, VerifyUserMutationVariables, TContext>(
      ['VerifyUser'],
      (variables?: VerifyUserMutationVariables) => fetcher<VerifyUserMutation, VerifyUserMutationVariables>(client, VerifyUserDocument, variables, headers)(),
      options
    );
export const RequestEmailVerificationDocument = `
    mutation requestEmailVerification($email: String!) {
  requestEmailVerification(email: $email)
}
    `;
export const useRequestEmailVerificationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RequestEmailVerificationMutation, TError, RequestEmailVerificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RequestEmailVerificationMutation, TError, RequestEmailVerificationMutationVariables, TContext>(
      ['requestEmailVerification'],
      (variables?: RequestEmailVerificationMutationVariables) => fetcher<RequestEmailVerificationMutation, RequestEmailVerificationMutationVariables>(client, RequestEmailVerificationDocument, variables, headers)(),
      options
    );
export const VerifyEmailDocument = `
    mutation verifyEmail($code: String!) {
  verifyEmail(emailVerificationCode: $code)
}
    `;
export const useVerifyEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<VerifyEmailMutation, TError, VerifyEmailMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<VerifyEmailMutation, TError, VerifyEmailMutationVariables, TContext>(
      ['verifyEmail'],
      (variables?: VerifyEmailMutationVariables) => fetcher<VerifyEmailMutation, VerifyEmailMutationVariables>(client, VerifyEmailDocument, variables, headers)(),
      options
    );
export const RequestEmailVerificationLinkDocument = `
    mutation RequestEmailVerificationLink {
  requestEmailVerificationLink
}
    `;
export const useRequestEmailVerificationLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RequestEmailVerificationLinkMutation, TError, RequestEmailVerificationLinkMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RequestEmailVerificationLinkMutation, TError, RequestEmailVerificationLinkMutationVariables, TContext>(
      ['RequestEmailVerificationLink'],
      (variables?: RequestEmailVerificationLinkMutationVariables) => fetcher<RequestEmailVerificationLinkMutation, RequestEmailVerificationLinkMutationVariables>(client, RequestEmailVerificationLinkDocument, variables, headers)(),
      options
    );
export const VerifyEmailTokenDocument = `
    mutation VerifyEmailToken($token: String!) {
  verifyEmailToken(token: $token)
}
    `;
export const useVerifyEmailTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<VerifyEmailTokenMutation, TError, VerifyEmailTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<VerifyEmailTokenMutation, TError, VerifyEmailTokenMutationVariables, TContext>(
      ['VerifyEmailToken'],
      (variables?: VerifyEmailTokenMutationVariables) => fetcher<VerifyEmailTokenMutation, VerifyEmailTokenMutationVariables>(client, VerifyEmailTokenDocument, variables, headers)(),
      options
    );
export const ResetPasswordDocument = `
    mutation ResetPassword($identifier: String!, $password: String!, $passwordResetCode: String!) {
  resetPassword(
    identifier: $identifier
    password: $password
    passwordResetCode: $passwordResetCode
  ) {
    errors {
      ... on TranslatableError {
        errorCode
        path
      }
    }
    token
    user {
      ...baseUser
    }
  }
}
    ${BaseUserFragmentDoc}`;
export const useResetPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>(
      ['ResetPassword'],
      (variables?: ResetPasswordMutationVariables) => fetcher<ResetPasswordMutation, ResetPasswordMutationVariables>(client, ResetPasswordDocument, variables, headers)(),
      options
    );
export const ResetPasswordRequestDocument = `
    mutation ResetPasswordRequest($identifier: String!) {
  resetPasswordRequest(identifier: $identifier) {
    errors {
      ... on TranslatableError {
        errorCode
        path
      }
    }
    requested
  }
}
    `;
export const useResetPasswordRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResetPasswordRequestMutation, TError, ResetPasswordRequestMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResetPasswordRequestMutation, TError, ResetPasswordRequestMutationVariables, TContext>(
      ['ResetPasswordRequest'],
      (variables?: ResetPasswordRequestMutationVariables) => fetcher<ResetPasswordRequestMutation, ResetPasswordRequestMutationVariables>(client, ResetPasswordRequestDocument, variables, headers)(),
      options
    );
export const ValidateResetPasswordCodeDocument = `
    mutation ValidateResetPasswordCode($passwordResetCode: String!) {
  validatePasswordResetCode(passwordResetCode: $passwordResetCode)
}
    `;
export const useValidateResetPasswordCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ValidateResetPasswordCodeMutation, TError, ValidateResetPasswordCodeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ValidateResetPasswordCodeMutation, TError, ValidateResetPasswordCodeMutationVariables, TContext>(
      ['ValidateResetPasswordCode'],
      (variables?: ValidateResetPasswordCodeMutationVariables) => fetcher<ValidateResetPasswordCodeMutation, ValidateResetPasswordCodeMutationVariables>(client, ValidateResetPasswordCodeDocument, variables, headers)(),
      options
    );
export const UserUpdateAuthDocument = `
    mutation UserUpdateAuth($email: String, $firstName: String, $lastName: String, $password: String, $sendEmailVerification: Boolean, $username: String, $birthday: String) {
  userUpdate(
    email: $email
    firstName: $firstName
    lastName: $lastName
    password: $password
    sendEmailVerification: $sendEmailVerification
    username: $username
    birthday: $birthday
  ) {
    id
    phone
  }
}
    `;
export const useUserUpdateAuthMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UserUpdateAuthMutation, TError, UserUpdateAuthMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UserUpdateAuthMutation, TError, UserUpdateAuthMutationVariables, TContext>(
      ['UserUpdateAuth'],
      (variables?: UserUpdateAuthMutationVariables) => fetcher<UserUpdateAuthMutation, UserUpdateAuthMutationVariables>(client, UserUpdateAuthDocument, variables, headers)(),
      options
    );
export const RequestSubscriptionPurchaseDocument = `
    mutation RequestSubscriptionPurchase($productId: String!, $fromWeb: Boolean, $postPaymentReturnUrl: String) {
  requestSubscriptionPurchase(
    productId: $productId
    fromWeb: $fromWeb
    postPaymentReturnUrl: $postPaymentReturnUrl
  ) {
    subscriptionId
    stripePaymentIntentClientSecret
    stripeSubscriptionId
    membershipId
  }
}
    `;
export const useRequestSubscriptionPurchaseMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RequestSubscriptionPurchaseMutation, TError, RequestSubscriptionPurchaseMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RequestSubscriptionPurchaseMutation, TError, RequestSubscriptionPurchaseMutationVariables, TContext>(
      ['RequestSubscriptionPurchase'],
      (variables?: RequestSubscriptionPurchaseMutationVariables) => fetcher<RequestSubscriptionPurchaseMutation, RequestSubscriptionPurchaseMutationVariables>(client, RequestSubscriptionPurchaseDocument, variables, headers)(),
      options
    );
export const GetSubscriptionProductDocument = `
    query GetSubscriptionProduct($productId: ID!) {
  product(productId: $productId) {
    id
    name
    description
    price
    currency
    displayPrice
    productType
    mediaUrl
    shortTerms
    postPurchaseInstructions
    community {
      id
      name
      currency
    }
  }
}
    `;
export const useGetSubscriptionProductQuery = <
      TData = GetSubscriptionProductQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetSubscriptionProductQueryVariables,
      options?: UseQueryOptions<GetSubscriptionProductQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetSubscriptionProductQuery, TError, TData>(
      ['GetSubscriptionProduct', variables],
      fetcher<GetSubscriptionProductQuery, GetSubscriptionProductQueryVariables>(client, GetSubscriptionProductDocument, variables, headers),
      options
    );
export const useInfiniteGetSubscriptionProductQuery = <
      TData = GetSubscriptionProductQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetSubscriptionProductQueryVariables,
      client: GraphQLClient,
      variables: GetSubscriptionProductQueryVariables,
      options?: UseInfiniteQueryOptions<GetSubscriptionProductQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<GetSubscriptionProductQuery, TError, TData>(
      ['GetSubscriptionProduct.infinite', variables],
      (metaData) => fetcher<GetSubscriptionProductQuery, GetSubscriptionProductQueryVariables>(client, GetSubscriptionProductDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const GetMembershipStatusDocument = `
    query GetMembershipStatus($membershipId: ID!) {
  membershipStatus(membershipId: $membershipId) {
    id
    status
    currentPeriodEnd
    stripeSubscriptionId
    product {
      id
      name
      price
      community {
        name
        currency
      }
    }
  }
}
    `;
export const useGetMembershipStatusQuery = <
      TData = GetMembershipStatusQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetMembershipStatusQueryVariables,
      options?: UseQueryOptions<GetMembershipStatusQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetMembershipStatusQuery, TError, TData>(
      ['GetMembershipStatus', variables],
      fetcher<GetMembershipStatusQuery, GetMembershipStatusQueryVariables>(client, GetMembershipStatusDocument, variables, headers),
      options
    );
export const useInfiniteGetMembershipStatusQuery = <
      TData = GetMembershipStatusQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetMembershipStatusQueryVariables,
      client: GraphQLClient,
      variables: GetMembershipStatusQueryVariables,
      options?: UseInfiniteQueryOptions<GetMembershipStatusQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<GetMembershipStatusQuery, TError, TData>(
      ['GetMembershipStatus.infinite', variables],
      (metaData) => fetcher<GetMembershipStatusQuery, GetMembershipStatusQueryVariables>(client, GetMembershipStatusDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const CreateStripeCustomerPortalDocument = `
    mutation CreateStripeCustomerPortal($membershipId: ID!) {
  createStripeCustomerPortal(membershipId: $membershipId) {
    url
  }
}
    `;
export const useCreateStripeCustomerPortalMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateStripeCustomerPortalMutation, TError, CreateStripeCustomerPortalMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateStripeCustomerPortalMutation, TError, CreateStripeCustomerPortalMutationVariables, TContext>(
      ['CreateStripeCustomerPortal'],
      (variables?: CreateStripeCustomerPortalMutationVariables) => fetcher<CreateStripeCustomerPortalMutation, CreateStripeCustomerPortalMutationVariables>(client, CreateStripeCustomerPortalDocument, variables, headers)(),
      options
    );
export const CalculateDiscountAndFeesDocument = `
    mutation CalculateDiscountAndFees($cart: [RequestProductsPurchaseInput!]!, $paymentMethod: PurchasePaymentMethod, $promocodeId: String, $shippingCountry: String, $printfulShippingFee: Float) {
  calculateDiscountAndFees(
    paymentMethod: $paymentMethod
    cart: $cart
    promocodeId: $promocodeId
    shippingCountry: $shippingCountry
    printfulShippingFee: $printfulShippingFee
  ) {
    discount
    fees
    deliveryFees
    vat
    invalidProductIds
    checkoutMode
    paymentMethods
  }
}
    `;
export const useCalculateDiscountAndFeesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CalculateDiscountAndFeesMutation, TError, CalculateDiscountAndFeesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CalculateDiscountAndFeesMutation, TError, CalculateDiscountAndFeesMutationVariables, TContext>(
      ['CalculateDiscountAndFees'],
      (variables?: CalculateDiscountAndFeesMutationVariables) => fetcher<CalculateDiscountAndFeesMutation, CalculateDiscountAndFeesMutationVariables>(client, CalculateDiscountAndFeesDocument, variables, headers)(),
      options
    );
export const RequestProductsPurchaseDocument = `
    mutation RequestProductsPurchase($arrivedViaSlugs: [String!], $paymentMethod: PurchasePaymentMethod!, $cart: [RequestProductsPurchaseInput!]!, $promocodeId: String, $fromWeb: Boolean, $postPaymentReturnUrl: String, $additionalInfo: Json, $joinRequirementsResponses: Json, $checkoutRequirementsResponses: Json, $stripePaymentMethodId: String, $idempotencyKey: String, $printfulShippingMethod: String, $printfulShippingRate: Float) {
  requestProductsPurchase(
    arrivedViaSlugs: $arrivedViaSlugs
    paymentMethod: $paymentMethod
    cart: $cart
    promocodeId: $promocodeId
    fromWeb: $fromWeb
    postPaymentReturnUrl: $postPaymentReturnUrl
    additionalInfo: $additionalInfo
    joinRequirementsResponses: $joinRequirementsResponses
    checkoutRequirementsResponses: $checkoutRequirementsResponses
    stripePaymentMethodId: $stripePaymentMethodId
    idempotencyKey: $idempotencyKey
    printfulShippingMethod: $printfulShippingMethod
    printfulShippingRate: $printfulShippingRate
  ) {
    orderId
    purchaseIds
    swishCheckoutDeepLink
    stripePaymentIntentClientSecret
    stripeRedirectUrl
    stripeSwishQRUrl
    kustomCheckoutHtmlSnippet
    kustomCheckoutOrderId
  }
}
    `;
export const useRequestProductsPurchaseMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RequestProductsPurchaseMutation, TError, RequestProductsPurchaseMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RequestProductsPurchaseMutation, TError, RequestProductsPurchaseMutationVariables, TContext>(
      ['RequestProductsPurchase'],
      (variables?: RequestProductsPurchaseMutationVariables) => fetcher<RequestProductsPurchaseMutation, RequestProductsPurchaseMutationVariables>(client, RequestProductsPurchaseDocument, variables, headers)(),
      options
    );
export const ShopPurchasesDocument = `
    query ShopPurchases($purchaseIds: [String!]!) {
  shopPurchases(where: {id: {in: $purchaseIds}}) {
    id
    status
    statusMessage
    deliveryMethod
    competitionInfo
    product {
      name
      additionalConfig
    }
  }
}
    `;
export const useShopPurchasesQuery = <
      TData = ShopPurchasesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ShopPurchasesQueryVariables,
      options?: UseQueryOptions<ShopPurchasesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ShopPurchasesQuery, TError, TData>(
      ['ShopPurchases', variables],
      fetcher<ShopPurchasesQuery, ShopPurchasesQueryVariables>(client, ShopPurchasesDocument, variables, headers),
      options
    );
export const useInfiniteShopPurchasesQuery = <
      TData = ShopPurchasesQuery,
      TError = unknown
    >(
      pageParamKey: keyof ShopPurchasesQueryVariables,
      client: GraphQLClient,
      variables: ShopPurchasesQueryVariables,
      options?: UseInfiniteQueryOptions<ShopPurchasesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ShopPurchasesQuery, TError, TData>(
      ['ShopPurchases.infinite', variables],
      (metaData) => fetcher<ShopPurchasesQuery, ShopPurchasesQueryVariables>(client, ShopPurchasesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const CheckoutPostReturnDocument = `
    query CheckoutPostReturn($purchaseIds: [ID!]!) {
  checkoutPostReturn(purchaseIds: $purchaseIds) {
    purchases {
      additionalInfo
      deliveryMethod
      price
      product {
        ...baseProduct
      }
      status
      statusMessage
    }
    currency
    discount
    fees
    status
    vat
    byEmail
    digitalItems {
      ticketUuid
      productName
      label
    }
  }
}
    ${BaseProductFragmentDoc}`;
export const useCheckoutPostReturnQuery = <
      TData = CheckoutPostReturnQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CheckoutPostReturnQueryVariables,
      options?: UseQueryOptions<CheckoutPostReturnQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CheckoutPostReturnQuery, TError, TData>(
      ['CheckoutPostReturn', variables],
      fetcher<CheckoutPostReturnQuery, CheckoutPostReturnQueryVariables>(client, CheckoutPostReturnDocument, variables, headers),
      options
    );
export const useInfiniteCheckoutPostReturnQuery = <
      TData = CheckoutPostReturnQuery,
      TError = unknown
    >(
      pageParamKey: keyof CheckoutPostReturnQueryVariables,
      client: GraphQLClient,
      variables: CheckoutPostReturnQueryVariables,
      options?: UseInfiniteQueryOptions<CheckoutPostReturnQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CheckoutPostReturnQuery, TError, TData>(
      ['CheckoutPostReturn.infinite', variables],
      (metaData) => fetcher<CheckoutPostReturnQuery, CheckoutPostReturnQueryVariables>(client, CheckoutPostReturnDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const ValidatePromocodeDocument = `
    mutation validatePromocode($parentCommunityId: String!, $parentCommunityCode: String, $promocode: String!, $productIds: [String!]!) {
  validatePromocode(
    parentCommunityId: $parentCommunityId
    parentCommunityCode: $parentCommunityCode
    promocode: $promocode
    productIds: $productIds
  ) {
    id
    name
  }
}
    `;
export const useValidatePromocodeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ValidatePromocodeMutation, TError, ValidatePromocodeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ValidatePromocodeMutation, TError, ValidatePromocodeMutationVariables, TContext>(
      ['validatePromocode'],
      (variables?: ValidatePromocodeMutationVariables) => fetcher<ValidatePromocodeMutation, ValidatePromocodeMutationVariables>(client, ValidatePromocodeDocument, variables, headers)(),
      options
    );
export const CreateOrUpdateKustomOrderDocument = `
    mutation CreateOrUpdateKustomOrder($arrivedViaSlugs: [String!], $cart: [RequestProductsPurchaseInput!]!, $communityCode: String!, $orderId: String, $promocodeId: String, $additionalInfo: Json, $checkoutRequirementsResponses: Json, $idempotencyKey: String, $printfulShippingMethod: String, $printfulShippingRate: Float) {
  createOrUpdateKustomOrder(
    arrivedViaSlugs: $arrivedViaSlugs
    cart: $cart
    communityCode: $communityCode
    orderId: $orderId
    promocodeId: $promocodeId
    additionalInfo: $additionalInfo
    checkoutRequirementsResponses: $checkoutRequirementsResponses
    idempotencyKey: $idempotencyKey
    printfulShippingMethod: $printfulShippingMethod
    printfulShippingRate: $printfulShippingRate
  ) {
    htmlSnippet
    orderId
    purchaseIds
    werzOrderId
  }
}
    `;
export const useCreateOrUpdateKustomOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateOrUpdateKustomOrderMutation, TError, CreateOrUpdateKustomOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateOrUpdateKustomOrderMutation, TError, CreateOrUpdateKustomOrderMutationVariables, TContext>(
      ['CreateOrUpdateKustomOrder'],
      (variables?: CreateOrUpdateKustomOrderMutationVariables) => fetcher<CreateOrUpdateKustomOrderMutation, CreateOrUpdateKustomOrderMutationVariables>(client, CreateOrUpdateKustomOrderDocument, variables, headers)(),
      options
    );
export const GetPrintfulShippingRatesDocument = `
    mutation GetPrintfulShippingRates($cart: [RequestProductsPurchaseInput!]!, $shippingAddress: PrintfulShippingAddressInput!) {
  getPrintfulShippingRates(cart: $cart, shippingAddress: $shippingAddress) {
    selectedShippingMethod
    rates {
      currency
      customsFeesPossible
      maxDeliveryDate
      maxDeliveryDays
      minDeliveryDate
      minDeliveryDays
      rate
      shipping
      shippingMethodName
    }
  }
}
    `;
export const useGetPrintfulShippingRatesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GetPrintfulShippingRatesMutation, TError, GetPrintfulShippingRatesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GetPrintfulShippingRatesMutation, TError, GetPrintfulShippingRatesMutationVariables, TContext>(
      ['GetPrintfulShippingRates'],
      (variables?: GetPrintfulShippingRatesMutationVariables) => fetcher<GetPrintfulShippingRatesMutation, GetPrintfulShippingRatesMutationVariables>(client, GetPrintfulShippingRatesDocument, variables, headers)(),
      options
    );
export const ConfirmKustomOrderDocument = `
    mutation ConfirmKustomOrder($orderId: String!) {
  confirmKustomOrder(orderId: $orderId) {
    success
    purchases {
      additionalInfo
      deliveryMethod
      id
      amount
      discount
      fee
      price
      status
      statusMessage
      product {
        ...baseProduct
      }
    }
    discount
    fees
    vat
    currency
    byEmail
    digitalItems {
      ticketUuid
      productName
      label
    }
  }
}
    ${BaseProductFragmentDoc}`;
export const useConfirmKustomOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ConfirmKustomOrderMutation, TError, ConfirmKustomOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ConfirmKustomOrderMutation, TError, ConfirmKustomOrderMutationVariables, TContext>(
      ['ConfirmKustomOrder'],
      (variables?: ConfirmKustomOrderMutationVariables) => fetcher<ConfirmKustomOrderMutation, ConfirmKustomOrderMutationVariables>(client, ConfirmKustomOrderDocument, variables, headers)(),
      options
    );
export const CommunityLandingDocument = `
    query CommunityLanding($communityCode: String!) {
  communityLanding(communityCode: $communityCode) {
    community {
      id
      name
      code
      iconUrl
      location
      radioModule
      description
      currency
      availablePaymentMethods
      preselectedPaymentMethod
      configs
      stripeConnectedAccountId
      requestToJoin
      joinRequirements
      socialLinks {
        url
        platform
      }
    }
    upcomingEvents {
      id
      webLink
      end
      name
      start
      locationDisplayCompact
      mediaUrl
      buyTicketsLink
      products {
        id
        end
        name
        price
        start
        status
      }
    }
    latestNews {
      id
      name
      mediaUrl
      createdAt
    }
    radioTracks {
      id
      end
      type
      title
      start
      duration
      coverUrl
    }
    otherLinks {
      url
      text
      icon
    }
  }
}
    `;
export const useCommunityLandingQuery = <
      TData = CommunityLandingQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CommunityLandingQueryVariables,
      options?: UseQueryOptions<CommunityLandingQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CommunityLandingQuery, TError, TData>(
      ['CommunityLanding', variables],
      fetcher<CommunityLandingQuery, CommunityLandingQueryVariables>(client, CommunityLandingDocument, variables, headers),
      options
    );
export const useInfiniteCommunityLandingQuery = <
      TData = CommunityLandingQuery,
      TError = unknown
    >(
      pageParamKey: keyof CommunityLandingQueryVariables,
      client: GraphQLClient,
      variables: CommunityLandingQueryVariables,
      options?: UseInfiniteQueryOptions<CommunityLandingQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CommunityLandingQuery, TError, TData>(
      ['CommunityLanding.infinite', variables],
      (metaData) => fetcher<CommunityLandingQuery, CommunityLandingQueryVariables>(client, CommunityLandingDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const CommunityContentDocument = `
    query CommunityContent($communityId: ID!) {
  announcements(communityId: $communityId) {
    items {
      ...baseFeedItem
    }
  }
  eventsV2(communityId: $communityId) {
    items {
      ...eventListItem
    }
  }
}
    ${BaseFeedItemFragmentDoc}
${EventListItemFragmentDoc}`;
export const useCommunityContentQuery = <
      TData = CommunityContentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CommunityContentQueryVariables,
      options?: UseQueryOptions<CommunityContentQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CommunityContentQuery, TError, TData>(
      ['CommunityContent', variables],
      fetcher<CommunityContentQuery, CommunityContentQueryVariables>(client, CommunityContentDocument, variables, headers),
      options
    );
export const useInfiniteCommunityContentQuery = <
      TData = CommunityContentQuery,
      TError = unknown
    >(
      pageParamKey: keyof CommunityContentQueryVariables,
      client: GraphQLClient,
      variables: CommunityContentQueryVariables,
      options?: UseInfiniteQueryOptions<CommunityContentQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CommunityContentQuery, TError, TData>(
      ['CommunityContent.infinite', variables],
      (metaData) => fetcher<CommunityContentQuery, CommunityContentQueryVariables>(client, CommunityContentDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const CompetitionTicketDocument = `
    query CompetitionTicket($ticketUuid: String) {
  competitionTicket(ticketUuid: $ticketUuid) {
    ticketUuid
    state
    isWinner
    question
    options
    communityCode
    productSlug
    charityName
    charityUrl
    donationPool
    productName
    productImage
  }
}
    `;
export const useCompetitionTicketQuery = <
      TData = CompetitionTicketQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CompetitionTicketQueryVariables,
      options?: UseQueryOptions<CompetitionTicketQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CompetitionTicketQuery, TError, TData>(
      variables === undefined ? ['CompetitionTicket'] : ['CompetitionTicket', variables],
      fetcher<CompetitionTicketQuery, CompetitionTicketQueryVariables>(client, CompetitionTicketDocument, variables, headers),
      options
    );
export const useInfiniteCompetitionTicketQuery = <
      TData = CompetitionTicketQuery,
      TError = unknown
    >(
      pageParamKey: keyof CompetitionTicketQueryVariables,
      client: GraphQLClient,
      variables?: CompetitionTicketQueryVariables,
      options?: UseInfiniteQueryOptions<CompetitionTicketQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CompetitionTicketQuery, TError, TData>(
      variables === undefined ? ['CompetitionTicket.infinite'] : ['CompetitionTicket.infinite', variables],
      (metaData) => fetcher<CompetitionTicketQuery, CompetitionTicketQueryVariables>(client, CompetitionTicketDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const CompetitionLandingDocument = `
    query CompetitionLanding($communityCode: String) {
  competitionTicket(communityCode: $communityCode) {
    donationPool
    charityName
    charityUrl
    donateProductSlug
    productSlug
    communityCode
  }
}
    `;
export const useCompetitionLandingQuery = <
      TData = CompetitionLandingQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CompetitionLandingQueryVariables,
      options?: UseQueryOptions<CompetitionLandingQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CompetitionLandingQuery, TError, TData>(
      variables === undefined ? ['CompetitionLanding'] : ['CompetitionLanding', variables],
      fetcher<CompetitionLandingQuery, CompetitionLandingQueryVariables>(client, CompetitionLandingDocument, variables, headers),
      options
    );
export const useInfiniteCompetitionLandingQuery = <
      TData = CompetitionLandingQuery,
      TError = unknown
    >(
      pageParamKey: keyof CompetitionLandingQueryVariables,
      client: GraphQLClient,
      variables?: CompetitionLandingQueryVariables,
      options?: UseInfiniteQueryOptions<CompetitionLandingQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<CompetitionLandingQuery, TError, TData>(
      variables === undefined ? ['CompetitionLanding.infinite'] : ['CompetitionLanding.infinite', variables],
      (metaData) => fetcher<CompetitionLandingQuery, CompetitionLandingQueryVariables>(client, CompetitionLandingDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const UpdateCompetitionTicketDocument = `
    mutation UpdateCompetitionTicket($ticketUuid: String!, $answerIndex: Int, $reveal: Boolean) {
  updateCompetitionTicket(
    ticketUuid: $ticketUuid
    answerIndex: $answerIndex
    reveal: $reveal
  ) {
    correct
    isWinner
    state
  }
}
    `;
export const useUpdateCompetitionTicketMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCompetitionTicketMutation, TError, UpdateCompetitionTicketMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCompetitionTicketMutation, TError, UpdateCompetitionTicketMutationVariables, TContext>(
      ['UpdateCompetitionTicket'],
      (variables?: UpdateCompetitionTicketMutationVariables) => fetcher<UpdateCompetitionTicketMutation, UpdateCompetitionTicketMutationVariables>(client, UpdateCompetitionTicketDocument, variables, headers)(),
      options
    );
export const ContentPreviewDocument = `
    query ContentPreview($landingCode: String!, $type: String!, $itemId: String!) {
  contentPreview(landingCode: $landingCode, type: $type, itemId: $itemId) {
    id
    type
    title
    subtitle
    image
    community {
      name
      iconUrl
    }
  }
}
    `;
export const useContentPreviewQuery = <
      TData = ContentPreviewQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ContentPreviewQueryVariables,
      options?: UseQueryOptions<ContentPreviewQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ContentPreviewQuery, TError, TData>(
      ['ContentPreview', variables],
      fetcher<ContentPreviewQuery, ContentPreviewQueryVariables>(client, ContentPreviewDocument, variables, headers),
      options
    );
export const useInfiniteContentPreviewQuery = <
      TData = ContentPreviewQuery,
      TError = unknown
    >(
      pageParamKey: keyof ContentPreviewQueryVariables,
      client: GraphQLClient,
      variables: ContentPreviewQueryVariables,
      options?: UseInfiniteQueryOptions<ContentPreviewQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ContentPreviewQuery, TError, TData>(
      ['ContentPreview.infinite', variables],
      (metaData) => fetcher<ContentPreviewQuery, ContentPreviewQueryVariables>(client, ContentPreviewDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const CreateDeferredLinkDocument = `
    mutation CreateDeferredLink($inviteUrl: String!, $communityCode: String!, $inviteCode: String!, $screenWidth: Int!, $timezone: String!, $locale: String!) {
  createDeferredLink(
    inviteUrl: $inviteUrl
    communityCode: $communityCode
    inviteCode: $inviteCode
    screenWidth: $screenWidth
    timezone: $timezone
    locale: $locale
  )
}
    `;
export const useCreateDeferredLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateDeferredLinkMutation, TError, CreateDeferredLinkMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateDeferredLinkMutation, TError, CreateDeferredLinkMutationVariables, TContext>(
      ['CreateDeferredLink'],
      (variables?: CreateDeferredLinkMutationVariables) => fetcher<CreateDeferredLinkMutation, CreateDeferredLinkMutationVariables>(client, CreateDeferredLinkDocument, variables, headers)(),
      options
    );
export const DetectCountryDocument = `
    query DetectCountry {
  detectCountry
}
    `;
export const useDetectCountryQuery = <
      TData = DetectCountryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: DetectCountryQueryVariables,
      options?: UseQueryOptions<DetectCountryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<DetectCountryQuery, TError, TData>(
      variables === undefined ? ['DetectCountry'] : ['DetectCountry', variables],
      fetcher<DetectCountryQuery, DetectCountryQueryVariables>(client, DetectCountryDocument, variables, headers),
      options
    );
export const useInfiniteDetectCountryQuery = <
      TData = DetectCountryQuery,
      TError = unknown
    >(
      pageParamKey: keyof DetectCountryQueryVariables,
      client: GraphQLClient,
      variables?: DetectCountryQueryVariables,
      options?: UseInfiniteQueryOptions<DetectCountryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<DetectCountryQuery, TError, TData>(
      variables === undefined ? ['DetectCountry.infinite'] : ['DetectCountry.infinite', variables],
      (metaData) => fetcher<DetectCountryQuery, DetectCountryQueryVariables>(client, DetectCountryDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const EventsDocument = `
    query Events($communityId: ID!, $futureOnly: Boolean!, $skip: Int!, $take: Int!) {
  eventsV2(
    communityId: $communityId
    futureOnly: $futureOnly
    skip: $skip
    take: $take
  ) {
    next
    total
    items {
      ...eventListItem
    }
  }
}
    ${EventListItemFragmentDoc}`;
export const useEventsQuery = <
      TData = EventsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: EventsQueryVariables,
      options?: UseQueryOptions<EventsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<EventsQuery, TError, TData>(
      ['Events', variables],
      fetcher<EventsQuery, EventsQueryVariables>(client, EventsDocument, variables, headers),
      options
    );
export const useInfiniteEventsQuery = <
      TData = EventsQuery,
      TError = unknown
    >(
      pageParamKey: keyof EventsQueryVariables,
      client: GraphQLClient,
      variables: EventsQueryVariables,
      options?: UseInfiniteQueryOptions<EventsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<EventsQuery, TError, TData>(
      ['Events.infinite', variables],
      (metaData) => fetcher<EventsQuery, EventsQueryVariables>(client, EventsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const EventDocument = `
    query Event($communityId: ID!, $eventId: ID!) {
  eventV2(communityId: $communityId, eventId: $eventId) {
    arrivedViaSlug
    ...eventDetail
  }
}
    ${EventDetailFragmentDoc}`;
export const useEventQuery = <
      TData = EventQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: EventQueryVariables,
      options?: UseQueryOptions<EventQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<EventQuery, TError, TData>(
      ['Event', variables],
      fetcher<EventQuery, EventQueryVariables>(client, EventDocument, variables, headers),
      options
    );
export const useInfiniteEventQuery = <
      TData = EventQuery,
      TError = unknown
    >(
      pageParamKey: keyof EventQueryVariables,
      client: GraphQLClient,
      variables: EventQueryVariables,
      options?: UseInfiniteQueryOptions<EventQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<EventQuery, TError, TData>(
      ['Event.infinite', variables],
      (metaData) => fetcher<EventQuery, EventQueryVariables>(client, EventDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const EventWithTicketsDocument = `
    query EventWithTickets($eventId: ID!, $communityId: ID, $accessCode: String) {
  eventWithTickets(
    eventId: $eventId
    communityId: $communityId
    accessCode: $accessCode
  ) {
    eventInfo {
      id
      name
      start
      end
      locationDisplayCompact
      locationDisplayFull
      description
      mediaUrl
    }
    products {
      ...baseProduct
    }
    requestBundleProducts {
      ...baseProduct
    }
    showGotCode
  }
}
    ${BaseProductFragmentDoc}`;
export const useEventWithTicketsQuery = <
      TData = EventWithTicketsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: EventWithTicketsQueryVariables,
      options?: UseQueryOptions<EventWithTicketsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<EventWithTicketsQuery, TError, TData>(
      ['EventWithTickets', variables],
      fetcher<EventWithTicketsQuery, EventWithTicketsQueryVariables>(client, EventWithTicketsDocument, variables, headers),
      options
    );
export const useInfiniteEventWithTicketsQuery = <
      TData = EventWithTicketsQuery,
      TError = unknown
    >(
      pageParamKey: keyof EventWithTicketsQueryVariables,
      client: GraphQLClient,
      variables: EventWithTicketsQueryVariables,
      options?: UseInfiniteQueryOptions<EventWithTicketsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<EventWithTicketsQuery, TError, TData>(
      ['EventWithTickets.infinite', variables],
      (metaData) => fetcher<EventWithTicketsQuery, EventWithTicketsQueryVariables>(client, EventWithTicketsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const TrackEventSlugVisitDocument = `
    mutation TrackEventSlugVisit($slug: String!, $visitorId: String) {
  trackEventSlugVisit(slug: $slug, visitorId: $visitorId)
}
    `;
export const useTrackEventSlugVisitMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TrackEventSlugVisitMutation, TError, TrackEventSlugVisitMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TrackEventSlugVisitMutation, TError, TrackEventSlugVisitMutationVariables, TContext>(
      ['TrackEventSlugVisit'],
      (variables?: TrackEventSlugVisitMutationVariables) => fetcher<TrackEventSlugVisitMutation, TrackEventSlugVisitMutationVariables>(client, TrackEventSlugVisitDocument, variables, headers)(),
      options
    );
export const SaveFormResponseDocument = `
    mutation SaveFormResponse($source: String!, $firstName: String, $lastName: String, $email: String, $phone: String, $data: Json) {
  saveFormResponse(
    source: $source
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    data: $data
  )
}
    `;
export const useSaveFormResponseMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SaveFormResponseMutation, TError, SaveFormResponseMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SaveFormResponseMutation, TError, SaveFormResponseMutationVariables, TContext>(
      ['SaveFormResponse'],
      (variables?: SaveFormResponseMutationVariables) => fetcher<SaveFormResponseMutation, SaveFormResponseMutationVariables>(client, SaveFormResponseDocument, variables, headers)(),
      options
    );
export const ForumPostsDocument = `
    query ForumPosts($communityId: ID!, $filterTagId: ID, $skip: Int!, $take: Int!) {
  forumPosts(
    communityId: $communityId
    filterTagId: $filterTagId
    skip: $skip
    take: $take
  ) {
    next
    total
    allTags {
      id
      name
    }
    posts {
      ...baseForumPost
    }
  }
}
    ${BaseForumPostFragmentDoc}`;
export const useForumPostsQuery = <
      TData = ForumPostsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ForumPostsQueryVariables,
      options?: UseQueryOptions<ForumPostsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ForumPostsQuery, TError, TData>(
      ['ForumPosts', variables],
      fetcher<ForumPostsQuery, ForumPostsQueryVariables>(client, ForumPostsDocument, variables, headers),
      options
    );
export const useInfiniteForumPostsQuery = <
      TData = ForumPostsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForumPostsQueryVariables,
      client: GraphQLClient,
      variables: ForumPostsQueryVariables,
      options?: UseInfiniteQueryOptions<ForumPostsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ForumPostsQuery, TError, TData>(
      ['ForumPosts.infinite', variables],
      (metaData) => fetcher<ForumPostsQuery, ForumPostsQueryVariables>(client, ForumPostsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const ForumPostDocument = `
    query ForumPost($communityId: ID, $postId: ID!) {
  forumPost(communityId: $communityId, postId: $postId) {
    ...baseForumPost
  }
}
    ${BaseForumPostFragmentDoc}`;
export const useForumPostQuery = <
      TData = ForumPostQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ForumPostQueryVariables,
      options?: UseQueryOptions<ForumPostQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ForumPostQuery, TError, TData>(
      ['ForumPost', variables],
      fetcher<ForumPostQuery, ForumPostQueryVariables>(client, ForumPostDocument, variables, headers),
      options
    );
export const useInfiniteForumPostQuery = <
      TData = ForumPostQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForumPostQueryVariables,
      client: GraphQLClient,
      variables: ForumPostQueryVariables,
      options?: UseInfiniteQueryOptions<ForumPostQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ForumPostQuery, TError, TData>(
      ['ForumPost.infinite', variables],
      (metaData) => fetcher<ForumPostQuery, ForumPostQueryVariables>(client, ForumPostDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const ForumPostCommentsDocument = `
    query ForumPostComments($postId: ID!, $skip: Int!, $take: Int!) {
  forumPostComments(postId: $postId, skip: $skip, take: $take) {
    total
    next
    comments {
      ...baseComment
      replies {
        ...baseComment
      }
    }
  }
}
    ${BaseCommentFragmentDoc}`;
export const useForumPostCommentsQuery = <
      TData = ForumPostCommentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ForumPostCommentsQueryVariables,
      options?: UseQueryOptions<ForumPostCommentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ForumPostCommentsQuery, TError, TData>(
      ['ForumPostComments', variables],
      fetcher<ForumPostCommentsQuery, ForumPostCommentsQueryVariables>(client, ForumPostCommentsDocument, variables, headers),
      options
    );
export const useInfiniteForumPostCommentsQuery = <
      TData = ForumPostCommentsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForumPostCommentsQueryVariables,
      client: GraphQLClient,
      variables: ForumPostCommentsQueryVariables,
      options?: UseInfiniteQueryOptions<ForumPostCommentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ForumPostCommentsQuery, TError, TData>(
      ['ForumPostComments.infinite', variables],
      (metaData) => fetcher<ForumPostCommentsQuery, ForumPostCommentsQueryVariables>(client, ForumPostCommentsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const SubmitForumPostDocument = `
    mutation SubmitForumPost($communityId: ID!, $tags: [String!], $headline: String, $content: String!, $media: [String!]) {
  submitForumPost(
    communityId: $communityId
    headline: $headline
    content: $content
    media: $media
    tags: $tags
  ) {
    id
  }
}
    `;
export const useSubmitForumPostMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SubmitForumPostMutation, TError, SubmitForumPostMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SubmitForumPostMutation, TError, SubmitForumPostMutationVariables, TContext>(
      ['SubmitForumPost'],
      (variables?: SubmitForumPostMutationVariables) => fetcher<SubmitForumPostMutation, SubmitForumPostMutationVariables>(client, SubmitForumPostDocument, variables, headers)(),
      options
    );
export const ReactForumPostDocument = `
    mutation ReactForumPost($forumPostId: ID!) {
  reactForumPost(forumPostId: $forumPostId)
}
    `;
export const useReactForumPostMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReactForumPostMutation, TError, ReactForumPostMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReactForumPostMutation, TError, ReactForumPostMutationVariables, TContext>(
      ['ReactForumPost'],
      (variables?: ReactForumPostMutationVariables) => fetcher<ReactForumPostMutation, ReactForumPostMutationVariables>(client, ReactForumPostDocument, variables, headers)(),
      options
    );
export const ReactForumCommentDocument = `
    mutation ReactForumComment($forumCommentId: ID!) {
  reactForumComment(forumCommentId: $forumCommentId)
}
    `;
export const useReactForumCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReactForumCommentMutation, TError, ReactForumCommentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReactForumCommentMutation, TError, ReactForumCommentMutationVariables, TContext>(
      ['ReactForumComment'],
      (variables?: ReactForumCommentMutationVariables) => fetcher<ReactForumCommentMutation, ReactForumCommentMutationVariables>(client, ReactForumCommentDocument, variables, headers)(),
      options
    );
export const DeleteForumContentDocument = `
    mutation DeleteForumContent($postId: ID, $commentId: ID) {
  deleteForumContent(postId: $postId, commentId: $commentId)
}
    `;
export const useDeleteForumContentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteForumContentMutation, TError, DeleteForumContentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteForumContentMutation, TError, DeleteForumContentMutationVariables, TContext>(
      ['DeleteForumContent'],
      (variables?: DeleteForumContentMutationVariables) => fetcher<DeleteForumContentMutation, DeleteForumContentMutationVariables>(client, DeleteForumContentDocument, variables, headers)(),
      options
    );
export const ReportForumContentDocument = `
    mutation ReportForumContent($postId: ID, $commentId: ID, $reason: String!) {
  reportForumContent(postId: $postId, commentId: $commentId, reason: $reason) {
    id
  }
}
    `;
export const useReportForumContentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReportForumContentMutation, TError, ReportForumContentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReportForumContentMutation, TError, ReportForumContentMutationVariables, TContext>(
      ['ReportForumContent'],
      (variables?: ReportForumContentMutationVariables) => fetcher<ReportForumContentMutation, ReportForumContentMutationVariables>(client, ReportForumContentDocument, variables, headers)(),
      options
    );
export const CommentForumPostDocument = `
    mutation CommentForumPost($postId: ID!, $commentId: ID, $content: String!, $media: [String!]) {
  commentForumPost(
    postId: $postId
    commentId: $commentId
    content: $content
    media: $media
  ) {
    id
  }
}
    `;
export const useCommentForumPostMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CommentForumPostMutation, TError, CommentForumPostMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CommentForumPostMutation, TError, CommentForumPostMutationVariables, TContext>(
      ['CommentForumPost'],
      (variables?: CommentForumPostMutationVariables) => fetcher<CommentForumPostMutation, CommentForumPostMutationVariables>(client, CommentForumPostDocument, variables, headers)(),
      options
    );
export const StartGameRunDocument = `
    mutation startGameRun($game: String!, $player: String!) {
  startGameRun(game: $game, player: $player)
}
    `;
export const useStartGameRunMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<StartGameRunMutation, TError, StartGameRunMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<StartGameRunMutation, TError, StartGameRunMutationVariables, TContext>(
      ['startGameRun'],
      (variables?: StartGameRunMutationVariables) => fetcher<StartGameRunMutation, StartGameRunMutationVariables>(client, StartGameRunDocument, variables, headers)(),
      options
    );
export const FinishGameRunDocument = `
    mutation finishGameRun($runId: ID!, $score: Int!, $playSeconds: Float!) {
  finishGameRun(runId: $runId, score: $score, playSeconds: $playSeconds)
}
    `;
export const useFinishGameRunMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FinishGameRunMutation, TError, FinishGameRunMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<FinishGameRunMutation, TError, FinishGameRunMutationVariables, TContext>(
      ['finishGameRun'],
      (variables?: FinishGameRunMutationVariables) => fetcher<FinishGameRunMutation, FinishGameRunMutationVariables>(client, FinishGameRunDocument, variables, headers)(),
      options
    );
export const TopGameScoresDocument = `
    query topGameScores($game: String, $userId: String) {
  topGameScores(game: $game, userId: $userId) {
    displayName
    id
    isCurrentPlayer
    score
  }
}
    `;
export const useTopGameScoresQuery = <
      TData = TopGameScoresQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: TopGameScoresQueryVariables,
      options?: UseQueryOptions<TopGameScoresQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TopGameScoresQuery, TError, TData>(
      variables === undefined ? ['topGameScores'] : ['topGameScores', variables],
      fetcher<TopGameScoresQuery, TopGameScoresQueryVariables>(client, TopGameScoresDocument, variables, headers),
      options
    );
export const useInfiniteTopGameScoresQuery = <
      TData = TopGameScoresQuery,
      TError = unknown
    >(
      pageParamKey: keyof TopGameScoresQueryVariables,
      client: GraphQLClient,
      variables?: TopGameScoresQueryVariables,
      options?: UseInfiniteQueryOptions<TopGameScoresQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<TopGameScoresQuery, TError, TData>(
      variables === undefined ? ['topGameScores.infinite'] : ['topGameScores.infinite', variables],
      (metaData) => fetcher<TopGameScoresQuery, TopGameScoresQueryVariables>(client, TopGameScoresDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const ClaimCardDocument = `
    mutation claimCard($userId: String!, $communityCode: String!) {
  claimCard(userId: $userId, communityCode: $communityCode)
}
    `;
export const useClaimCardMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ClaimCardMutation, TError, ClaimCardMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ClaimCardMutation, TError, ClaimCardMutationVariables, TContext>(
      ['claimCard'],
      (variables?: ClaimCardMutationVariables) => fetcher<ClaimCardMutation, ClaimCardMutationVariables>(client, ClaimCardDocument, variables, headers)(),
      options
    );
export const GuestListInviteDocument = `
    query GuestListInvite($code: String!) {
  guestListInvite(code: $code) {
    code
    status
    fullName
    note
    numPlus
    claimerId
    productName
    plusGuests {
      name
      phone
      status
    }
    eventId
    event {
      id
      name
      start
      locationDisplayFull
      mediaUrl
      community {
        name
        code
        globalInviteCode
        iconUrl
      }
    }
  }
}
    `;
export const useGuestListInviteQuery = <
      TData = GuestListInviteQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GuestListInviteQueryVariables,
      options?: UseQueryOptions<GuestListInviteQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GuestListInviteQuery, TError, TData>(
      ['GuestListInvite', variables],
      fetcher<GuestListInviteQuery, GuestListInviteQueryVariables>(client, GuestListInviteDocument, variables, headers),
      options
    );
export const useInfiniteGuestListInviteQuery = <
      TData = GuestListInviteQuery,
      TError = unknown
    >(
      pageParamKey: keyof GuestListInviteQueryVariables,
      client: GraphQLClient,
      variables: GuestListInviteQueryVariables,
      options?: UseInfiniteQueryOptions<GuestListInviteQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<GuestListInviteQuery, TError, TData>(
      ['GuestListInvite.infinite', variables],
      (metaData) => fetcher<GuestListInviteQuery, GuestListInviteQueryVariables>(client, GuestListInviteDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const ClaimGuestListInviteDocument = `
    mutation ClaimGuestListInvite($code: String!) {
  claimGuestListInvite(code: $code)
}
    `;
export const useClaimGuestListInviteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ClaimGuestListInviteMutation, TError, ClaimGuestListInviteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ClaimGuestListInviteMutation, TError, ClaimGuestListInviteMutationVariables, TContext>(
      ['ClaimGuestListInvite'],
      (variables?: ClaimGuestListInviteMutationVariables) => fetcher<ClaimGuestListInviteMutation, ClaimGuestListInviteMutationVariables>(client, ClaimGuestListInviteDocument, variables, headers)(),
      options
    );
export const AddGuestListInviteDocument = `
    mutation AddGuestListInvite($code: String!, $name: String!, $phone: String!) {
  addGuestListInvite(code: $code, name: $name, phone: $phone)
}
    `;
export const useAddGuestListInviteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddGuestListInviteMutation, TError, AddGuestListInviteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddGuestListInviteMutation, TError, AddGuestListInviteMutationVariables, TContext>(
      ['AddGuestListInvite'],
      (variables?: AddGuestListInviteMutationVariables) => fetcher<AddGuestListInviteMutation, AddGuestListInviteMutationVariables>(client, AddGuestListInviteDocument, variables, headers)(),
      options
    );
export const RemoveGuestListInviteDocument = `
    mutation RemoveGuestListInvite($code: String!, $phone: String!) {
  removeGuestListInvite(code: $code, phone: $phone)
}
    `;
export const useRemoveGuestListInviteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveGuestListInviteMutation, TError, RemoveGuestListInviteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveGuestListInviteMutation, TError, RemoveGuestListInviteMutationVariables, TContext>(
      ['RemoveGuestListInvite'],
      (variables?: RemoveGuestListInviteMutationVariables) => fetcher<RemoveGuestListInviteMutation, RemoveGuestListInviteMutationVariables>(client, RemoveGuestListInviteDocument, variables, headers)(),
      options
    );
export const MarkGuestListInviteAsOpenedDocument = `
    mutation MarkGuestListInviteAsOpened($code: String!) {
  updateGuestListInviteStatus(code: $code, status: Opened)
}
    `;
export const useMarkGuestListInviteAsOpenedMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MarkGuestListInviteAsOpenedMutation, TError, MarkGuestListInviteAsOpenedMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MarkGuestListInviteAsOpenedMutation, TError, MarkGuestListInviteAsOpenedMutationVariables, TContext>(
      ['MarkGuestListInviteAsOpened'],
      (variables?: MarkGuestListInviteAsOpenedMutationVariables) => fetcher<MarkGuestListInviteAsOpenedMutation, MarkGuestListInviteAsOpenedMutationVariables>(client, MarkGuestListInviteAsOpenedDocument, variables, headers)(),
      options
    );
export const CreateMediaDocument = `
    mutation CreateMedia($filename: String, $mimeType: String!, $subpath: String!) {
  createMedia(filename: $filename, mimeType: $mimeType, subpath: $subpath) {
    publicUrl
    uploadURL
  }
}
    `;
export const useCreateMediaMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateMediaMutation, TError, CreateMediaMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateMediaMutation, TError, CreateMediaMutationVariables, TContext>(
      ['CreateMedia'],
      (variables?: CreateMediaMutationVariables) => fetcher<CreateMediaMutation, CreateMediaMutationVariables>(client, CreateMediaDocument, variables, headers)(),
      options
    );
export const CreateShareDocument = `
    mutation CreateShare($communityCode: String!, $module: Module!) {
  createShare(communityCode: $communityCode, module: $module)
}
    `;
export const useCreateShareMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateShareMutation, TError, CreateShareMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateShareMutation, TError, CreateShareMutationVariables, TContext>(
      ['CreateShare'],
      (variables?: CreateShareMutationVariables) => fetcher<CreateShareMutation, CreateShareMutationVariables>(client, CreateShareDocument, variables, headers)(),
      options
    );
export const ShopDocument = `
    query Shop($accessCode: String, $communityId: ID!, $skip: Int!, $take: Int!) {
  shopV2(
    accessCode: $accessCode
    communityId: $communityId
    skip: $skip
    take: $take
  ) {
    next
    total
    items {
      ...baseProduct
    }
  }
}
    ${BaseProductFragmentDoc}`;
export const useShopQuery = <
      TData = ShopQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ShopQueryVariables,
      options?: UseQueryOptions<ShopQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ShopQuery, TError, TData>(
      ['Shop', variables],
      fetcher<ShopQuery, ShopQueryVariables>(client, ShopDocument, variables, headers),
      options
    );
export const useInfiniteShopQuery = <
      TData = ShopQuery,
      TError = unknown
    >(
      pageParamKey: keyof ShopQueryVariables,
      client: GraphQLClient,
      variables: ShopQueryVariables,
      options?: UseInfiniteQueryOptions<ShopQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ShopQuery, TError, TData>(
      ['Shop.infinite', variables],
      (metaData) => fetcher<ShopQuery, ShopQueryVariables>(client, ShopDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const ShopV3Document = `
    query ShopV3($accessCode: String, $communityId: ID!, $selectedProductType: SelectedProductType!) {
  shopV3(
    accessCode: $accessCode
    communityId: $communityId
    selectedProductType: $selectedProductType
  ) {
    availableProductTypes
    eventsWithProducts {
      id
      name
      start
      end
      locationDisplayCompact
      buyTicketsLink
      products {
        ...baseProduct
      }
    }
    nonTicketProducts {
      ...baseProduct
    }
  }
}
    ${BaseProductFragmentDoc}`;
export const useShopV3Query = <
      TData = ShopV3Query,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ShopV3QueryVariables,
      options?: UseQueryOptions<ShopV3Query, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ShopV3Query, TError, TData>(
      ['ShopV3', variables],
      fetcher<ShopV3Query, ShopV3QueryVariables>(client, ShopV3Document, variables, headers),
      options
    );
export const useInfiniteShopV3Query = <
      TData = ShopV3Query,
      TError = unknown
    >(
      pageParamKey: keyof ShopV3QueryVariables,
      client: GraphQLClient,
      variables: ShopV3QueryVariables,
      options?: UseInfiniteQueryOptions<ShopV3Query, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ShopV3Query, TError, TData>(
      ['ShopV3.infinite', variables],
      (metaData) => fetcher<ShopV3Query, ShopV3QueryVariables>(client, ShopV3Document, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const ProductDocument = `
    query Product($productId: ID!) {
  product(productId: $productId) {
    ...baseProduct
  }
}
    ${BaseProductFragmentDoc}`;
export const useProductQuery = <
      TData = ProductQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ProductQueryVariables,
      options?: UseQueryOptions<ProductQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProductQuery, TError, TData>(
      ['Product', variables],
      fetcher<ProductQuery, ProductQueryVariables>(client, ProductDocument, variables, headers),
      options
    );
export const useInfiniteProductQuery = <
      TData = ProductQuery,
      TError = unknown
    >(
      pageParamKey: keyof ProductQueryVariables,
      client: GraphQLClient,
      variables: ProductQueryVariables,
      options?: UseInfiniteQueryOptions<ProductQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<ProductQuery, TError, TData>(
      ['Product.infinite', variables],
      (metaData) => fetcher<ProductQuery, ProductQueryVariables>(client, ProductDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const UserDocument = `
    query user($id: String!) {
  user(where: {id: $id}) {
    ...baseUser
    communitiesWhereMember {
      ...baseCommunity
    }
  }
}
    ${BaseUserFragmentDoc}
${BaseCommunityFragmentDoc}`;
export const useUserQuery = <
      TData = UserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UserQueryVariables,
      options?: UseQueryOptions<UserQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<UserQuery, TError, TData>(
      ['user', variables],
      fetcher<UserQuery, UserQueryVariables>(client, UserDocument, variables, headers),
      options
    );
export const useInfiniteUserQuery = <
      TData = UserQuery,
      TError = unknown
    >(
      pageParamKey: keyof UserQueryVariables,
      client: GraphQLClient,
      variables: UserQueryVariables,
      options?: UseInfiniteQueryOptions<UserQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useInfiniteQuery<UserQuery, TError, TData>(
      ['user.infinite', variables],
      (metaData) => fetcher<UserQuery, UserQueryVariables>(client, UserDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      options
    );

export const PostCreateUserUpdateDocument = `
    mutation postCreateUserUpdate($username: String!, $password: String!) {
  postCreateUserUpdate(username: $username, password: $password) {
    ...baseUser
  }
}
    ${BaseUserFragmentDoc}`;
export const usePostCreateUserUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PostCreateUserUpdateMutation, TError, PostCreateUserUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PostCreateUserUpdateMutation, TError, PostCreateUserUpdateMutationVariables, TContext>(
      ['postCreateUserUpdate'],
      (variables?: PostCreateUserUpdateMutationVariables) => fetcher<PostCreateUserUpdateMutation, PostCreateUserUpdateMutationVariables>(client, PostCreateUserUpdateDocument, variables, headers)(),
      options
    );
export const UserUpdateDocument = `
    mutation userUpdate($firstName: String!, $lastName: String!, $birthday: String, $password: String, $username: String, $email: String!, $phone: String) {
  userUpdate(
    firstName: $firstName
    lastName: $lastName
    username: $username
    password: $password
    birthday: $birthday
    email: $email
    phone: $phone
  ) {
    ...baseUser
  }
}
    ${BaseUserFragmentDoc}`;
export const useUserUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UserUpdateMutation, TError, UserUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UserUpdateMutation, TError, UserUpdateMutationVariables, TContext>(
      ['userUpdate'],
      (variables?: UserUpdateMutationVariables) => fetcher<UserUpdateMutation, UserUpdateMutationVariables>(client, UserUpdateDocument, variables, headers)(),
      options
    );
export const UserUpdateV2Document = `
    mutation userUpdateV2($data: UserUpdateV2Input!) {
  userUpdateV2(data: $data) {
    ...baseUser
  }
}
    ${BaseUserFragmentDoc}`;
export const useUserUpdateV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UserUpdateV2Mutation, TError, UserUpdateV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UserUpdateV2Mutation, TError, UserUpdateV2MutationVariables, TContext>(
      ['userUpdateV2'],
      (variables?: UserUpdateV2MutationVariables) => fetcher<UserUpdateV2Mutation, UserUpdateV2MutationVariables>(client, UserUpdateV2Document, variables, headers)(),
      options
    );
export const JoinCommunityWaitlistDocument = `
    mutation JoinCommunityWaitlist($communityCode: String!) {
  joinCommunityWaitlist(communityCode: $communityCode) {
    success
    alreadyOnWaitlist
  }
}
    `;
export const useJoinCommunityWaitlistMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<JoinCommunityWaitlistMutation, TError, JoinCommunityWaitlistMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<JoinCommunityWaitlistMutation, TError, JoinCommunityWaitlistMutationVariables, TContext>(
      ['JoinCommunityWaitlist'],
      (variables?: JoinCommunityWaitlistMutationVariables) => fetcher<JoinCommunityWaitlistMutation, JoinCommunityWaitlistMutationVariables>(client, JoinCommunityWaitlistDocument, variables, headers)(),
      options
    );